
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("lVF98", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $bUlM5 = parcelRequire("bUlM5");


var $ecnYn = parcelRequire("ecnYn");


var $6f0Oj = parcelRequire("6f0Oj");


var $6cnUO = parcelRequire("6cnUO");

var $5izcQ = parcelRequire("5izcQ");

var $2Fndw = parcelRequire("2Fndw");


var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");


var $1qfLF = parcelRequire("1qfLF");


var $ghftu = parcelRequire("ghftu");


var $2AytZ = parcelRequire("2AytZ");


var $3gadb = parcelRequire("3gadb");


var $1iSzD = parcelRequire("1iSzD");


var $iV5Ic = parcelRequire("iV5Ic");


var $8unJx = parcelRequire("8unJx");


var $hR4U4 = parcelRequire("hR4U4");


var $JTIzG = parcelRequire("JTIzG");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $hU34N = parcelRequire("hU34N");


var $iIQbF = parcelRequire("iIQbF");


var $3jwuS = parcelRequire("3jwuS");


var $9wGTI = parcelRequire("9wGTI");


var $D7PHQ = parcelRequire("D7PHQ");


var $kM55L = parcelRequire("kM55L");


var $6mKj3 = parcelRequire("6mKj3");


var $efvKr = parcelRequire("efvKr");


var $aWwYt = parcelRequire("aWwYt");


var $eNjW4 = parcelRequire("eNjW4");


var $jmjWc = parcelRequire("jmjWc");


var $e4o8D = parcelRequire("e4o8D");


var $kvJHJ = parcelRequire("kvJHJ");


var $8uM2K = parcelRequire("8uM2K");


var $bj5fB = parcelRequire("bj5fB");


var $dppWL = parcelRequire("dppWL");


var $3tUdX = parcelRequire("3tUdX");





var $4acD6 = parcelRequire("4acD6");


var $9QtOT = parcelRequire("9QtOT");


var $1v2bD = parcelRequire("1v2bD");


var $imNHQ = parcelRequire("imNHQ");








var $3Am3T = parcelRequire("3Am3T");


var $kEiOB = parcelRequire("kEiOB");


var $amW67 = parcelRequire("amW67");

/**
 * @generated SignedSource<<b4310f301c256ea95275f5723888b05a>>
 * @relayHash dea9c3cbfe29b9c92cdeb224b8f076c7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3535a366980d7daaf35b172ee45b177da449ae9442b6943bdb0c465be89ae8b7
const $e82e32b99e59f54f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentContributors",
            "kind": "LinkedField",
            "name": "contentContributors",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isCurrentUserContributor"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useNudgeContributorFilterQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useNudgeContributorFilterQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "dea9c3cbfe29b9c92cdeb224b8f076c7",
            "id": "3535a366980d7daaf35b172ee45b177da449ae9442b6943bdb0c465be89ae8b7",
            "metadata": {},
            "name": "useNudgeContributorFilterQuery",
            "operationKind": "query",
            "text": "query useNudgeContributorFilterQuery($contentId:ID!){contentContributors(id:$contentId){isCurrentUserContributor}}"
        }
    };
}();
$e82e32b99e59f54f$var$node.hash = "427fb0db9de3e615035eab567b67ccf0";
var $e82e32b99e59f54f$export$2e2bcd8739ae039 = $e82e32b99e59f54f$var$node;






var $jMyy4 = parcelRequire("jMyy4");

const $fc07d009da21f8b9$var$useNudgeContributorFilterQuery = (0, $e82e32b99e59f54f$export$2e2bcd8739ae039);
function $fc07d009da21f8b9$export$cb9bdc967aae1b21(contentId, skip) {
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($fc07d009da21f8b9$var$useNudgeContributorFilterQuery, {
        variables: {
            contentId: contentId
        },
        skip: !contentId || skip,
        __callerPackage__: "@confluence/page-rovo-config-common"
    });
    const isCurrentUserContributor = data?.contentContributors?.isCurrentUserContributor ?? false;
    return (0, $42omo.useMemo)(()=>({
            isCurrentUserContributor: isCurrentUserContributor,
            loading: loading
        }), [
        isCurrentUserContributor,
        loading
    ]);
}


/**
 * @generated SignedSource<<7aa3d54126f9597e716056a7eefea026>>
 * @relayHash a0dc0a296d152cfbd6c0ca2a59e55c8b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 80126f44d9591dcee6cb6f9d63eb77d74968d56d29dd33c4a3e52973ee97507e
const $d9c45cee0d598413$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentType"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentType",
                    "variableName": "contentType"
                }
            ],
            "concreteType": "CatchupLastViewedTimeResponse",
            "kind": "LinkedField",
            "name": "catchupGetLastViewedTime",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "lastViewedTimeISO"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useNudgeFirstVisitFilterQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useNudgeFirstVisitFilterQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "a0dc0a296d152cfbd6c0ca2a59e55c8b",
            "id": "80126f44d9591dcee6cb6f9d63eb77d74968d56d29dd33c4a3e52973ee97507e",
            "metadata": {},
            "name": "useNudgeFirstVisitFilterQuery",
            "operationKind": "query",
            "text": "query useNudgeFirstVisitFilterQuery($contentId:ID!,$contentType:CatchupContentType!){catchupGetLastViewedTime(contentId:$contentId,contentType:$contentType){lastViewedTimeISO}}"
        }
    };
}();
$d9c45cee0d598413$var$node.hash = "1e734053e31505b911fcc40be543fe6e";
var $d9c45cee0d598413$export$2e2bcd8739ae039 = $d9c45cee0d598413$var$node;








const $4a8709f90f4edadd$var$useNudgeFirstVisitFilterQuery = (0, $d9c45cee0d598413$export$2e2bcd8739ae039);
function $4a8709f90f4edadd$export$628206ea1fe1b0f7(lastViewedTimeISO) {
    if (!lastViewedTimeISO) return true;
    // Strip timezone bracket suffixes (e.g. "[America/New_York]") that cause NaN on Date.parse
    const cleaned = lastViewedTimeISO.replace(/\[.*?\]$/, '');
    return !cleaned || Number.isNaN(Date.parse(cleaned));
}
function $4a8709f90f4edadd$export$2e8f1aa0f8ab1526(contentId, skip) {
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($4a8709f90f4edadd$var$useNudgeFirstVisitFilterQuery, {
        variables: {
            contentId: contentId,
            contentType: 'PAGE'
        },
        skip: !contentId || skip,
        __callerPackage__: "@confluence/page-rovo-config-common"
    });
    const lastViewedTimeISO = data?.catchupGetLastViewedTime?.lastViewedTimeISO ?? '';
    const isFirstVisit = $4a8709f90f4edadd$export$628206ea1fe1b0f7(lastViewedTimeISO);
    return (0, $42omo.useMemo)(()=>({
            isFirstVisit: isFirstVisit,
            loading: loading
        }), [
        isFirstVisit,
        loading
    ]);
}






var $2bR8c = parcelRequire("2bR8c");


var $gXKuh = parcelRequire("gXKuh");

function $97654e51bdd5d39b$export$5985165b88d806e9() {
    const sidebarApi = (0, $2bR8c.useCreateRovoExperienceSidebarController)();
    const handleAgentMentionSaved = (0, $42omo.useCallback)((event)=>{
        const detail = event.detail;
        if (!detail) return;
        sidebarApi.openSidebar();
    }, [
        sidebarApi
    ]);
    (0, $42omo.useEffect)(()=>{
        window.addEventListener((0, $gXKuh.AGENT_MENTION_COMMENT_SAVED_EVENT), handleAgentMentionSaved);
        return ()=>{
            window.removeEventListener((0, $gXKuh.AGENT_MENTION_COMMENT_SAVED_EVENT), handleAgentMentionSaved);
        };
    }, [
        handleAgentMentionSaved
    ]);
}















var $bQm3c = parcelRequire("bQm3c");


var $h2uld = parcelRequire("h2uld");

const $e4cd8876e4f83d2e$export$b68936138edb7d6e = (contentType, contentId)=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { readTime: readTime, loading: readTimeLoading } = (0, $h2uld.useReadTime)(contentId, !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT);
    const readTimeMinutes = readTimeLoading ? null : Number(readTime);
    const minReadTimeMinutes = (0, $9wGTI.fg)('rovo_button_proactive_nudge_min_read_time_increase') ? 1.0 : 0.5;
    /**
   * Base eligibility checks (page-level, shared across all nudges):
   * 1. Rovo Button must be enabled
   * 2. Content type must be 'page' (TODO: extend to 'blogpost' when backend 500s are fixed)
   * 3. Page must not be in edit mode
   * 4. Read time query must be completed
   * 5. Read time must exceed the minimum threshold (1 min with gate on, 30s with gate off)
   */ const isBaseEligible = isRovoButtonEnabled && contentType === 'page' && pageMode !== (0, $cD1qu.PageMode).EDIT && readTimeMinutes !== null && readTimeMinutes > minReadTimeMinutes;
    return {
        isBaseEligible: isBaseEligible,
        readTimeMinutes: readTimeMinutes
    };
};


















var $dWpd3 = parcelRequire("dWpd3");











var $g5jMy = parcelRequire("g5jMy");


var $i25hX = parcelRequire("i25hX");


var $6Htct = parcelRequire("6Htct");

const $b985b864a3dfeb42$export$560e3a8567843c82 = 'daily-brief-nudge';
const $b985b864a3dfeb42$export$98808fd4b2dc119e = 300000;
const $b985b864a3dfeb42$var$messages = (0, $aXWIB.defineMessages)({
    dailyBriefNudgeTitle: {
        id: "page-rovo-config-common.daily-brief-nudge-title",
        defaultMessage: "Review your daily brief"
    },
    dailyBriefNudgeSubtitle: {
        id: "page-rovo-config-common.daily-brief-nudge-subtitle",
        defaultMessage: "See today's highlights at a glance"
    },
    dailyBriefNudgeIconLabel: {
        id: "page-rovo-config-common.daily-brief-nudge-icon-label",
        defaultMessage: "Daily brief"
    }
});
function $b985b864a3dfeb42$export$9c69eb1d10bb0a06(conversationId) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const publish = (0, $i25hX.usePublish)('ai-mate');
    const onClick = (0, $42omo.useCallback)(()=>{
        if (conversationId) publish({
            type: 'chat-open',
            data: {
                channelId: conversationId
            },
            openChatMode: 'mini-modal',
            source: 'daily-brief-nudge'
        });
    }, [
        conversationId,
        publish
    ]);
    return (0, $42omo.useMemo)(()=>({
            id: $b985b864a3dfeb42$export$560e3a8567843c82,
            title: formatMessage($b985b864a3dfeb42$var$messages.dailyBriefNudgeTitle),
            secondaryTitle: formatMessage($b985b864a3dfeb42$var$messages.dailyBriefNudgeSubtitle),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5jMy))), {
                    size: "small",
                    label: formatMessage($b985b864a3dfeb42$var$messages.dailyBriefNudgeIconLabel)
                }),
            onClick: onClick,
            type: 'ai-action',
            handleType: (0, $6Htct.HandleActionType).Base,
            nudgeContext: {
                id: $b985b864a3dfeb42$export$560e3a8567843c82,
                selfEligible: true,
                suppressionKey: conversationId ?? undefined
            }
        }), [
        onClick,
        formatMessage,
        conversationId
    ]);
}









var $AL4QS = parcelRequire("AL4QS");


var $5gEqE = parcelRequire("5gEqE");





var $1AJi3 = parcelRequire("1AJi3");

const $c3e3eb1b5def3766$var$messages = (0, $aXWIB.defineMessages)({
    insightsNudgeTitle: {
        id: "page-rovo-config-common.insights-nudge-title.v2",
        defaultMessage: "Explore your Rovo insights"
    },
    insightsNudgeIconLabel: {
        id: "page-rovo-config-common.insights-nudge-icon-label",
        defaultMessage: "Insights icon"
    },
    insightsNudgeSecondaryTitle: {
        id: "page-rovo-config-common.insights-nudge-secondary-title",
        defaultMessage: "See this week's highlights at a glance"
    }
});
function $c3e3eb1b5def3766$export$efd7aeb42217b406() {
    const { setActiveMenu: setActiveMenu } = (0, $5gEqE.useUIStore)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { mode: mode, toggleConversationAssistant: toggleConversationAssistant } = (0, $1AJi3.useToggleConversationAssistant)();
    const onClick = (0, $42omo.useCallback)(()=>{
        if (!mode) toggleConversationAssistant();
        setActiveMenu('pulse');
    }, [
        mode,
        toggleConversationAssistant,
        setActiveMenu
    ]);
    return (0, $42omo.useMemo)(()=>({
            id: 'rovo-insights-nudge',
            title: formatMessage($c3e3eb1b5def3766$var$messages.insightsNudgeTitle),
            secondaryTitle: formatMessage($c3e3eb1b5def3766$var$messages.insightsNudgeSecondaryTitle),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($AL4QS))), {
                    size: "small",
                    label: formatMessage($c3e3eb1b5def3766$var$messages.insightsNudgeIconLabel)
                }),
            onClick: onClick,
            type: 'ai-action',
            handleType: (0, $6Htct.HandleActionType).Base,
            nudgeContext: {
                id: 'rovo-insights'
            }
        }), [
        onClick,
        formatMessage
    ]);
}









var $7MEbC = parcelRequire("7MEbC");


var $ccRXO = parcelRequire("ccRXO");




const $c07f2db40a5a574b$var$CONVO_STARTER_NUDGE_ID = 'convo-starter';
/**
 * Checks whether the user has consented to Functional storage.
 * The convo starter nudge uses sessionStorage for suppression, which requires
 * Functional cookie consent per Atlassian policy.
 * Returns null while pending, true if granted, false if denied.
 */ function $c07f2db40a5a574b$var$useCanShowConvoStarterNudge() {
    const [hasFunctionalConsent, setHasFunctionalConsent] = (0, $42omo.useState)(null);
    (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('rovo_button_convostarter_nudge_cookie_policy_check')) {
            setHasFunctionalConsent(true);
            return;
        }
        (0, $7MEbC.getPreferences)().then((preferences)=>{
            setHasFunctionalConsent(Boolean(preferences?.[(0, $ccRXO.PreferenceCategory).Functional]));
        }).catch(()=>{
            setHasFunctionalConsent(false);
        });
    }, []);
    return hasFunctionalConsent;
}
function $c07f2db40a5a574b$export$26385239543be8d2() {
    const hasFunctionalConsent = $c07f2db40a5a574b$var$useCanShowConvoStarterNudge();
    return (0, $42omo.useMemo)(()=>{
        if (!(0, $9wGTI.fg)('aix_convo_starter_nudge_enabled')) return null;
        if (hasFunctionalConsent !== true) return null;
        return {
            id: $c07f2db40a5a574b$var$CONVO_STARTER_NUDGE_ID,
            title: '',
            type: 'convo-starter-action',
            handleType: (0, $6Htct.HandleActionType).Chat,
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null),
            staticPrompt: '',
            starterType: 'static'
        };
    }, [
        hasFunctionalConsent
    ]);
}









var $inPa6 = parcelRequire("inPa6");

/**
 * Centralized i18n message descriptors for the FOMO nudge.
 *
 * Both products consume defineMessages output via formatMessage:
 *   - Confluence: `react-intl`
 *   - Jira: `@atlassian/jira-intl`
 *
 * Keeping copy here ensures parity across products. Phase 1 is an empty
 * placeholder so the file exists without pulling in `react-intl` yet.
 */ 


const $3f8965cb0e7ea657$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    fomoNudgeTitle: {
        id: "rovo-fomo-nudge.title",
        defaultMessage: "Your teammates are chatting with Rovo"
    },
    fomoNudgeDescription: {
        id: "rovo-fomo-nudge.description",
        defaultMessage: "Try chat today to get quick answers and draft work fast."
    },
    fomoNudgeIconLabel: {
        id: "rovo-fomo-nudge.icon-label",
        defaultMessage: "Avatars of your collaborators using Rovo"
    }
});


/**
 * Pure factory that returns a fully-formed ConversationAction object for the
 * FOMO ("teammates using Rovo") nudge.
 *
 * Why a factory (not a hook) at this layer?
 *   - Confluence consumes nudges as objects inside a `NudgeEntry[]`
 *     (declarative, via `useViewPageNudgeConfig`).
 *   - Jira consumes nudges by calling
 *     `updateConfiguration({ nudges: [...] })` imperatively
 *     (via `useAiRovoCurrentRouteConfigurationStoreActions`).
 *   Both surfaces can call a pure builder; only the surrounding glue differs.
 *
 * Eligibility (experiment treatment, non-Rovo-MAU TAP trait, "show once"
 * guard, launch-date scheduling via Statsig) lives in the product hooks /
 * Statsig config. This builder assumes "we've decided to show the nudge".
 */ 





/**
 * Public identifiers + content for the FOMO ("teammates using Rovo") nudge.
 *
 * Source of truth: FOMO Nudge doc (Confluence page 7094179434).
 * Consumed by both the Confluence hook (page-rovo-config-common) and the Jira
 * sibling provider (ai-rovo/actions-route-provider).
 *
 * NOTE: Statsig gate / experiment identifiers are intentionally NOT exported
 * from this package. Both `fg()` (Confluence) and `expVal()` (Jira) require
 * string literals for static analysis — consuming a variable breaks the
 * tooling. Each product uses the strings inline:
 *   gate:       'rovo_button_collab_teammates_fomo_nudge_enabled'
 *   experiment: 'rovo_button_collab_teammates_fomo_nudge' / 'isEnabled'
 */ /** Stable id used for analytics, store de-duping, and nudgeContext matching. */ const $1709d6600d9fd48f$export$2f71d683d556ec71 = 'rovo-collab-teammates-fomo-nudge';
const $1709d6600d9fd48f$export$1362ba0e5605958a = 'Based on my work, give me 3 ways Rovo can help me this week.';
const $1709d6600d9fd48f$export$774fe05d25c075a9 = 'rovo-collab-teammates-fomo-nudge:dismissed';


/* FomoNudgeContent.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * Custom nudge content for the FOMO ("teammates using Rovo") nudge.
 *
 * Rendered via the `customContent` slot on the ConversationAction — this
 * replaces the standard icon+title layout inside the nudge pill while keeping
 * the outer pill container, dismiss button, animation, and analytics intact.
 *
 * Layout:
 *   title [👤👤👤]
 *   description (always visible)
 *
 * Both title and description are always visible (no hover required).
 */ 






var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");

/**
 * Avatar-stack icon rendered inline as the FOMO nudge's leading visual.
 *
 * Per the FOMO Nudge doc § "Custom Rovo Nudge UI":
 *   - shows up to 3 collaborator avatars who are Rovo Chat MAU
 *   - When collaborators is empty (Phase 2/3) or avatarUrl is null, AvatarGroup
 *     renders the default generic user avatar automatically (ADS fallback).
 *   - Phase 4: real collaborators supplied via TWG / AGG
 */ 



var $2Pg7f = parcelRequire("2Pg7f");

/** Shown when no real collaborator data is available yet (Phase 2 / Phase 3). */ const $8960a4d94a0dfc27$var$PLACEHOLDER_AVATARS = [
    {
        name: ''
    },
    {
        name: ''
    },
    {
        name: ''
    }
];
function $8960a4d94a0dfc27$export$66e4706d4e7dd953({ collaborators: collaborators }) {
    const data = collaborators.length > 0 ? collaborators.map((c)=>({
            name: c.displayName ?? '',
            src: c.avatarUrl ?? undefined
        })) : $8960a4d94a0dfc27$var$PLACEHOLDER_AVATARS;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Pg7f.default), {
        size: "small",
        maxCount: 3,
        data: data
    });
}


const $dc7f8a88f1232df5$var$styles = {
    wrapper: "_y3gn1e5h _ca0q1b66 _n3td12x7 _19bvu2gc _u5f3utpp _80omtlke"
};
function $dc7f8a88f1232df5$export$876f92013f22097a({ collaborators: collaborators, title: title, description: description }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $dc7f8a88f1232df5$var$styles.wrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.inverse"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8960a4d94a0dfc27$export$66e4706d4e7dd953), {
        collaborators: collaborators
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "small",
        color: "color.text.inverse"
    }, description)));
}



function $10529594d7451c96$export$b3c17769b94f96dc(ctx) {
    return {
        id: (0, $1709d6600d9fd48f$export$2f71d683d556ec71),
        title: ctx.title,
        description: ctx.description,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8960a4d94a0dfc27$export$66e4706d4e7dd953), {
                collaborators: ctx.collaborators
            }),
        handleType: (0, $6Htct.HandleActionType).Chat,
        type: 'convo-starter-action',
        staticPrompt: (0, $1709d6600d9fd48f$export$1362ba0e5605958a),
        starterType: 'static',
        secondaryTitle: ctx.description,
        customContent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dc7f8a88f1232df5$export$876f92013f22097a), {
                collaborators: ctx.collaborators,
                title: ctx.title,
                description: ctx.description
            }),
        // ChatAction.onClick is intentionally omitted: triggerAction early-returns
        // when onClick is defined, preventing HandleActionType.Chat from opening chat.
        // Side-effects (storage, analytics, …) flow through ctx.onAccept (click-through)
        // and ctx.onDismiss (X button), each invoked by main.tsx after triggerAction.
        // Kept separate so consumers can fire distinct analytics events per outcome;
        // pass the same function to both to collapse behavior.
        nudgeContext: {
            id: (0, $1709d6600d9fd48f$export$2f71d683d556ec71),
            selfEligible: true,
            onAccept: ctx.onAccept,
            onDismiss: ctx.onDismiss
        }
    };
}






var $irOoi = parcelRequire("irOoi");

/**
 * @generated SignedSource<<f84adf570fb691b6495d19f38b7c4902>>
 * @relayHash 0ad556ff820d35bb17d0e31ce5d0b047
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a1d19e41603d4aaa8be4d60bdde37b87fbf00da84f06435309642e8e6c5710aa
const $74be300194dee94d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountIds"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "accountIds"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "picture"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "fetchUsersByAaidsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "fetchUsersByAaidsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a1d19e41603d4aaa8be4d60bdde37b87fbf00da84f06435309642e8e6c5710aa",
            "metadata": {},
            "name": "fetchUsersByAaidsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$74be300194dee94d$var$node.hash = "8a3ac08d21378d56d25c36c21e4e0285";
var $74be300194dee94d$export$2e2bcd8739ae039 = $74be300194dee94d$var$node;





async function $008b4943a6a1fee5$export$eec092fef118af9(environment, aaids) {
    if (aaids.length === 0) return {
        collaborators: [],
        error: null
    };
    try {
        const data = await (0, $irOoi.fetchQuery)(environment, (0, $74be300194dee94d$export$2e2bcd8739ae039), {
            accountIds: aaids
        }).toPromise();
        const users = data?.users ?? [];
        const byAaid = new Map();
        for (const u of users)// Skip records missing name or picture — we can't render an avatar without both.
        if (u?.accountId && u.name && u.picture) byAaid.set(u.accountId, {
            accountId: u.accountId,
            displayName: u.name,
            avatarUrl: u.picture
        });
        // Preserve input order.
        const collaborators = aaids.map((a)=>byAaid.get(a)).filter((c)=>!!c);
        return {
            collaborators: collaborators,
            error: null
        };
    } catch (error) {
        return {
            collaborators: [],
            error: error
        };
    }
}


const $dd60741ad0e804e7$var$MAX_AAIDS = 3;
function $dd60741ad0e804e7$export$21f6c38d03063951(aaids, { enabled: enabled = true } = {}) {
    const environment = (0, $irOoi.useRelayEnvironment)();
    const capped = aaids.slice(0, $dd60741ad0e804e7$var$MAX_AAIDS);
    const isNoop = !enabled || capped.length === 0;
    const key = isNoop ? '__noop__' : JSON.stringify(capped);
    const [state, setState] = (0, $42omo.useState)({
        collaborators: [],
        error: null,
        key: isNoop ? key : null
    });
    (0, $42omo.useEffect)(()=>{
        if (isNoop) {
            setState({
                collaborators: [],
                error: null,
                key: key
            });
            return;
        }
        let cancelled = false;
        (0, $008b4943a6a1fee5$export$eec092fef118af9)(environment, capped).then(({ collaborators: collaborators, error: error })=>{
            if (cancelled) return;
            setState({
                collaborators: collaborators,
                error: error,
                key: key
            });
        });
        return ()=>{
            cancelled = true;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        key,
        isNoop,
        environment
    ]);
    const loaded = state.key === key;
    return {
        collaborators: loaded ? state.collaborators : [],
        isReady: loaded,
        error: loaded ? state.error : null
    };
}






var $dh538 = parcelRequire("dh538");






async function $8bb4aa0824d43956$export$54ea2450140fa4c6() {
    try {
        const prefs = await (0, $7MEbC.getPreferences)();
        return Boolean(prefs?.[(0, $ccRXO.PreferenceCategory).Functional]);
    } catch  {
        return false;
    }
}


function $16043a9e8d35dbcc$export$f2c87e8746c4282b({ enabled: enabled = true } = {}) {
    const cookieConsentEnforced = enabled ? (0, $dh538.fg)('rovo_fomo_nudge_cookie_policy_check') : false;
    // When the gate is off, short-circuit: legacy behavior, always allow.
    const [canShow, setCanShow] = (0, $42omo.useState)(enabled ? cookieConsentEnforced ? null : true : false);
    (0, $42omo.useEffect)(()=>{
        if (!enabled) {
            setCanShow(false);
            return;
        }
        if (!cookieConsentEnforced) {
            setCanShow(true);
            return;
        }
        let isMounted = true;
        setCanShow(null);
        (0, $8bb4aa0824d43956$export$54ea2450140fa4c6)().then((result)=>{
            if (isMounted) setCanShow(result);
        });
        return ()=>{
            isMounted = false;
        };
    }, [
        enabled,
        cookieConsentEnforced
    ]);
    return canShow;
}









var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $7c4rV = parcelRequire("7c4rV");

const $c0593064e6d92683$export$c440923610fb5736 = 'rovo_chat_top_collaborators_all_users';
const $c0593064e6d92683$export$e90c6f262048878a = 'is_rovo_chat_mau';
const $c0593064e6d92683$var$MAX_AAIDS = 3;
function $c0593064e6d92683$export$c25450ce4b2df968({ enabled: enabled }) {
    const { data: data, loading: loading, error: error } = (0, $7c4rV.useAtlassianAccountTraits)({
        skipBootstrap: !enabled
    });
    if (!enabled) return {
        aaids: [],
        isReady: true,
        loaded: false,
        isRovoChatMau: null
    };
    if (loading) return {
        aaids: [],
        isReady: false,
        loaded: false,
        isRovoChatMau: null
    };
    if (error) return {
        aaids: [],
        isReady: true,
        loaded: false,
        isRovoChatMau: null
    };
    if (data == null) return {
        aaids: [],
        isReady: false,
        loaded: false,
        isRovoChatMau: null
    };
    const traitValue = data?.attributes?.find((attr)=>attr.name === $c0593064e6d92683$export$c440923610fb5736)?.value ?? '';
    // `value` is typed as `string` by the trait resource, but in practice Site
    // User Traits can deliver booleans/numbers (or `null`) for this attribute
    // depending on the upstream pipeline. Coerce defensively so a non-string
    // shape cannot crash the hook (and therefore the entire page tree above it).
    const rawMauValue = data?.attributes?.find((attr)=>attr.name === $c0593064e6d92683$export$e90c6f262048878a)?.value;
    const isRovoChatMau = rawMauValue != null && String(rawMauValue).toLowerCase() === 'true';
    const aaids = [];
    const atlassianIds = traitValue.split(',').slice(0, $c0593064e6d92683$var$MAX_AAIDS);
    atlassianIds.forEach((atlassianId)=>{
        const trimmed = atlassianId.trim();
        if (trimmed) aaids.push(trimmed);
    });
    return {
        aaids: aaids,
        isReady: true,
        loaded: true,
        isRovoChatMau: isRovoChatMau
    };
}


/** How long to suppress the FOMO nudge after the user clicks or dismisses it (2 weeks). */ const $5b287a4ca991cbd7$var$FOMO_NUDGE_SUPPRESSION_DURATION_MS = 1209600000;
/**
 * Confluence localStorage-backed FomoNudgeStorage adapter.
 *
 * Reads/writes via StorageManager (AtlBrowserStorage-aware) so the key is
 * subject to the atlassian-cookies consent registry when
 * confluence_browser_storage_controls is on.
 */ const $5b287a4ca991cbd7$var$confluenceFomoNudgeStorage = {
    hasBeenShown () {
        const dismissedAt = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).FOMO_NUDGE_DISMISSED);
        return !!dismissedAt && Date.now() - Number(dismissedAt) < $5b287a4ca991cbd7$var$FOMO_NUDGE_SUPPRESSION_DURATION_MS;
    },
    markShown () {
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).FOMO_NUDGE_DISMISSED, Date.now());
    }
};
function $5b287a4ca991cbd7$export$c77cd3167eb72a41({ enabled: enabled = true } = {}) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    // Cookie consent check — the hook reads the `rovo_fomo_nudge_cookie_policy_check`
    // killswitch internally. When the killswitch is on, the nudge only shows for
    // users who have consented to Functional storage. When the killswitch is off,
    // canShowFromCookiePreference is `true` immediately (legacy behavior, no network/storage check).
    // Runs before any TAP / Relay fetch so non-consenting users incur no extra
    // network requests.
    const canShowFromCookiePreference = (0, $16043a9e8d35dbcc$export$f2c87e8746c4282b)({
        enabled: enabled && (0, $9wGTI.fg)('rovo_button_collab_teammates_fomo_nudge_enabled')
    });
    const canShowFomoNudge = enabled && canShowFromCookiePreference === true && (0, $9wGTI.fg)('rovo_button_collab_teammates_fomo_nudge_enabled');
    // Read suppression once per render. Synchronous localStorage read via the
    // adapter; cost is sub-microsecond. Used to short-circuit the trait + Relay
    // fetches below so users inside the 14-day suppression window incur no
    // network requests.
    const suppressed = canShowFomoNudge ? $5b287a4ca991cbd7$var$confluenceFomoNudgeStorage.hasBeenShown() : false;
    // Trait fetch is NOT gated on `expVal` — we need `isRovoChatMau` before
    // the experiment can be exposed.
    const { aaids: aaids, isReady: traitReady, loaded: traitRan, isRovoChatMau: isRovoChatMau } = (0, $c0593064e6d92683$export$c25450ce4b2df968)({
        enabled: canShowFomoNudge && !suppressed
    });
    // First `expVal` call site — only reached after `isRovoChatMau === false`.
    const { collaborators: collaborators, isReady: collaboratorsReady, error: collaboratorError } = (0, $dd60741ad0e804e7$export$21f6c38d03063951)(aaids, {
        enabled: canShowFomoNudge && !suppressed && traitReady && isRovoChatMau === false && aaids.length > 0 && (0, $6mKj3.expVal)('rovo_button_collab_teammates_fomo_nudge', 'isEnabled', false)
    });
    const hasReportedRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (!enabled || !(0, $9wGTI.fg)('rovo_button_collab_teammates_fomo_nudge_enabled')) return;
        if (!traitReady || !traitRan) return;
        if (isRovoChatMau !== false) return;
        if (aaids.length > 0 && !collaboratorsReady) return;
        if (!(0, $6mKj3.expVal)('rovo_button_collab_teammates_fomo_nudge', 'isEnabled', false)) return;
        if (hasReportedRef.current) return;
        hasReportedRef.current = true;
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'fomoNudge',
                action: 'traitResolved',
                actionSubject: 'fomoNudge',
                attributes: {
                    traitName: (0, $c0593064e6d92683$export$c440923610fb5736),
                    aaidCount: aaids.length
                }
            }
        }).fire();
        const zeroResolved = aaids.length > 0 && collaborators.length === 0;
        if (collaboratorError || zeroResolved) {
            let errorMessage;
            if (collaboratorError instanceof Error) errorMessage = collaboratorError.message;
            else if (collaboratorError) errorMessage = String(collaboratorError);
            else errorMessage = 'no collaborators resolved';
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'fomoNudge',
                    action: 'failed',
                    actionSubject: 'collaboratorResolution',
                    attributes: {
                        operation: 'fetchUsersByAaids',
                        requestedAaidCount: aaids.length,
                        errorMessage: errorMessage
                    }
                }
            }).fire();
            if (collaboratorError) (0, $5ZqQS.getMonitoringClient)().submitError(collaboratorError instanceof Error ? collaboratorError : new Error(String(collaboratorError)), {
                attribution: (0, $3IBnw.Attribution).AI_MATE
            });
        }
    }, [
        enabled,
        traitReady,
        traitRan,
        collaboratorsReady,
        isRovoChatMau,
        aaids,
        collaborators,
        collaboratorError,
        createAnalyticsEvent
    ]);
    return (0, $42omo.useMemo)(()=>{
        // Killswitch — also checks is_rovo_chat_mau
        if (!enabled || !(0, $9wGTI.fg)('rovo_button_collab_teammates_fomo_nudge_enabled')) return null;
        // Cookie consent check — when the killswitch is on, only proceed if
        // the user has granted Functional storage consent. When the killswitch
        // is off, canShowFromCookiePreference is `true` immediately (no-op).
        // canShowFromCookiePreference === null → check is still pending; canShowFromCookiePreference === false → denied.
        if (canShowFromCookiePreference !== true) return null;
        // Check storage — if the nudge was dismissed within the suppression
        // window, bail before re-exposing the experiment (TREX-1585 requirement 4).
        if (suppressed) return null;
        // `traitReady` + MAU check MUST stay above the `expVal` call so
        // non-eligible users are never exposed to the experiment.
        if (!traitReady) return null;
        if (isRovoChatMau !== false) return null;
        if (!(0, $6mKj3.expVal)('rovo_button_collab_teammates_fomo_nudge', 'isEnabled', false)) return null;
        // No eligible collaborators — hide the nudge.
        if (collaborators.length === 0) return null;
        // Wait for avatar/name resolution to complete — avoid flashing placeholder
        // avatars before the real data lands.
        if (!collaboratorsReady) return null;
        return (0, $10529594d7451c96$export$b3c17769b94f96dc)({
            collaborators: collaborators,
            title: formatMessage((0, $3f8965cb0e7ea657$export$defe85febe8b728c).fomoNudgeTitle),
            description: formatMessage((0, $3f8965cb0e7ea657$export$defe85febe8b728c).fomoNudgeDescription),
            onAccept: ()=>$5b287a4ca991cbd7$var$confluenceFomoNudgeStorage.markShown(),
            onDismiss: ()=>$5b287a4ca991cbd7$var$confluenceFomoNudgeStorage.markShown()
        });
    }, [
        enabled,
        canShowFromCookiePreference,
        suppressed,
        traitReady,
        isRovoChatMau,
        collaboratorsReady,
        collaborators,
        formatMessage
    ]);
}


const $fa24c3761347e030$export$5d0421d6a355c531 = (entry)=>'action' in entry;


/** Minimum read time (in minutes) required for the convo starter nudge. */ const $8bdd9ea855fe08b8$var$CONVO_STARTER_MIN_READ_TIME_MINUTES = 2;
function $8bdd9ea855fe08b8$export$730669e74cd8a0c9(isBaseEligible, readTimeMinutes, isCurrentUserContributor, isFirstVisit, dailyBriefStatus) {
    const viewPageRovoActions = (0, $kEiOB.useViewPageRovoActions)();
    const dailyBriefNudgeAction = (0, $b985b864a3dfeb42$export$9c69eb1d10bb0a06)(dailyBriefStatus?.conversationId ?? null);
    const insightsNudgeAction = (0, $c3e3eb1b5def3766$export$efd7aeb42217b406)();
    const convoStartersNudgeAction = (0, $c07f2db40a5a574b$export$26385239543be8d2)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const fomoNudgeAction = (0, $5b287a4ca991cbd7$export$c77cd3167eb72a41)({
        enabled: pageMode !== (0, $cD1qu.PageMode).LIVE || !(0, $6mKj3.expVal)('rovo_button_fomo_live_doc_perf_guard', 'isEnabled', false)
    });
    const { eligibleForChangeboarding: eligibleForChangeboarding } = (0, $dWpd3.useAudioButtonWrapperStore)();
    const actionsById = (0, $42omo.useMemo)(()=>new Map(viewPageRovoActions.map((registeredAction)=>[
                registeredAction.actionId,
                registeredAction.action
            ])), [
        viewPageRovoActions
    ]);
    return (0, $42omo.useMemo)(()=>{
        if (!isBaseEligible) return [];
        const nudgeEntries = [
            {
                actionId: 'page-catchup',
                enabled: true
            },
            {
                actionId: 'audio-briefing',
                enabled: !eligibleForChangeboarding
            },
            {
                action: dailyBriefNudgeAction,
                enabled: !!dailyBriefStatus?.conversationId && !!dailyBriefStatus?.completedAt && Date.now() - new Date(dailyBriefStatus.completedAt).getTime() < (0, $b985b864a3dfeb42$export$98808fd4b2dc119e) && (0, $9wGTI.fg)('rovo_button_daily_brief_nudge')
            },
            // Insights nudge — 1 min read time threshold covered by isBaseEligible
            {
                action: insightsNudgeAction,
                enabled: (0, $6mKj3.expVal)('rovo_growth_chat_pulse', 'isEnabled', false)
            },
            // Convo starter nudge — requires higher read time than the base threshold
            // Excluded for contributors and first-time visitors
            {
                action: convoStartersNudgeAction,
                enabled: !isCurrentUserContributor && !isFirstVisit && readTimeMinutes !== null && readTimeMinutes > $8bdd9ea855fe08b8$var$CONVO_STARTER_MIN_READ_TIME_MINUTES && (0, $9wGTI.fg)('aix_convo_starter_nudge_enabled')
            },
            // FOMO nudge — experiment + non-MAU trait + "show once" + launch-date
            // scheduling via Statsig live inside useFomoNudgeAction; the killswitch
            // gate is repeated here explicitly to align with the pattern used by
            // other nudges (dailyBriefNudge uses fg, insightsNudge uses expVal, etc.).
            {
                action: fomoNudgeAction,
                enabled: (0, $9wGTI.fg)('rovo_button_collab_teammates_fomo_nudge_enabled')
            },
            // Action items nudge — eligibility gated in useViewPageRovoActions
            {
                actionId: 'action-items-nudge',
                enabled: true
            }
        ];
        return nudgeEntries.reduce((acc, nudgeEntry)=>{
            if (!nudgeEntry.enabled) return acc;
            const action = (0, $fa24c3761347e030$export$5d0421d6a355c531)(nudgeEntry) ? nudgeEntry.action : actionsById.get(nudgeEntry.actionId);
            if (action) acc.push(action);
            return acc;
        }, []);
    }, [
        isBaseEligible,
        readTimeMinutes,
        eligibleForChangeboarding,
        isCurrentUserContributor,
        isFirstVisit,
        dailyBriefStatus,
        dailyBriefNudgeAction,
        insightsNudgeAction,
        convoStartersNudgeAction,
        fomoNudgeAction,
        actionsById
    ]);
}


const $2b7ed8ae830eb95a$var$AgentMentionSidebarListener = ()=>{
    (0, $97654e51bdd5d39b$export$5985165b88d806e9)();
    return null;
};
const $2b7ed8ae830eb95a$var$ViewPageConfigProviderInner = ({ setConfiguration: setConfiguration })=>{
    // Temporary: opens Rovo mini-modal for Founding Admins landing after onboarding.
    // Remove when experiment twcg-1387-rovo-in-onboarding-chat is cleaned up.
    const onboardingConfig = (0, $imNHQ.useOnboardingEntryPointPublish)();
    const { contentType: contentType, contentId: contentId } = (0, $amW67.useRovoConfigProviderProps)();
    const viewPageRovoActions = (0, $kEiOB.useViewPageRovoActions)();
    const { isBaseEligible: isBaseEligible, readTimeMinutes: readTimeMinutes } = (0, $e4cd8876e4f83d2e$export$b68936138edb7d6e)(contentType, contentId);
    const { isCurrentUserContributor: isCurrentUserContributor } = (0, $fc07d009da21f8b9$export$cb9bdc967aae1b21)(contentId, !isBaseEligible || !(0, $9wGTI.fg)('aix_convo_starter_nudge_enabled'));
    const { isFirstVisit: isFirstVisit } = (0, $4a8709f90f4edadd$export$2e8f1aa0f8ab1526)(contentId, !isBaseEligible || !(0, $9wGTI.fg)('aix_convo_starter_nudge_enabled'));
    const dailyBriefStatus = (0, $9QtOT.useDailyBriefUnread)();
    const nudges = (0, $8bdd9ea855fe08b8$export$730669e74cd8a0c9)(isBaseEligible, readTimeMinutes, isCurrentUserContributor, isFirstVisit, dailyBriefStatus);
    const { setNudges: setNudges } = (0, $4acD6.useAISmartButtonActions)();
    const rovoConfiguration = (0, $42omo.useMemo)(()=>{
        const baseConfig = {
            getActions: async ()=>{
                const actions = viewPageRovoActions.map((action)=>action.action);
                return Promise.resolve(actions);
            }
        };
        return (0, $1v2bD.applyOnboardingRovoConfig)(baseConfig, onboardingConfig);
    }, [
        viewPageRovoActions,
        onboardingConfig
    ]);
    (0, $42omo.useEffect)(()=>{
        setConfiguration(rovoConfiguration);
        setNudges(nudges);
    }, [
        rovoConfiguration,
        setConfiguration,
        nudges,
        setNudges
    ]);
    return (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2b7ed8ae830eb95a$var$AgentMentionSidebarListener, null) : null;
};
const $2b7ed8ae830eb95a$export$299010de885adda = (props)=>{
    const { contentId: contentId } = (0, $amW67.useRovoConfigProviderProps)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Am3T.CommentCountsProvider), {
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2b7ed8ae830eb95a$var$ViewPageConfigProviderInner, props));
};









var $e2ZTm = parcelRequire("e2ZTm");










var $la9AC = parcelRequire("la9AC");

























var $4wwVl = parcelRequire("4wwVl");







const $8732973ed376fa07$var$messages = (0, $aXWIB.defineMessages)({
    agentMentionNudgeTitle: {
        id: "page-rovo-config-common.agent-mention-nudge-title",
        defaultMessage: "Start chatting with agent"
    },
    agentMentionNudgeTitleWithAgentName: {
        id: "page-rovo-config-common.agent-mention-nudge-title-with-agent-name.ai-non-final",
        defaultMessage: "Start chatting with {agentName}"
    },
    agentMentionNudgeIconLabel: {
        id: "page-rovo-config-common.agent-mention-nudge-icon-label",
        defaultMessage: "Agent icon"
    },
    agentMentionNudgeSecondaryTitle: {
        id: "page-rovo-config-common.agent-mention-nudge-secondary-title",
        defaultMessage: "Start a conversation using this agent"
    }
});
const $8732973ed376fa07$export$d8e8e9b085d2396e = 'agent-mention-nudge';
const $8732973ed376fa07$export$969a8c78a138b693 = 'taskItem';
/** Defined outside the hook so React keeps the same DOM node across re-renders. */ const $8732973ed376fa07$var$AgentMentionIcon = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4wwVl))), {
        size: "small",
        label: label
    });
function $8732973ed376fa07$export$3e06c63ab8775ee2(agentId, agentMentionContext, agentMentionParentNodeType, agentMentionInsertionCount, agentMentionName) {
    const resolvedAgentId = agentId ?? null;
    const resolvedPrompt = agentMentionContext ?? '';
    const resolvedAgentMentionName = agentMentionName?.trim() || null;
    const isTaskItem = agentMentionParentNodeType === $8732973ed376fa07$export$969a8c78a138b693;
    const nudgeId = agentMentionInsertionCount && agentMentionInsertionCount > 0 ? `${$8732973ed376fa07$export$d8e8e9b085d2396e}-${agentMentionInsertionCount}` : $8732973ed376fa07$export$d8e8e9b085d2396e;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const publish = (0, $i25hX.usePublish)('ai-mate');
    // Keep a ref to the latest prompt so onClick doesn't need it as a dep.
    // agentMentionContext changes on every keystroke; without this, onClick would
    // recreate on each keystroke → cascading memo invalidations → setNudges on every keystroke.
    const resolvedPromptRef = (0, $42omo.useRef)(resolvedPrompt);
    resolvedPromptRef.current = resolvedPrompt;
    // Keep a ref to the latest agentId so onClick doesn't capture a stale null.
    // agentId resolves asynchronously; without this, the callback created before
    // resolution would permanently close over null.
    const resolvedAgentIdRef = (0, $42omo.useRef)(resolvedAgentId);
    resolvedAgentIdRef.current = resolvedAgentId;
    const iconLabel = formatMessage($8732973ed376fa07$var$messages.agentMentionNudgeIconLabel);
    // Stable as long as agent identity and node type don't change.
    const onClick = (0, $42omo.useCallback)(()=>{
        publish({
            type: 'chat-new',
            source: 'agentMentionEditorNudge',
            openChatMode: 'mini-modal',
            data: {
                prompt: resolvedPromptRef.current ?? '',
                // Task items auto-send; other blocks pre-fill as a draft.
                ...isTaskItem ? {} : {
                    overrideAutoSend: true
                },
                dialogues: [],
                mode: {
                    useCurrentPageContext: true
                },
                ...resolvedAgentIdRef.current ? {
                    agentId: resolvedAgentIdRef.current
                } : {}
            }
        });
    }, [
        publish,
        isTaskItem
    ]);
    return (0, $42omo.useMemo)(()=>{
        const title = resolvedAgentMentionName ? formatMessage($8732973ed376fa07$var$messages.agentMentionNudgeTitleWithAgentName, {
            agentName: resolvedAgentMentionName
        }) : formatMessage($8732973ed376fa07$var$messages.agentMentionNudgeTitle);
        return {
            id: nudgeId,
            title: title,
            secondaryTitle: formatMessage($8732973ed376fa07$var$messages.agentMentionNudgeSecondaryTitle),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8732973ed376fa07$var$AgentMentionIcon, {
                    label: iconLabel
                }),
            onClick: onClick,
            type: 'ai-action',
            handleType: (0, $6Htct.HandleActionType).Base,
            nudgeContext: {
                id: $8732973ed376fa07$export$d8e8e9b085d2396e,
                selfEligible: true,
                experimentName: 'platform_editor_agent_mentions'
            }
        };
    }, [
        formatMessage,
        iconLabel,
        nudgeId,
        onClick,
        resolvedAgentMentionName
    ]);
}


























const $23e0c73c9feee0cc$export$5569745b4d0a5343 = (contentType)=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const isLiveDoc = pageMode === (0, $cD1qu.PageMode).LIVE;
    /**
	 * Filters to prevent high request volume checking for nudge recommendations on live docs
	 * 1. Feature gate 'confluence_rovo_live_doc_nudges' must be enabled
	 * 2. Page must be a live doc
	 * 3. Rovo Button must be enabled
	 * 4. Content type must be 'page'
	 */ return isLiveDoc && isRovoButtonEnabled && contentType === 'page' && isAdminHubAIEnabled && (0, $9wGTI.fg)('confluence_rovo_live_doc_nudges');
};










const $1dc1702d58bb7989$var$AUDIO_BRIEFING_MIN_READ_TIME_MINUTES = 5;
function $1dc1702d58bb7989$export$60835107d4b45e85(enableLiveDocNudges, eligibleForChangeboarding, isFirstVisit, isCurrentUserContributor, isEligibilityLoading, readTimeMinutes, /** controls nudge *presence* (truthy = show the nudge). */ agentMentionId, /** control nudge *payload* (forwarded to useAgentMentionNudgeAction). */ resolvedAgentMentionId, /** control nudge *payload* (forwarded to useAgentMentionNudgeAction). */ agentMentionContext, /** control nudge *payload* (forwarded to useAgentMentionNudgeAction). */ agentMentionParentNodeType, /** controls the nudge action id so each inserted mention is treated as a new nudge. */ agentMentionInsertionCount, /** control nudge title (forwarded to useAgentMentionNudgeAction). */ agentMentionName) {
    const viewPageRovoActions = (0, $kEiOB.useViewPageRovoActions)();
    const agentMentionNudgeAction = (0, $8732973ed376fa07$export$3e06c63ab8775ee2)(resolvedAgentMentionId, agentMentionContext, agentMentionParentNodeType, agentMentionInsertionCount, agentMentionName);
    const actionsById = (0, $42omo.useMemo)(()=>new Map(viewPageRovoActions.map((registeredAction)=>[
                registeredAction.actionId,
                registeredAction.action
            ])), [
        viewPageRovoActions
    ]);
    return (0, $42omo.useMemo)(()=>{
        const alwaysOnNudges = agentMentionId ? [
            agentMentionNudgeAction
        ] : [];
        if (!enableLiveDocNudges) return alwaysOnNudges;
        const isAudioBriefingEligible = !isEligibilityLoading && !eligibleForChangeboarding && isFirstVisit && !isCurrentUserContributor && readTimeMinutes !== null && readTimeMinutes >= $1dc1702d58bb7989$var$AUDIO_BRIEFING_MIN_READ_TIME_MINUTES;
        const nudgeEntries = [
            {
                actionId: 'audio-briefing',
                enabled: isAudioBriefingEligible
            }
        ];
        const liveDocNudges = nudgeEntries.reduce((acc, nudgeEntry)=>{
            if (!nudgeEntry.enabled) return acc;
            const action = (0, $fa24c3761347e030$export$5d0421d6a355c531)(nudgeEntry) ? nudgeEntry.action : actionsById.get(nudgeEntry.actionId);
            if (action) acc.push(action);
            return acc;
        }, []);
        return [
            ...alwaysOnNudges,
            ...liveDocNudges
        ];
    }, [
        agentMentionId,
        // resolvedAgentMentionId/agentMentionContext/agentMentionParentNodeType/agentMentionName
        // omitted: payload only, not presence. agentMentionNudgeAction already invalidates on
        // those values.
        agentMentionNudgeAction,
        enableLiveDocNudges,
        isEligibilityLoading,
        eligibleForChangeboarding,
        isFirstVisit,
        isCurrentUserContributor,
        readTimeMinutes,
        actionsById
    ]);
}



var $02cx8 = parcelRequire("02cx8");

/* getEmptyPageCreationActions.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $1s5hv = parcelRequire("1s5hv");


var $boRaI = parcelRequire("boRaI");




const $efb362169c233167$export$4b8c4c333cdd165d = [
    'create-product-requirements-document',
    'create-customer-onboarding-strategy',
    'create-background-research-plan'
]; /* istanbul ignore next */ 
const $efb362169c233167$var$styles = {
    iconContainer: "_1yt412x7"
};
const $efb362169c233167$export$4e5c71902381581b = (promptCards)=>{
    const promptCardsById = new Map(promptCards.map((card)=>[
            card.id,
            card
        ]));
    return $efb362169c233167$export$4b8c4c333cdd165d.reduce((actions, targetId)=>{
        const card = promptCardsById.get(targetId);
        if (card) actions.push({
            handleType: (0, $6Htct.HandleActionType).Chat,
            id: card.id,
            title: card.title,
            dynamicPrompt: card.prompt,
            icon: ()=>{
                const Icon = (0, $boRaI.getUseCaseIcon)(card.useCase);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
                    alignItems: "center",
                    justifyContent: "center",
                    xcss: $efb362169c233167$var$styles.iconContainer
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, null));
            }
        });
        return actions;
    }, []);
};


var $9c464318090b4e27$exports = {};
$9c464318090b4e27$exports = new URL("empty-page-greeting-icon.9a2c7bfb.svg", import.meta.url).toString();


const $7e583ad86f1e8aa8$var$messages = (0, $aXWIB.defineMessages)({
    emptyPageGreetingTitle: {
        id: "edit-page-rovo-config-provider.empty-page-greeting-title",
        defaultMessage: "Start your doc with a prompt"
    },
    copiedPageGreetingTitle: {
        id: "edit-page-rovo-config-provider.copied-page-greeting-title",
        defaultMessage: "Need help editing your copied page?"
    },
    suggestEditsMenuItemLabel: {
        id: "edit-page-rovo-config-provider.menu.item.label.suggest-edits",
        defaultMessage: "Review with suggestions"
    },
    suggestEditsMenuItemPrompt: {
        id: "edit-page-rovo-config-provider.menu.item.prompt.suggest-edits",
        defaultMessage: "Review my content with the /suggest-edits skill"
    }
});
const $7e583ad86f1e8aa8$var$EditPageConfigProviderInner = ({ setConfiguration: setConfiguration })=>{
    // Temporary: opens Rovo mini-modal for Founding Admins landing after onboarding.
    // Remove when experiment twcg-1387-rovo-in-onboarding-chat is cleaned up.
    const onboardingConfig = (0, $imNHQ.useOnboardingEntryPointPublish)();
    const viewPageRovoActions = (0, $kEiOB.useViewPageRovoActions)();
    const editorActions = (0, $02cx8.useEditorRovoButtonActionsActions)();
    const editorActionsContext = (0, $02cx8.useEditorRovoButtonActionsContext)();
    const rovoConfigProviderProps = (0, $amW67.useRovoConfigProviderProps)();
    const isEditorEmpty = (0, $dppWL.isPageRovoConfigProviderProps)(rovoConfigProviderProps) && rovoConfigProviderProps.isEditorEmpty;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { promptCards: promptCards } = (0, $la9AC.usePromptCards)();
    const isEmptyPageWithPromptCards = isEditorEmpty && Array.isArray(promptCards);
    const pageProps = (0, $dppWL.isPageRovoConfigProviderProps)(rovoConfigProviderProps) ? rovoConfigProviderProps : null;
    const contentType = pageProps?.contentType ?? '';
    const contentId = pageProps?.contentId ?? '';
    const readTimeMinutes = pageProps?.readTime ?? null;
    const readTimeLoading = pageProps?.readTimeLoading ?? false;
    const suggestEditsActionIcon = (0, $42omo.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e2ZTm))), {
            label: ""
        }), []);
    const enableLiveDocNudges = (0, $23e0c73c9feee0cc$export$5569745b4d0a5343)(contentType);
    const { eligibleForChangeboarding: eligibleForChangeboarding } = (0, $dWpd3.useAudioButtonWrapperStore)();
    const { isFirstVisit: isFirstVisit, loading: isFirstVisitLoading } = (0, $4a8709f90f4edadd$export$2e8f1aa0f8ab1526)(contentId, !enableLiveDocNudges);
    const { isCurrentUserContributor: isCurrentUserContributor, loading: isContributorLoading } = (0, $fc07d009da21f8b9$export$cb9bdc967aae1b21)(contentId, !enableLiveDocNudges);
    const isEligibilityLoading = isFirstVisitLoading || isContributorLoading || readTimeLoading;
    const agentMentionId = (0, $02cx8.useEditorRovoButtonAgentMentionId)();
    const agentMentionInsertionCount = (0, $02cx8.useEditorRovoButtonAgentMentionInsertionCount)();
    const resolvedAgentMentionId = (0, $02cx8.useEditorRovoButtonResolvedAgentMentionId)();
    const agentMentionContext = (0, $02cx8.useEditorRovoButtonAgentMentionContext)();
    const agentMentionName = (0, $02cx8.useEditorRovoButtonAgentMentionName)();
    const agentMentionParentNodeType = (0, $02cx8.useEditorRovoButtonAgentMentionParentNodeType)();
    const isTaskItemMention = agentMentionParentNodeType === (0, $8732973ed376fa07$export$969a8c78a138b693);
    const nudges = (0, $1dc1702d58bb7989$export$60835107d4b45e85)(enableLiveDocNudges, eligibleForChangeboarding, isFirstVisit, isCurrentUserContributor, isEligibilityLoading, readTimeMinutes, // Task items use auto-fire instead; expValEquals last ensures exposure is tracked.
    !isTaskItemMention && (0, $6mKj3.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true) ? agentMentionId : null, resolvedAgentMentionId, agentMentionContext, agentMentionParentNodeType, agentMentionInsertionCount, agentMentionName);
    const { setNudges: setNudges } = (0, $4acD6.useAISmartButtonActions)();
    const publish = (0, $i25hX.usePublish)('ai-mate');
    // Keep a ref so the auto-fire effect can read the latest agentMentionContext without
    // it being a reactive dependency. Adding agentMentionContext to the dep array would
    // cause the effect to re-fire on every keystroke in the task item (since textContent
    // updates on each character) without agentMentionInsertionCount changing.
    const agentMentionContextRef = (0, $42omo.useRef)(agentMentionContext);
    agentMentionContextRef.current = agentMentionContext;
    // Auto-fire Rovo chat when an agent is @mentioned inside a task item.
    // Task item mentions are action-oriented, so open the chat immediately with
    // the agent pre-selected and the task text as the context prompt.
    // Gated behind the platform_editor_agent_mentions experiment.
    (0, $42omo.useEffect)(()=>{
        if (!isTaskItemMention || !resolvedAgentMentionId || !agentMentionInsertionCount || !(0, $6mKj3.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true)) return;
        publish({
            type: 'chat-new',
            source: 'agentMentionTaskItemAutoFire',
            openChatMode: 'mini-modal',
            data: {
                prompt: agentMentionContextRef.current ?? undefined,
                isPromptPlaceholder: false,
                dialogues: [],
                mode: {
                    useCurrentPageContext: true
                },
                agentId: resolvedAgentMentionId
            }
        });
    }, [
        agentMentionInsertionCount,
        resolvedAgentMentionId,
        isTaskItemMention,
        // agentMentionContext intentionally omitted — read via ref above to avoid
        // re-firing on every keystroke after the mention is inserted.
        publish
    ]);
    const config = (0, $42omo.useMemo)(()=>{
        const getCustomGreeting = ()=>{
            if (isEmptyPageWithPromptCards) return {
                iconSrc: (0, (/*@__PURE__*/$parcel$interopDefault($9c464318090b4e27$exports))),
                title: formatMessage($7e583ad86f1e8aa8$var$messages.emptyPageGreetingTitle)
            };
            if ((0, $6mKj3.expValEquals)('cc_fd_copy_with_rovo', 'cohort', 'rovoChat')) return {
                title: formatMessage($7e583ad86f1e8aa8$var$messages.copiedPageGreetingTitle)
            };
            return undefined;
        };
        const customGreeting = getCustomGreeting();
        const suggestEditsAction = {
            id: 'suggest-edits-ai-action',
            title: formatMessage($7e583ad86f1e8aa8$var$messages.suggestEditsMenuItemLabel),
            icon: suggestEditsActionIcon,
            handleType: (0, $6Htct.HandleActionType).Skill,
            type: 'skill-action',
            staticPrompt: formatMessage($7e583ad86f1e8aa8$var$messages.suggestEditsMenuItemPrompt)
        };
        /** Optionally inject suggest-edits skill action */ const combinedEditorActions = (0, $6mKj3.expValEquals)('platform_editor_ai_content_suggested_edits', 'isEnabled', true) ? [
            suggestEditsAction,
            ...editorActions
        ] : editorActions;
        const baseConfig = {
            getActions: async ()=>{
                if (isEmptyPageWithPromptCards) return Promise.resolve((0, $efb362169c233167$export$4e5c71902381581b)(promptCards));
                if (editorActionsContext?.reference) return Promise.resolve(combinedEditorActions);
                // Find create-new-content action
                const createNewContentAction = viewPageRovoActions.find((action)=>action.actionId === 'create-new-content');
                // If create-new-content action exists, reposition it to 4th item, last visible before show more
                if (createNewContentAction) {
                    // Filter out create-new-content from view page actions
                    // Small bounded array (typically <10 actions), no risk of quadratic performance issues.
                    // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
                    const viewPageActionsWithoutCreate = viewPageRovoActions.filter((action)=>action.actionId !== 'create-new-content').map((action)=>action.action);
                    const combinedActions = [
                        ...combinedEditorActions,
                        ...viewPageActionsWithoutCreate
                    ];
                    // Insert create-new-content at position index 3 (4th position), or at the end if there are less than 3 actions
                    const insertIndex = Math.min(3, combinedActions.length);
                    combinedActions.splice(insertIndex, 0, createNewContentAction.action);
                    return Promise.resolve(combinedActions);
                }
                // Fallback: no create-new-content action, use original behavior
                const viewPageActions = viewPageRovoActions.map((action)=>action.action);
                return Promise.resolve([
                    ...combinedEditorActions,
                    ...viewPageActions
                ]);
            },
            customGreeting: customGreeting,
            shouldShowGreeting: customGreeting !== undefined || undefined,
            prioritizeCustomActionResults: isEmptyPageWithPromptCards ? true : undefined
        };
        return (0, $1v2bD.applyOnboardingRovoConfig)(baseConfig, onboardingConfig);
    }, [
        editorActions,
        editorActionsContext,
        viewPageRovoActions,
        isEmptyPageWithPromptCards,
        promptCards,
        formatMessage,
        suggestEditsActionIcon,
        onboardingConfig
    ]);
    (0, $42omo.useEffect)(()=>{
        setConfiguration(config);
        setNudges(nudges);
    }, [
        config,
        setConfiguration,
        nudges,
        setNudges
    ]);
    return null;
};
const $7e583ad86f1e8aa8$export$d95c465cd9bfae9f = (props)=>{
    const { contentId: contentId } = (0, $amW67.useRovoConfigProviderProps)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Am3T.CommentCountsProvider), {
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7e583ad86f1e8aa8$var$EditPageConfigProviderInner, props));
};
























var $gIaMn = parcelRequire("gIaMn");




var $5Abqh = parcelRequire("5Abqh");


const $8a4bdd953279ff48$export$75b705e7e413826a = (0, $jmjWc.LoadableActivatable)({
    __loadable_id__: "h5GrM",
    name: "AudioButtonLoaderActivatable",
    loader: async ()=>(await (parcelRequire("cMOU8"))).AudioButton,
    triggers: [
        {
            type: (0, $gIaMn.ActivationTriggerType).HOVER
        }
    ],
    ssrSuccessCheckName: (0, $5Abqh.SSR_PARTIAL_COMPONENT).AudioButton
});

const $8a4bdd953279ff48$export$2cf028d3aae3c5f9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "IJrya",
    name: "AudioButtonLoaderAfterPaint",
    loader: async ()=>(await (parcelRequire("cMOU8"))).AudioButton
});


const $46bbba5af56c1c8e$export$6210e0bba7c89213 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(8);
    const { isView: isView, contentId: contentId, contentType: contentType, spaceKey: spaceKey, contentTitle: contentTitle, isDisabled: isDisabled } = props;
    if (isView && (0, $6mKj3.expVal)("confluence_selective_hydration_audio_button", "isEnabled", false)) {
        let t0;
        if ($[0] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($46bbba5af56c1c8e$var$AudioButtonSelectiveHydrationWrapper, props);
            $[0] = props;
            $[1] = t0;
        } else t0 = $[1];
        return t0;
    }
    let t0;
    if ($[2] !== contentId || $[3] !== contentTitle || $[4] !== contentType || $[5] !== isDisabled || $[6] !== spaceKey) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8a4bdd953279ff48$export$2cf028d3aae3c5f9), {
            contentId: contentId,
            contentType: contentType,
            spaceKey: spaceKey,
            contentTitle: contentTitle,
            isDisabled: isDisabled
        });
        $[2] = contentId;
        $[3] = contentTitle;
        $[4] = contentType;
        $[5] = isDisabled;
        $[6] = spaceKey;
        $[7] = t0;
    } else t0 = $[7];
    return t0;
} : (props)=>{
    const { isView: isView, contentId: contentId, contentType: contentType, spaceKey: spaceKey, contentTitle: contentTitle, isDisabled: isDisabled } = props;
    if (isView && (0, $6mKj3.expVal)('confluence_selective_hydration_audio_button', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($46bbba5af56c1c8e$var$AudioButtonSelectiveHydrationWrapper, props);
    // functionality is unchanged, AudioButton is only wrapped in a Loadable
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8a4bdd953279ff48$export$2cf028d3aae3c5f9), {
        contentId: contentId,
        contentType: contentType,
        spaceKey: spaceKey,
        contentTitle: contentTitle,
        isDisabled: isDisabled
    });
};
/**
 * Internal component used only when selective hydration is enabled.
 * Contains all SH-specific logic (browser support, keyboard focus unlock).
 *
 * JS for AudioButton is delayed until user hovers (currently for View Page and Space Overviews)
 * Cases for immediate unlock (bypassing selective hydration) include:
 *
 * Disabled browser (Firefox)
 * User activation via keyboard (tab)
 *
 */ const $46bbba5af56c1c8e$var$AudioButtonSelectiveHydrationWrapper = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(18);
    const { contentId: contentId, contentType: contentType, spaceKey: spaceKey, contentTitle: contentTitle, isDisabled: isDisabled } = t0;
    const wrapperRef = (0, $42omo.useRef)(null);
    const [audioSupportedByBrowser, setAudioSupportedByBrowser] = (0, $42omo.useState)(true);
    const [isFocusActivated, setIsFocusActivated] = (0, $42omo.useState)(false);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            const isAudioSupportedByBrowser = typeof MediaSource !== "undefined" && MediaSource.isTypeSupported("audio/mpeg");
            if (!isAudioSupportedByBrowser) (0, $42omo.startTransition)(()=>{
                setAudioSupportedByBrowser(false);
            });
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const wrapper = wrapperRef.current;
            if (!wrapper) return;
            const handleFocus = (event)=>{
                const target = event.target;
                if (!target || !target.matches("button, [role=\"button\"]")) return;
                const isKeyboardFocus = target.matches(":focus-visible");
                if (!isKeyboardFocus) return;
                (0, $42omo.startTransition)(()=>{
                    setIsFocusActivated(true);
                });
            };
            wrapper.addEventListener("focus", handleFocus, true);
            return ()=>{
                wrapper.removeEventListener("focus", handleFocus, true);
            };
        };
        t4 = [];
        $[2] = t3;
        $[3] = t4;
    } else {
        t3 = $[2];
        t4 = $[3];
    }
    (0, $42omo.useEffect)(t3, t4);
    const immediateActivationCondition = audioSupportedByBrowser === false || isFocusActivated;
    let t5;
    if ($[4] !== audioSupportedByBrowser || $[5] !== isDisabled || $[6] !== renderServerPlaceholder) {
        t5 = isDisabled && (0, $6mKj3.expVal)("platform_editor_offline_editing_web", "isEnabled", false) || !renderServerPlaceholder && !audioSupportedByBrowser;
        $[4] = audioSupportedByBrowser;
        $[5] = isDisabled;
        $[6] = renderServerPlaceholder;
        $[7] = t5;
    } else t5 = $[7];
    const isButtonDisabled = t5;
    const t6 = audioSupportedByBrowser ?? true;
    let t7;
    if ($[8] !== t6) {
        t7 = {
            audioSupportedByBrowserFromWrapper: t6
        };
        $[8] = t6;
        $[9] = t7;
    } else t7 = $[9];
    const wrapperProps = t7;
    let t8;
    if ($[10] !== contentId || $[11] !== contentTitle || $[12] !== contentType || $[13] !== immediateActivationCondition || $[14] !== isButtonDisabled || $[15] !== spaceKey || $[16] !== wrapperProps) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: wrapperRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8a4bdd953279ff48$export$75b705e7e413826a), {
            contentId: contentId,
            contentType: contentType,
            spaceKey: spaceKey,
            contentTitle: contentTitle,
            isDisabled: isButtonDisabled,
            immediateActivationCondition: immediateActivationCondition,
            selectiveHydrationEnabled: true,
            ...wrapperProps
        }));
        $[10] = contentId;
        $[11] = contentTitle;
        $[12] = contentType;
        $[13] = immediateActivationCondition;
        $[14] = isButtonDisabled;
        $[15] = spaceKey;
        $[16] = wrapperProps;
        $[17] = t8;
    } else t8 = $[17];
    return t8;
} : ({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, contentTitle: contentTitle, isDisabled: isDisabled })=>{
    const wrapperRef = (0, $42omo.useRef)(null);
    // Assume audio is enabled for SSR until client-side useEffect checks browser support
    const [audioSupportedByBrowser, setAudioSupportedByBrowser] = (0, $42omo.useState)(true);
    const [isFocusActivated, setIsFocusActivated] = (0, $42omo.useState)(false);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    (0, $42omo.useEffect)(()=>{
        // Only check audio support when selective hydration is enabled.
        // For FG-OFF we rely on the browser check within AudioButton.
        const isAudioSupportedByBrowser = typeof MediaSource !== 'undefined' && MediaSource.isTypeSupported('audio/mpeg');
        if (!isAudioSupportedByBrowser) (0, $42omo.startTransition)(()=>{
            setAudioSupportedByBrowser(false);
        });
    }, []);
    (0, $42omo.useEffect)(()=>{
        // Focus listener to determine if a user has tabbed to the button via keyboard, in which case
        // the component is immediately hydrated. This listener must live outside AudioButton code and hydrate if button is activated.
        const wrapper = wrapperRef.current;
        if (!wrapper) return;
        const handleFocus = (event)=>{
            const target = event.target;
            if (!target || !target.matches('button, [role="button"]')) return;
            const isKeyboardFocus = target.matches(':focus-visible');
            if (!isKeyboardFocus) return;
            (0, $42omo.startTransition)(()=>{
                setIsFocusActivated(true);
            });
        };
        wrapper.addEventListener('focus', handleFocus, true);
        return ()=>{
            wrapper.removeEventListener('focus', handleFocus, true);
        };
    }, []);
    // Only immediately hydrate if:
    // 1) audio button is not supported by browser (firefox) and component needs to hydrate to show as disabled on page load
    // 2) user activates the button via keyboard focus
    const immediateActivationCondition = audioSupportedByBrowser === false || isFocusActivated;
    const isButtonDisabled = isDisabled && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false) || !renderServerPlaceholder && !audioSupportedByBrowser;
    const wrapperProps = {
        audioSupportedByBrowserFromWrapper: audioSupportedByBrowser ?? true
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: wrapperRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8a4bdd953279ff48$export$75b705e7e413826a), {
        contentId: contentId,
        contentType: contentType,
        spaceKey: spaceKey,
        contentTitle: contentTitle,
        isDisabled: isButtonDisabled,
        immediateActivationCondition: immediateActivationCondition,
        selectiveHydrationEnabled: true,
        ...wrapperProps
    }));
};





















var $h8ZMZ = parcelRequire("h8ZMZ");

/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 


const $507d1897964ccd80$export$dfb24f670bfd5854 = ()=>{
    const width = 24;
    const height = 24;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        viewBox: "0 0 156 156"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        filter: "url(#a)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#b)",
        "data-figma-skip-parse": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("foreignObject", {
        width: 1789.03,
        height: 1789.03,
        x: -894.514,
        y: -894.514,
        transform: "matrix(.05 -.06262 .06262 .05 74 74)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: {
            background: // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            'conic-gradient(from 90deg,#fca700 0deg,#fca700 72.6913deg,#6a9922 72.7273deg,#6a9922 167.895deg,#1868db 167.931deg,#1868db 252.667deg,#af59e0 252.703deg,#af59e0 360deg)',
            height: '100%',
            width: '100%',
            opacity: 1
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M24 24h100v100H24z",
        "data-figma-gradient-fill": '{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"transform":{"m00":100.00002288818359,"m01":125.23040008544922,"m02":-38.615222930908203,"m10":-125.23040008544922,"m11":100.00002288818359,"m12":86.615180969238281},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "b"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M24 24h100v100H24z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("filter", {
        id: "a",
        width: 164,
        height: 164,
        x: -8,
        y: -8,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feGaussianBlur", {
        result: "effect1_foregroundBlur_3077_178",
        stdDeviation: 16
    }))));
};


function $cd68455bb63fab05$export$eca6b6ab857179f1({ contentId: contentId, cloudId: cloudId, contentType: contentType }) {
    const { isHerActive: isHerActive, toggleHer: toggleHer } = (0, $h8ZMZ.useHerStore)();
    const handleClick = (0, $42omo.useCallback)(()=>{
        toggleHer(contentId, cloudId, contentType);
    }, [
        toggleHer,
        contentId,
        cloudId,
        contentType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: "Enterprise HER",
        position: "left"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $507d1897964ccd80$export$dfb24f670bfd5854), null),
        label: "Enterprise HER",
        shape: "circle",
        isSelected: isHerActive,
        onClick: handleClick,
        testId: "enterprise-her-button"
    }));
}





const $d34346cf549a725a$export$2501aa4690daf770 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { contentId: contentId, contentType: contentType } = t0;
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t1;
    if ($[0] !== cloudId || $[1] !== contentId || $[2] !== contentType) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cd68455bb63fab05$export$eca6b6ab857179f1), {
            contentId: contentId,
            contentType: contentType,
            cloudId: cloudId
        });
        $[0] = cloudId;
        $[1] = contentId;
        $[2] = contentType;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ contentId: contentId, contentType: contentType })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cd68455bb63fab05$export$eca6b6ab857179f1), {
        contentId: contentId,
        contentType: contentType,
        cloudId: cloudId
    });
};



var $4ZXww = parcelRequire("4ZXww");


var $fgdVB = parcelRequire("fgdVB");

const $3265ee1fae39f7d6$var$hoistedNav4RightSlotWidthVar = [
    '--right',
    'PanelWidth'
].join('');

const $3265ee1fae39f7d6$var$CommentPanelButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "R3F99",
    name: "CommentPanelButton",
    loader: async ()=>(await (parcelRequire("ag08F"))).CommentPanelButton
});

const $3265ee1fae39f7d6$var$DetailsPanelButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "wgj5o",
    name: "DetailsPanelButton",
    loader: async ()=>(await (parcelRequire("9Ima4"))).DetailsPanelButton
});

const $3265ee1fae39f7d6$var$AgentReceiptPanelButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "R8yoa",
    name: "AgentReceiptPanelButton",
    loader: async ()=>(await (parcelRequire("8qfS5"))).AgentReceiptPanelButton
});

const $3265ee1fae39f7d6$var$EditorAIActions = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "gSc9d",
    name: "EditorAIActions",
    loader: async ()=>(await (parcelRequire("7rWz7"))).EditorAIActions
});

const $3265ee1fae39f7d6$var$UndoButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KP43A",
    name: "UndoButton",
    loader: async ()=>(await (parcelRequire("7K4N2"))).UndoButton
});

const $3265ee1fae39f7d6$var$RedoButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "jZ8ML",
    name: "RedoButton",
    loader: async ()=>(await (parcelRequire("7K4N2"))).RedoButton
});

const $3265ee1fae39f7d6$var$ShowDiffButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "41USm",
    name: "ShowDiffButton",
    loader: async ()=>(await (parcelRequire("3abxA"))).ShowDiffButton
});

const $3265ee1fae39f7d6$var$FeedbackCollectorButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "erEzF",
    name: "FeedbackCollectorButton",
    loader: async ()=>(await (parcelRequire("6HPDw"))).FeedbackCollectorButton
});

const $3265ee1fae39f7d6$var$RemixPanelButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CmH6Z",
    name: "RemixPanelButton",
    loader: async ()=>(await (parcelRequire("6hYoU"))).RemixPanelButton
});

const $3265ee1fae39f7d6$var$AudioListenButtonWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "bAx22",
    name: "AudioListenButtonWrapper",
    loader: async ()=>(await (parcelRequire("iJqig"))).AudioListenButtonWrapper
});

const $3265ee1fae39f7d6$var$ObjectSidebarSpotlightTour = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "hFsXW",
    name: "ObjectSidebarSpotlightTour",
    loader: async ()=>(await (parcelRequire("7mgQ0"))).ObjectSidebarSpotlightTour
});
const $3265ee1fae39f7d6$var$objectSidebarStyles = null;
const $3265ee1fae39f7d6$var$markdownModeObjectSidebarStyles = null;
const $3265ee1fae39f7d6$var$objectSidebarPaddingStyles = null;
const $3265ee1fae39f7d6$var$databaseObjectSidebarPaddingStyles = null;
const $3265ee1fae39f7d6$var$largeBottomPaddingStyles = null;
const $3265ee1fae39f7d6$var$viewModeStylesWithLegacyFooter = null;
const $3265ee1fae39f7d6$var$viewModeStylesWithNewFooter = null;
const $3265ee1fae39f7d6$var$miniModalModeStyles = null;
const $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles = (0, $ecnYn.xcss)({
    padding: 'space.100',
    boxShadow: 'elevation.shadow.raised',
    backgroundColor: 'elevation.surface.raised',
    borderRadius: 'radius.full'
});
const $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerOverlayStyles = (0, $ecnYn.xcss)({
    padding: 'space.100',
    boxShadow: 'elevation.shadow.overlay',
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: 'radius.full'
});
const $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles = (0, $ecnYn.xcss)({
    padding: 'space.100',
    boxShadow: 'elevation.shadow.raised',
    backgroundColor: 'elevation.surface.raised',
    borderRadius: 'radius.xlarge'
});
const $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerOverlayStyles = (0, $ecnYn.xcss)({
    padding: 'space.100',
    boxShadow: 'elevation.shadow.overlay',
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: 'radius.xlarge'
});
const $3265ee1fae39f7d6$var$collapsibleContainerStyles = null;
const $3265ee1fae39f7d6$var$collapsibleBottomSidebarStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.100',
    marginBottom: 'space.050'
});
const $3265ee1fae39f7d6$var$rovoButtonCollapsibleBottomSidebarStyles = null;
const $3265ee1fae39f7d6$var$collapsibleToggleStyles = null;
const $3265ee1fae39f7d6$var$dividerStyle = (0, $ecnYn.xcss)({
    borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    display: 'inline-block',
    width: '16px',
    height: '1px'
});
const $3265ee1fae39f7d6$var$hiddenStyles = null;
const $3265ee1fae39f7d6$var$i18n = (0, $aXWIB.defineMessages)({
    expandToggleLabel: {
        id: "object-sidebar-components.expand-toggle-label",
        defaultMessage: "Expand action bar"
    },
    collapseToggleLabel: {
        id: "object-sidebar-components.collapse-toggle-label",
        defaultMessage: "Collapse action bar"
    }
});
const $3265ee1fae39f7d6$export$3fab07431350539e = /*#__PURE__*/ (0, $42omo.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(219);
    const { hasCommentsButton: hasCommentsButton, hasDetailsButton: hasDetailsButton, hasAgentReceiptButton: hasAgentReceiptButton, hasLoomButton: hasLoomButton, hasAiButton: hasAiButton, hasRemixButton: hasRemixButton, undoRedoButtonActions: undoRedoButtonActions, hasUndoRedoButton: hasUndoRedoButton, showDiffButtonActions: showDiffButtonActions, hasAudioButton: hasAudioButton, hasFeedbackButton: t1, agentTrustReceipt: agentTrustReceipt, contentId: contentId, spaceKey: spaceKey, contentType: contentType, contentTitle: contentTitle, lastModifiedDate: lastModifiedDate, aiIsStreaming: t2, pageCommentsSectionInView: pageCommentsSectionInView, contentIdFromQuery: contentIdFromQuery, contentBodyDynamic: contentBodyDynamic, getAdfDocument: getAdfDocument, isUnpublishedDraft: isUnpublishedDraft, largeBottomPadding: largeBottomPadding, editorAIActions: editorAIActions, shouldDisableUndoRedo: t3, isDatabasesStagingArea: t4, disabled: disabled, isEditorEmpty: isEditorEmpty, isMarkdownMode: isMarkdownMode, isMarkdownModeSyntaxViewToggled: isMarkdownModeSyntaxViewToggled } = t0;
    const hasFeedbackButton = t1 === undefined ? true : t1;
    const aiIsStreaming = t2 === undefined ? false : t2;
    const shouldDisableUndoRedo = t3 === undefined ? false : t3;
    const isDatabasesStagingArea = t4 === undefined ? false : t4;
    const [t5] = (0, $kM55L.useCollabNetworkStatus)();
    const { isCollabOffline: isCollabOffline } = t5;
    let t6;
    if ($[0] !== isCollabOffline) {
        t6 = isCollabOffline && (0, $6mKj3.expVal)("platform_editor_offline_editing_web", "isEnabled", false) && !(0, $9wGTI.fg)("platform_editor_offline_editing_wrapper_override");
        $[0] = isCollabOffline;
        $[1] = t6;
    } else t6 = $[1];
    const isNetworkDisabled = t6;
    const { isFullScreenEmbedView: isFullScreenEmbedView } = (0, $iV5Ic.useReactProps_DO_NOT_USE)() || {};
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [actionBarIsHovered, setActionBarIsHovered] = (0, $42omo.useState)(false);
    const sidebarControlState = (0, $aWwYt.useSidebarControlState)();
    const sidebarControlExpandCollapsedState = (0, $aWwYt.useSidebarControlExpandCollapsedState)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { setSidebarControlState: setSidebarControlState, toggleObjectSidebarControl: toggleObjectSidebarControl, setSidebarControlExpandCollapsedState: setSidebarControlExpandCollapsedState } = (0, $aWwYt.useObjectSidebarActions)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const { mode: rovoExperienceMode } = (0, $8unJx.useRovoExperienceAPIStore)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    let t7;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = {
            selector: $3265ee1fae39f7d6$var$_temp
        };
        $[2] = t7;
    } else t7 = $[2];
    const isOnPDFExportPageRouteArgs = t7;
    const isOnPDFExportPageRoute = (0, $dPJCf.useRouteName)(isOnPDFExportPageRouteArgs);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [t8] = (0, $efvKr.useLivePageMode)();
    const { isViewMode: isLiveViewMode } = t8;
    let t9;
    if ($[3] !== isAdminHubAIEnabled || $[4] !== isLiveViewMode || $[5] !== isRovoButtonEnabled || $[6] !== pageMode) {
        t9 = !isAdminHubAIEnabled || !isRovoButtonEnabled || pageMode !== (0, $cD1qu.PageMode).LIVE || isLiveViewMode || !(0, $9wGTI.fg)("confluence_rovo_live_doc_nudges");
        $[3] = isAdminHubAIEnabled;
        $[4] = isLiveViewMode;
        $[5] = isRovoButtonEnabled;
        $[6] = pageMode;
        $[7] = t9;
    } else t9 = $[7];
    const skipReadTime = t9;
    const { readTime: readTime, loading: readTimeLoading } = (0, $h2uld.useReadTime)(contentId, skipReadTime);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { isAudioV3Enabled: isAudioV3Enabled } = (0, $JTIzG.useAudioFeatureFlags)();
    let t10;
    if ($[8] !== setSidebarControlExpandCollapsedState) {
        t10 = ()=>{
            setSidebarControlExpandCollapsedState("expanded");
        };
        $[8] = setSidebarControlExpandCollapsedState;
        $[9] = t10;
    } else t10 = $[9];
    let t11;
    if ($[10] !== contentId || $[11] !== setSidebarControlExpandCollapsedState) {
        t11 = [
            contentId,
            setSidebarControlExpandCollapsedState
        ];
        $[10] = contentId;
        $[11] = setSidebarControlExpandCollapsedState;
        $[12] = t11;
    } else t11 = $[12];
    (0, $42omo.useEffect)(t10, t11);
    let t12;
    let t13;
    if ($[13] !== isObjectSidebarShown || $[14] !== setSidebarControlExpandCollapsedState || $[15] !== setSidebarControlState) {
        t12 = ()=>{
            if (!isObjectSidebarShown) setSidebarControlState("shown");
            setSidebarControlExpandCollapsedState("expanded");
            return ()=>{
                setSidebarControlExpandCollapsedState("collapsed");
            };
        };
        t13 = [
            setSidebarControlState,
            setSidebarControlExpandCollapsedState,
            isObjectSidebarShown
        ];
        $[13] = isObjectSidebarShown;
        $[14] = setSidebarControlExpandCollapsedState;
        $[15] = setSidebarControlState;
        $[16] = t12;
        $[17] = t13;
    } else {
        t12 = $[16];
        t13 = $[17];
    }
    (0, $42omo.useEffect)(t12, t13);
    const sidebarIsExpanded = sidebarControlExpandCollapsedState === "expanded" || renderServerPlaceholder;
    let collapsedActions;
    let primaryActions;
    let secondaryActions;
    let secondaryActionsTeam25;
    if ($[18] !== agentTrustReceipt || $[19] !== aiIsStreaming || $[20] !== contentBodyDynamic?.value || $[21] !== contentId || $[22] !== contentTitle || $[23] !== contentType || $[24] !== disabled || $[25] !== editorAIActions || $[26] !== getAdfDocument || $[27] !== hasAgentReceiptButton || $[28] !== hasAudioButton || $[29] !== hasCommentsButton || $[30] !== hasDetailsButton || $[31] !== hasFeedbackButton || $[32] !== hasLoomButton || $[33] !== hasRemixButton || $[34] !== hasUndoRedoButton || $[35] !== isAudioV3Enabled || $[36] !== isDatabasesStagingArea || $[37] !== isEditorEmpty || $[38] !== isLivePage || $[39] !== isLiveViewMode || $[40] !== isLoomDisabled || $[41] !== isNetworkDisabled || $[42] !== isRovoButtonEnabled || $[43] !== pageMode || $[44] !== shouldDisableUndoRedo || $[45] !== showDiffButtonActions || $[46] !== sidebarIsExpanded || $[47] !== spaceKey || $[48] !== undoRedoButtonActions) {
        collapsedActions = [];
        primaryActions = [];
        if (hasUndoRedoButton && undoRedoButtonActions && !isLiveViewMode && (0, $9wGTI.fg)("aifc_create_enabled") && isDatabasesStagingArea) {
            const { canUndo: canUndo, undo: undo, canRedo: canRedo, redo: redo } = undoRedoButtonActions;
            if (undo && canUndo !== undefined) {
                const t14 = aiIsStreaming || shouldDisableUndoRedo;
                let t15;
                if ($[53] !== canUndo || $[54] !== t14 || $[55] !== undo) {
                    t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$UndoButton, {
                        canUndo: canUndo,
                        undo: undo,
                        isDisabled: t14
                    });
                    $[53] = canUndo;
                    $[54] = t14;
                    $[55] = undo;
                    $[56] = t15;
                } else t15 = $[56];
                primaryActions.push(t15);
            }
            if (redo && canRedo !== undefined) {
                const t14 = aiIsStreaming || shouldDisableUndoRedo;
                let t15;
                if ($[57] !== canRedo || $[58] !== redo || $[59] !== t14) {
                    t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$RedoButton, {
                        canRedo: canRedo,
                        redo: redo,
                        isDisabled: t14
                    });
                    $[57] = canRedo;
                    $[58] = redo;
                    $[59] = t14;
                    $[60] = t15;
                } else t15 = $[60];
                primaryActions.push(t15);
            }
        }
        if (showDiffButtonActions && !isLiveViewMode && (0, $9wGTI.fg)("aifc_create_enabled") && isDatabasesStagingArea) {
            const { onShowDiff: onShowDiff, isShowDiffEnabled: isShowDiffEnabled, isShowDiffSelected: isShowDiffSelected } = showDiffButtonActions;
            const t14 = isShowDiffEnabled && !aiIsStreaming;
            let t15;
            if ($[61] !== isShowDiffSelected || $[62] !== onShowDiff || $[63] !== t14) {
                t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$ShowDiffButton, {
                    isShowDiffSelected: isShowDiffSelected,
                    isShowDiffEnabled: t14,
                    onShowDiff: onShowDiff
                });
                $[61] = isShowDiffSelected;
                $[62] = onShowDiff;
                $[63] = t14;
                $[64] = t15;
            } else t15 = $[64];
            primaryActions.push(t15);
        }
        secondaryActions = [];
        secondaryActionsTeam25 = [];
        if ((0, $9wGTI.fg)("aifc_create_enabled")) {
            if (hasCommentsButton) {
                let t14;
                if ($[65] !== contentId || $[66] !== isNetworkDisabled) {
                    t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$CommentPanelButton, {
                        key: "comment-panel-button",
                        contentId: contentId,
                        isDisabled: isNetworkDisabled
                    });
                    $[65] = contentId;
                    $[66] = isNetworkDisabled;
                    $[67] = t14;
                } else t14 = $[67];
                secondaryActionsTeam25.push(t14);
                if (!sidebarIsExpanded) {
                    let t15;
                    if ($[68] !== contentId || $[69] !== isNetworkDisabled) {
                        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$CommentPanelButton, {
                            key: "comment-panel-button-collapsed",
                            contentId: contentId,
                            collapsed: true,
                            isDisabled: isNetworkDisabled
                        });
                        $[68] = contentId;
                        $[69] = isNetworkDisabled;
                        $[70] = t15;
                    } else t15 = $[70];
                    collapsedActions.push(t15);
                }
            }
            if (hasDetailsButton) {
                let t14;
                if ($[71] !== contentId || $[72] !== isNetworkDisabled) {
                    t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$DetailsPanelButton, {
                        key: "details-panel-button",
                        contentId: contentId,
                        isDisabled: isNetworkDisabled
                    });
                    $[71] = contentId;
                    $[72] = isNetworkDisabled;
                    $[73] = t14;
                } else t14 = $[73];
                secondaryActionsTeam25.push(t14);
                if (!sidebarIsExpanded) {
                    let t15;
                    if ($[74] !== contentId || $[75] !== isNetworkDisabled) {
                        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$DetailsPanelButton, {
                            key: "details-panel-button-collapsed",
                            contentId: contentId,
                            collapsed: true,
                            isDisabled: isNetworkDisabled
                        });
                        $[74] = contentId;
                        $[75] = isNetworkDisabled;
                        $[76] = t15;
                    } else t15 = $[76];
                    collapsedActions.push(t15);
                }
            }
            if (hasAgentReceiptButton && agentTrustReceipt) {
                let t14;
                if ($[77] !== agentTrustReceipt || $[78] !== isNetworkDisabled) {
                    t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$AgentReceiptPanelButton, {
                        key: "agent-receipt-panel-button",
                        receipt: agentTrustReceipt,
                        isDisabled: isNetworkDisabled
                    });
                    $[77] = agentTrustReceipt;
                    $[78] = isNetworkDisabled;
                    $[79] = t14;
                } else t14 = $[79];
                secondaryActionsTeam25.push(t14);
            }
            if ((0, $6mKj3.isExperimentEnabled)("enterprise_her")) {
                const t14 = contentType ?? "";
                let t15;
                if ($[80] !== contentId || $[81] !== t14) {
                    t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d34346cf549a725a$export$2501aa4690daf770), {
                        key: "enterprise-her-button-wrapper",
                        contentId: contentId,
                        contentType: t14
                    });
                    $[80] = contentId;
                    $[81] = t14;
                    $[82] = t15;
                } else t15 = $[82];
                secondaryActionsTeam25.push(t15);
            }
            if (hasAudioButton) {
                if (isAudioV3Enabled) {
                    const t14 = contentType ?? "";
                    const t15 = spaceKey ?? "";
                    const t16 = contentTitle ?? "";
                    let t17;
                    if ($[83] !== contentId || $[84] !== disabled || $[85] !== isLivePage || $[86] !== isRovoButtonEnabled || $[87] !== t14 || $[88] !== t15 || $[89] !== t16) {
                        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$AudioListenButtonWrapper, {
                            key: "audio-listen-button-wrapper",
                            isRovoButtonEnabled: isRovoButtonEnabled,
                            contentId: contentId,
                            contentType: t14,
                            isLivePage: isLivePage,
                            spaceKey: t15,
                            title: t16,
                            isAutoOpenDisabled: disabled
                        });
                        $[83] = contentId;
                        $[84] = disabled;
                        $[85] = isLivePage;
                        $[86] = isRovoButtonEnabled;
                        $[87] = t14;
                        $[88] = t15;
                        $[89] = t16;
                        $[90] = t17;
                    } else t17 = $[90];
                    secondaryActionsTeam25.push(t17);
                } else {
                    const t14 = pageMode === (0, $cD1qu.PageMode).VIEW;
                    let t15;
                    if ($[91] !== contentId || $[92] !== contentTitle || $[93] !== contentType || $[94] !== isNetworkDisabled || $[95] !== spaceKey || $[96] !== t14) {
                        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46bbba5af56c1c8e$export$6210e0bba7c89213), {
                            key: "audio-button-loader-wrapper",
                            contentId: contentId,
                            contentType: contentType,
                            spaceKey: spaceKey,
                            contentTitle: contentTitle,
                            isDisabled: isNetworkDisabled,
                            isView: t14
                        });
                        $[91] = contentId;
                        $[92] = contentTitle;
                        $[93] = contentType;
                        $[94] = isNetworkDisabled;
                        $[95] = spaceKey;
                        $[96] = t14;
                        $[97] = t15;
                    } else t15 = $[97];
                    secondaryActionsTeam25.push(t15);
                }
            }
            if (hasLoomButton && !isLoomDisabled) {
                const t14 = spaceKey ?? "";
                const t15 = contentType ?? "";
                const t16 = !isRovoButtonEnabled;
                let t17;
                if ($[98] !== contentId || $[99] !== isNetworkDisabled || $[100] !== t14 || $[101] !== t15 || $[102] !== t16) {
                    t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $D7PHQ.PageHeaderLoomEntryPoint), {
                        key: "page-header-loom-entry-point",
                        contentId: contentId,
                        crossSellPopupPlacement: "left-end",
                        crossSellSpotlightPlacement: "left-start",
                        spaceKey: t14,
                        contentType: t15,
                        isCircle: t16,
                        testId: "sidebar-loom-button",
                        source: "contentWrapper",
                        isDisabled: isNetworkDisabled
                    });
                    $[98] = contentId;
                    $[99] = isNetworkDisabled;
                    $[100] = t14;
                    $[101] = t15;
                    $[102] = t16;
                    $[103] = t17;
                } else t17 = $[103];
                secondaryActionsTeam25.push(t17);
            }
            if (editorAIActions) {
                let t14;
                if ($[104] !== aiIsStreaming || $[105] !== editorAIActions) {
                    t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$EditorAIActions, {
                        key: "editor-ai-actions",
                        editorAIActions: editorAIActions,
                        isDisabled: aiIsStreaming
                    });
                    $[104] = aiIsStreaming;
                    $[105] = editorAIActions;
                    $[106] = t14;
                } else t14 = $[106];
                secondaryActionsTeam25.push(t14);
            }
            if (hasRemixButton && (0, $6mKj3.expValEquals)("cc-maui-object-level-remix-experiment", "isEnabled", true)) {
                const t14 = contentBodyDynamic?.value;
                let t15;
                if ($[107] !== getAdfDocument || $[108] !== isEditorEmpty || $[109] !== isNetworkDisabled || $[110] !== t14) {
                    t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$RemixPanelButton, {
                        key: "remix-panel-button",
                        contentBodyValue: t14,
                        getAdfDocument: getAdfDocument,
                        isEditorEmpty: isEditorEmpty,
                        isDisabled: isNetworkDisabled
                    });
                    $[107] = getAdfDocument;
                    $[108] = isEditorEmpty;
                    $[109] = isNetworkDisabled;
                    $[110] = t14;
                    $[111] = t15;
                } else t15 = $[111];
                const remixButton = t15;
                secondaryActionsTeam25.push(remixButton);
            }
        } else {
            if (hasCommentsButton) {
                let t14;
                if ($[112] !== contentId || $[113] !== isNetworkDisabled) {
                    t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$CommentPanelButton, {
                        key: "comment-panel-button",
                        contentId: contentId,
                        isDisabled: isNetworkDisabled
                    });
                    $[112] = contentId;
                    $[113] = isNetworkDisabled;
                    $[114] = t14;
                } else t14 = $[114];
                primaryActions.push(t14);
                if (!sidebarIsExpanded) {
                    let t15;
                    if ($[115] !== contentId || $[116] !== isNetworkDisabled) {
                        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$CommentPanelButton, {
                            key: "comment-panel-button-collapsed",
                            contentId: contentId,
                            collapsed: true,
                            isDisabled: isNetworkDisabled
                        });
                        $[115] = contentId;
                        $[116] = isNetworkDisabled;
                        $[117] = t15;
                    } else t15 = $[117];
                    collapsedActions.push(t15);
                }
            }
            if (hasDetailsButton) {
                let t14;
                if ($[118] !== contentId || $[119] !== isNetworkDisabled) {
                    t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$DetailsPanelButton, {
                        key: "details-panel-button",
                        contentId: contentId,
                        isDisabled: isNetworkDisabled
                    });
                    $[118] = contentId;
                    $[119] = isNetworkDisabled;
                    $[120] = t14;
                } else t14 = $[120];
                primaryActions.push(t14);
                if (!sidebarIsExpanded) {
                    let t15;
                    if ($[121] !== contentId || $[122] !== isNetworkDisabled) {
                        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$DetailsPanelButton, {
                            key: "details-panel-button-collapsed",
                            contentId: contentId,
                            collapsed: true,
                            isDisabled: isNetworkDisabled
                        });
                        $[121] = contentId;
                        $[122] = isNetworkDisabled;
                        $[123] = t15;
                    } else t15 = $[123];
                    collapsedActions.push(t15);
                }
            }
            if (hasAgentReceiptButton && agentTrustReceipt) {
                let t14;
                if ($[124] !== agentTrustReceipt || $[125] !== isNetworkDisabled) {
                    t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$AgentReceiptPanelButton, {
                        key: "agent-receipt-panel-button",
                        receipt: agentTrustReceipt,
                        isDisabled: isNetworkDisabled
                    });
                    $[124] = agentTrustReceipt;
                    $[125] = isNetworkDisabled;
                    $[126] = t14;
                } else t14 = $[126];
                primaryActions.push(t14);
            }
            if (hasAudioButton) {
                if (isAudioV3Enabled) {
                    const t14 = contentType ?? "";
                    const t15 = spaceKey ?? "";
                    const t16 = contentTitle ?? "";
                    let t17;
                    if ($[127] !== contentId || $[128] !== disabled || $[129] !== isLivePage || $[130] !== isRovoButtonEnabled || $[131] !== t14 || $[132] !== t15 || $[133] !== t16) {
                        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$AudioListenButtonWrapper, {
                            key: "audio-listen-button-wrapper",
                            isRovoButtonEnabled: isRovoButtonEnabled,
                            contentId: contentId,
                            contentType: t14,
                            isLivePage: isLivePage,
                            spaceKey: t15,
                            title: t16,
                            isAutoOpenDisabled: disabled
                        });
                        $[127] = contentId;
                        $[128] = disabled;
                        $[129] = isLivePage;
                        $[130] = isRovoButtonEnabled;
                        $[131] = t14;
                        $[132] = t15;
                        $[133] = t16;
                        $[134] = t17;
                    } else t17 = $[134];
                    secondaryActions.push(t17);
                } else {
                    const t14 = pageMode === (0, $cD1qu.PageMode).VIEW;
                    let t15;
                    if ($[135] !== contentId || $[136] !== contentTitle || $[137] !== contentType || $[138] !== isNetworkDisabled || $[139] !== spaceKey || $[140] !== t14) {
                        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46bbba5af56c1c8e$export$6210e0bba7c89213), {
                            key: "audio-button-loader-wrapper",
                            contentId: contentId,
                            contentType: contentType,
                            spaceKey: spaceKey,
                            contentTitle: contentTitle,
                            isDisabled: isNetworkDisabled,
                            isView: t14
                        });
                        $[135] = contentId;
                        $[136] = contentTitle;
                        $[137] = contentType;
                        $[138] = isNetworkDisabled;
                        $[139] = spaceKey;
                        $[140] = t14;
                        $[141] = t15;
                    } else t15 = $[141];
                    secondaryActions.push(t15);
                }
            }
            if (hasLoomButton && !isLoomDisabled) {
                const t14 = spaceKey ?? "";
                const t15 = contentType ?? "";
                const t16 = !isRovoButtonEnabled;
                let t17;
                if ($[142] !== contentId || $[143] !== isNetworkDisabled || $[144] !== t14 || $[145] !== t15 || $[146] !== t16) {
                    t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $D7PHQ.PageHeaderLoomEntryPoint), {
                        key: "page-header-loom-entry-point",
                        contentId: contentId,
                        crossSellPopupPlacement: "left-end",
                        crossSellSpotlightPlacement: "left-start",
                        spaceKey: t14,
                        contentType: t15,
                        isCircle: t16,
                        testId: "sidebar-loom-button",
                        source: "contentWrapper",
                        isDisabled: isNetworkDisabled
                    });
                    $[142] = contentId;
                    $[143] = isNetworkDisabled;
                    $[144] = t14;
                    $[145] = t15;
                    $[146] = t16;
                    $[147] = t17;
                } else t17 = $[147];
                secondaryActions.push(t17);
            }
            if (hasFeedbackButton) {
                let t14;
                if ($[148] !== contentId || $[149] !== isNetworkDisabled) {
                    t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$FeedbackCollectorButton, {
                        key: "feedback-collector-button",
                        contentId: contentId,
                        isDisabled: isNetworkDisabled
                    });
                    $[148] = contentId;
                    $[149] = isNetworkDisabled;
                    $[150] = t14;
                } else t14 = $[150];
                secondaryActions.push(t14);
            }
        }
        $[18] = agentTrustReceipt;
        $[19] = aiIsStreaming;
        $[20] = contentBodyDynamic?.value;
        $[21] = contentId;
        $[22] = contentTitle;
        $[23] = contentType;
        $[24] = disabled;
        $[25] = editorAIActions;
        $[26] = getAdfDocument;
        $[27] = hasAgentReceiptButton;
        $[28] = hasAudioButton;
        $[29] = hasCommentsButton;
        $[30] = hasDetailsButton;
        $[31] = hasFeedbackButton;
        $[32] = hasLoomButton;
        $[33] = hasRemixButton;
        $[34] = hasUndoRedoButton;
        $[35] = isAudioV3Enabled;
        $[36] = isDatabasesStagingArea;
        $[37] = isEditorEmpty;
        $[38] = isLivePage;
        $[39] = isLiveViewMode;
        $[40] = isLoomDisabled;
        $[41] = isNetworkDisabled;
        $[42] = isRovoButtonEnabled;
        $[43] = pageMode;
        $[44] = shouldDisableUndoRedo;
        $[45] = showDiffButtonActions;
        $[46] = sidebarIsExpanded;
        $[47] = spaceKey;
        $[48] = undoRedoButtonActions;
        $[49] = collapsedActions;
        $[50] = primaryActions;
        $[51] = secondaryActions;
        $[52] = secondaryActionsTeam25;
    } else {
        collapsedActions = $[49];
        primaryActions = $[50];
        secondaryActions = $[51];
        secondaryActionsTeam25 = $[52];
    }
    let t14;
    bb0: {
        if (pageMode === (0, $cD1qu.PageMode).VIEW || pageMode === (0, $cD1qu.PageMode).LIVE && isLiveViewMode) {
            let t15;
            if ($[151] === Symbol.for("react.memo_cache_sentinel")) {
                t15 = {
                    experience: (0, $dppWL.RegisteredExperience).VIEW_PAGE,
                    provider: (0, $2b7ed8ae830eb95a$export$299010de885adda)
                };
                $[151] = t15;
            } else t15 = $[151];
            t14 = t15;
            break bb0;
        }
        if (pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE && !isLiveViewMode) {
            let t15;
            if ($[152] === Symbol.for("react.memo_cache_sentinel")) {
                t15 = {
                    experience: (0, $dppWL.RegisteredExperience).EDIT_PAGE,
                    provider: (0, $7e583ad86f1e8aa8$export$d95c465cd9bfae9f)
                };
                $[152] = t15;
            } else t15 = $[152];
            t14 = t15;
            break bb0;
        }
        t14 = undefined;
    }
    const rovoConfiguration = t14;
    if (isOnPDFExportPageRoute) return null;
    let t15;
    if ($[153] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
        $[153] = t15;
    } else t15 = $[153];
    const isEmbeddedConfluence = t15;
    const shouldRenderWhenEmbedded = isEmbeddedConfluence ? isDatabasesStagingArea || isFullScreenEmbedView : !isEmbeddedConfluence;
    const shouldRenderIntegratedExpandButton = !hasAiButton && !sidebarIsExpanded;
    const shouldDisplayHoverToggle = sidebarIsExpanded && actionBarIsHovered || hasAiButton && !sidebarIsExpanded;
    const shouldRenderAISmartButton = hasAiButton && shouldRenderWhenEmbedded && !isMobileApp;
    const isRovoMiniModalShown = shouldRenderAISmartButton && isRovoButtonEnabled && rovoExperienceMode === (0, $hR4U4.ConversationAssistantUIModes).MINI_MODAL;
    let t16;
    if ($[154] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = ()=>{
            setActionBarIsHovered(true);
        };
        $[154] = t16;
    } else t16 = $[154];
    const handleMouseEnter = t16;
    let t17;
    if ($[155] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = ()=>{
            setActionBarIsHovered(false);
        };
        $[155] = t17;
    } else t17 = $[155];
    const handleMouseLeave = t17;
    let t18;
    if ($[156] !== sidebarIsExpanded || $[157] !== toggleObjectSidebarControl) {
        t18 = ()=>{
            toggleObjectSidebarControl();
            setActionBarIsHovered(!sidebarIsExpanded);
        };
        $[156] = sidebarIsExpanded;
        $[157] = toggleObjectSidebarControl;
        $[158] = t18;
    } else t18 = $[158];
    const onToggleClick = t18;
    let t19;
    if ($[159] !== formatMessage || $[160] !== sidebarIsExpanded) {
        t19 = sidebarIsExpanded ? formatMessage($3265ee1fae39f7d6$var$i18n.collapseToggleLabel) : formatMessage($3265ee1fae39f7d6$var$i18n.expandToggleLabel);
        $[159] = formatMessage;
        $[160] = sidebarIsExpanded;
        $[161] = t19;
    } else t19 = $[161];
    const toggleLabel = t19;
    let t20;
    if ($[162] !== formatMessage) {
        t20 = formatMessage($3265ee1fae39f7d6$var$i18n.expandToggleLabel);
        $[162] = formatMessage;
        $[163] = t20;
    } else t20 = $[163];
    let t21;
    if ($[164] !== toggleLabel || $[165] !== toggleObjectSidebarControl) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            appearance: "subtle",
            icon: $3265ee1fae39f7d6$var$_temp2,
            label: toggleLabel,
            onClick: toggleObjectSidebarControl,
            shape: "circle",
            testId: "integrated-expand-button"
        });
        $[164] = toggleLabel;
        $[165] = toggleObjectSidebarControl;
        $[166] = t21;
    } else t21 = $[166];
    let t22;
    if ($[167] !== t20 || $[168] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            position: "left",
            content: t20,
            hideTooltipOnClick: true
        }, t21);
        $[167] = t20;
        $[168] = t21;
        $[169] = t22;
    } else t22 = $[169];
    const integratedExpandButton = t22;
    const t23 = "object-sidebar-container";
    const t24 = "object-sidebar-container";
    const t25 = pageMode === (0, $cD1qu.PageMode).VIEW ? `calc(var(${$3265ee1fae39f7d6$var$hoistedNav4RightSlotWidthVar}, 0px))` : "0px";
    let t26;
    if ($[170] !== t25) {
        t26 = {
            right: t25,
            marginRight: 0
        };
        $[170] = t25;
        $[171] = t26;
    } else t26 = $[171];
    const t27 = (0, $gMc0m.default)([
        "_v564ul29 _kqsw1n9t _94n5idpf _1pbyowjs _lcxvglyw _w1y61wug",
        isMarkdownMode && isMarkdownModeSyntaxViewToggled && (0, $9wGTI.fg)("platform_editor_md_mvp_layout") && "_94n51jfw",
        (contentType === "page" || contentType === "blogpost" || pageMode === (0, $cD1qu.PageMode).VIEW) && "_u5f31ejb _n3tdu2gc",
        (contentType === "database" || contentType === "slide") && "_u5f3u2gc _n3tdu2gc",
        largeBottomPadding && "_n3td1ejb",
        isRovoMiniModalShown && "_1pby16oo",
        pageMode === (0, $cD1qu.PageMode).VIEW && !isRovoMiniModalShown && !(0, $9wGTI.fg)("confluence_frontend_content_wrapper") && "_1pbykb7n",
        pageMode === (0, $cD1qu.PageMode).VIEW && !isRovoMiniModalShown && (0, $9wGTI.fg)("confluence_frontend_content_wrapper") && "_1pbycs5v",
        !renderServerPlaceholder && sidebarControlState === "hidden" && "_1e0cglyw"
    ]);
    let t28;
    if ($[172] !== collapsedActions || $[173] !== contentId || $[174] !== integratedExpandButton || $[175] !== isMobileApp || $[176] !== isRovoButtonEnabled || $[177] !== onToggleClick || $[178] !== primaryActions || $[179] !== renderServerPlaceholder || $[180] !== secondaryActions || $[181] !== secondaryActionsTeam25 || $[182] !== shouldDisplayHoverToggle || $[183] !== shouldRenderIntegratedExpandButton || $[184] !== shouldRenderWhenEmbedded || $[185] !== sidebarIsExpanded || $[186] !== toggleLabel) {
        t28 = primaryActions.length + secondaryActions.length + secondaryActionsTeam25.length > 0 && shouldRenderWhenEmbedded && !isMobileApp && (0, $9wGTI.fg)("confluence_frontend_content_wrapper") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6cnUO.default), null, (0, $9wGTI.fg)("confluence_frontend_spotlight_ads_migration") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_1bsboahv _18u01wug"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            position: "left",
            content: toggleLabel,
            hideTooltipOnClick: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: {
                paddingBottom: sidebarIsExpanded ? "var(--ds-space-100, 8px)" : undefined,
                visibility: shouldDisplayHoverToggle ? "visible" : "hidden"
            },
            "data-testid": "collapsible-hover-toggle",
            className: (0, $gMc0m.default)([
                "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _1bsbxy5q"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            appearance: "subtle",
            icon: (iconProps_0)=>sidebarIsExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    ...iconProps_0,
                    size: "small"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
                    ...iconProps_0,
                    size: "small"
                }),
            label: toggleLabel,
            onClick: onToggleClick,
            shape: "circle",
            testId: "collapsible-hover-button"
        })))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
            name: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).OBJECT_SIDEBAR_CONTROL
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_1bsboahv _18u01wug"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            position: "left",
            content: toggleLabel,
            hideTooltipOnClick: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: {
                paddingBottom: sidebarIsExpanded ? "var(--ds-space-100, 8px)" : undefined,
                visibility: shouldDisplayHoverToggle ? "visible" : "hidden"
            },
            "data-testid": "collapsible-hover-toggle",
            className: (0, $gMc0m.default)([
                "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _1bsbxy5q"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            appearance: "subtle",
            icon: (iconProps_1)=>sidebarIsExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    ...iconProps_1,
                    size: "small"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
                    ...iconProps_1,
                    size: "small"
                }),
            label: toggleLabel,
            onClick: onToggleClick,
            shape: "circle",
            testId: "collapsible-hover-button"
        }))))), (0, $9wGTI.fg)("confluence_frontend_spotlight_ads_migration") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_1bsboahv _18u01wug"
            ])
        }, sidebarIsExpanded || renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            xcss: isRovoButtonEnabled ? (0, $6mKj3.expValEquals)("cwr_blank_object_experiment", "isEnabled", true) ? $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles : (0, $6mKj3.expValEquals)("cwr_blank_object_experiment", "isEnabled", true) ? $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles,
            direction: "column",
            gap: "space.100",
            justifyContent: "center",
            alignItems: "center",
            testId: "object-sidebar-control"
        }, primaryActions, (0, $9wGTI.fg)("aifc_create_enabled") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, primaryActions.length > 0 && secondaryActionsTeam25.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $3265ee1fae39f7d6$var$dividerStyle
        }), secondaryActionsTeam25) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, secondaryActions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $3265ee1fae39f7d6$var$dividerStyle
        }), secondaryActions)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, collapsedActions))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_1bsboahv _18u01wug"
            ])
        }, sidebarIsExpanded || renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            xcss: isRovoButtonEnabled ? (0, $6mKj3.expValEquals)("cwr_blank_object_experiment", "isEnabled", true) ? $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles : (0, $6mKj3.expValEquals)("cwr_blank_object_experiment", "isEnabled", true) ? $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles,
            direction: "column",
            gap: "space.100",
            justifyContent: "center",
            alignItems: "center",
            testId: "object-sidebar-control"
        }, primaryActions, (0, $9wGTI.fg)("aifc_create_enabled") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, primaryActions.length > 0 && secondaryActionsTeam25.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $3265ee1fae39f7d6$var$dividerStyle
        }), secondaryActionsTeam25) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, secondaryActions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $3265ee1fae39f7d6$var$dividerStyle
        }), secondaryActions)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, collapsedActions)), shouldRenderIntegratedExpandButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_1bsboahv _18u01wug"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            xcss: isRovoButtonEnabled ? (0, $6mKj3.expValEquals)("cwr_blank_object_experiment", "isEnabled", true) ? $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles : (0, $6mKj3.expValEquals)("cwr_blank_object_experiment", "isEnabled", true) ? $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles,
            direction: "column",
            gap: "space.100",
            justifyContent: "center",
            alignItems: "center",
            testId: "object-sidebar-control"
        }, integratedExpandButton)) : null, (0, $9wGTI.fg)("confluence_frontend_spotlight_ads_migration") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$ObjectSidebarSpotlightTour, {
            contentId: contentId
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$ObjectSidebarSpotlightTour, {
            contentId: contentId
        })));
        $[172] = collapsedActions;
        $[173] = contentId;
        $[174] = integratedExpandButton;
        $[175] = isMobileApp;
        $[176] = isRovoButtonEnabled;
        $[177] = onToggleClick;
        $[178] = primaryActions;
        $[179] = renderServerPlaceholder;
        $[180] = secondaryActions;
        $[181] = secondaryActionsTeam25;
        $[182] = shouldDisplayHoverToggle;
        $[183] = shouldRenderIntegratedExpandButton;
        $[184] = shouldRenderWhenEmbedded;
        $[185] = sidebarIsExpanded;
        $[186] = toggleLabel;
        $[187] = t28;
    } else t28 = $[187];
    let t29;
    if ($[188] !== contentBodyDynamic || $[189] !== contentId || $[190] !== contentIdFromQuery || $[191] !== contentTitle || $[192] !== contentType || $[193] !== isEditorEmpty || $[194] !== isEmbeddedConfluence || $[195] !== isLivePage || $[196] !== isNetworkDisabled || $[197] !== isRovoButtonEnabled || $[198] !== isUnpublishedDraft || $[199] !== lastModifiedDate || $[200] !== pageCommentsSectionInView || $[201] !== pageMode || $[202] !== readTime || $[203] !== readTimeLoading || $[204] !== rovoConfiguration?.experience || $[205] !== rovoConfiguration?.provider || $[206] !== shouldRenderAISmartButton || $[207] !== spaceKey) {
        t29 = shouldRenderAISmartButton && (isRovoButtonEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_ca0qu2gc _otyrpxbi _18u0t94y"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3tUdX.RovoConfigProvider), {
            experience: rovoConfiguration?.experience,
            provider: rovoConfiguration?.provider,
            contentId: contentId,
            contentType: contentType ?? "",
            spaceKey: spaceKey ?? "",
            contentTitle: contentTitle ?? "",
            lastModifiedDate: lastModifiedDate,
            isUnpublishedDraft: isUnpublishedDraft,
            isEditorEmpty: isEditorEmpty,
            readTime: readTime ?? undefined,
            readTimeLoading: readTimeLoading
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hU34N.AISmartButtonWrapper), {
            contentId: contentId,
            contentType: contentType ?? "",
            pageMode: pageMode,
            isDisabled: isNetworkDisabled,
            spaceKey: spaceKey,
            isSidebarAvailable: isEmbeddedConfluence ? false : undefined
        })) : contentType !== "database" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $3265ee1fae39f7d6$var$collapsibleBottomSidebarStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIQbF.AIFloatingContextMenu), {
            spaceKey: spaceKey ?? "",
            contentId: contentId,
            contentType: contentType ?? "",
            lastModifiedDate: lastModifiedDate,
            pageCommentsSectionInView: pageCommentsSectionInView,
            isLivePage: isLivePage,
            isInObjectSideBar: true,
            contentIdFromQuery: contentIdFromQuery,
            contentBodyDynamic: contentBodyDynamic
        })));
        $[188] = contentBodyDynamic;
        $[189] = contentId;
        $[190] = contentIdFromQuery;
        $[191] = contentTitle;
        $[192] = contentType;
        $[193] = isEditorEmpty;
        $[194] = isEmbeddedConfluence;
        $[195] = isLivePage;
        $[196] = isNetworkDisabled;
        $[197] = isRovoButtonEnabled;
        $[198] = isUnpublishedDraft;
        $[199] = lastModifiedDate;
        $[200] = pageCommentsSectionInView;
        $[201] = pageMode;
        $[202] = readTime;
        $[203] = readTimeLoading;
        $[204] = rovoConfiguration?.experience;
        $[205] = rovoConfiguration?.provider;
        $[206] = shouldRenderAISmartButton;
        $[207] = spaceKey;
        $[208] = t29;
    } else t29 = $[208];
    let t30;
    if ($[209] !== handleMouseEnter || $[210] !== handleMouseLeave || $[211] !== t26 || $[212] !== t27 || $[213] !== t28 || $[214] !== t29) {
        t30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": t23,
            "data-vc": t24,
            style: t26,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            onFocus: handleMouseEnter,
            onBlur: handleMouseLeave,
            className: t27
        }, t28, t29);
        $[209] = handleMouseEnter;
        $[210] = handleMouseLeave;
        $[211] = t26;
        $[212] = t27;
        $[213] = t28;
        $[214] = t29;
        $[215] = t30;
    } else t30 = $[215];
    let t31;
    if ($[216] === Symbol.for("react.memo_cache_sentinel")) {
        t31 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
            metric: (0, $fgdVB.OBJECT_SIDEBAR_CONTROL_METRIC)
        });
        $[216] = t31;
    } else t31 = $[216];
    let t32;
    if ($[217] !== t30) {
        t32 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t30, t31);
        $[217] = t30;
        $[218] = t32;
    } else t32 = $[218];
    return t32;
} : ({ hasCommentsButton: hasCommentsButton, hasDetailsButton: hasDetailsButton, hasAgentReceiptButton: hasAgentReceiptButton, hasLoomButton: hasLoomButton, hasAiButton: hasAiButton, hasRemixButton: hasRemixButton, undoRedoButtonActions: undoRedoButtonActions, hasUndoRedoButton: hasUndoRedoButton, showDiffButtonActions: showDiffButtonActions, hasAudioButton: hasAudioButton, hasFeedbackButton: hasFeedbackButton = true, agentTrustReceipt: agentTrustReceipt, contentId: contentId, spaceKey: spaceKey, contentType: contentType, contentTitle: contentTitle, lastModifiedDate: lastModifiedDate, aiIsStreaming: aiIsStreaming = false, pageCommentsSectionInView: pageCommentsSectionInView, contentIdFromQuery: contentIdFromQuery, contentBodyDynamic: contentBodyDynamic, getAdfDocument: getAdfDocument, isUnpublishedDraft: isUnpublishedDraft, largeBottomPadding: largeBottomPadding, editorAIActions: editorAIActions, shouldDisableUndoRedo: shouldDisableUndoRedo = false, isDatabasesStagingArea: isDatabasesStagingArea = false, disabled: disabled, isEditorEmpty: isEditorEmpty, isMarkdownMode: isMarkdownMode, isMarkdownModeSyntaxViewToggled: isMarkdownModeSyntaxViewToggled })=>{
    const [{ isCollabOffline: isCollabOffline }] = (0, $kM55L.useCollabNetworkStatus)(); // Network status is used when:
    // - isCollabOffline: The collab provider has detected a network disconnection
    // - platform_editor_offline_editing_web: Parent experiment for offline editing experience (must be enabled)
    // - platform_editor_offline_editing_wrapper_override: Kill switch to disable this feature (must be disabled)
    const isNetworkDisabled = isCollabOffline && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false) && !(0, $9wGTI.fg)('platform_editor_offline_editing_wrapper_override');
    const { isFullScreenEmbedView: isFullScreenEmbedView } = (0, $iV5Ic.useReactProps_DO_NOT_USE)() || {};
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [actionBarIsHovered, setActionBarIsHovered] = (0, $42omo.useState)(false);
    const sidebarControlState = (0, $aWwYt.useSidebarControlState)();
    const sidebarControlExpandCollapsedState = (0, $aWwYt.useSidebarControlExpandCollapsedState)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { setSidebarControlState: setSidebarControlState, toggleObjectSidebarControl: toggleObjectSidebarControl, setSidebarControlExpandCollapsedState: setSidebarControlExpandCollapsedState } = (0, $aWwYt.useObjectSidebarActions)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const { mode: rovoExperienceMode } = (0, $8unJx.useRovoExperienceAPIStore)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    const isOnPDFExportPageRouteArgs = {
        selector: (routeName)=>{
            if (!routeName) return false;
            return routeName === (0, $1NBp8.PDF_EXPORT_PAGE).name;
        }
    };
    const isOnPDFExportPageRoute = (0, $dPJCf.useRouteName)(isOnPDFExportPageRouteArgs);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [{ isViewMode: isLiveViewMode }] = (0, $efvKr.useLivePageMode)();
    const skipReadTime = !isAdminHubAIEnabled || !isRovoButtonEnabled || pageMode !== (0, $cD1qu.PageMode).LIVE || isLiveViewMode || !(0, $9wGTI.fg)('confluence_rovo_live_doc_nudges');
    const { readTime: readTime, loading: readTimeLoading } = (0, $h2uld.useReadTime)(contentId, skipReadTime);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { isAudioV3Enabled: isAudioV3Enabled } = (0, $JTIzG.useAudioFeatureFlags)(); // whenever the contentID changes we needed to reset the action bar to be expanded
    (0, $42omo.useEffect)(()=>{
        setSidebarControlExpandCollapsedState('expanded');
    }, [
        contentId,
        setSidebarControlExpandCollapsedState
    ]);
    (0, $42omo.useEffect)(()=>{
        // Only reset to 'shown' if no sidebar panel is currently open.
        // When a panel is open (e.g. via focusedCommentId deep-link), showObjectSidebar()
        // already set sidebarControlState to 'hidden' — we must not override that here.
        if (!isObjectSidebarShown) setSidebarControlState('shown');
        setSidebarControlExpandCollapsedState('expanded');
        return ()=>{
            setSidebarControlExpandCollapsedState('collapsed');
        };
    }, [
        setSidebarControlState,
        setSidebarControlExpandCollapsedState,
        isObjectSidebarShown
    ]);
    const sidebarIsExpanded = sidebarControlExpandCollapsedState === 'expanded' || renderServerPlaceholder; // Collapsed actions are rendered when collapsed. These can be used e.g. to enable keyboard shortcuts while collapsed.
    const collapsedActions = [];
    const primaryActions = [];
    if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
    hasUndoRedoButton && undoRedoButtonActions && !isLiveViewMode && (0, $9wGTI.fg)('aifc_create_enabled') && isDatabasesStagingArea) {
        const { canUndo: canUndo, undo: undo, canRedo: canRedo, redo: redo } = undoRedoButtonActions;
        if (undo && canUndo !== undefined) primaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$UndoButton, {
            canUndo: canUndo,
            undo: undo,
            isDisabled: aiIsStreaming || shouldDisableUndoRedo
        }));
        if (redo && canRedo !== undefined) primaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$RedoButton, {
            canRedo: canRedo,
            redo: redo,
            isDisabled: aiIsStreaming || shouldDisableUndoRedo
        }));
    }
    if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
    showDiffButtonActions && !isLiveViewMode && (0, $9wGTI.fg)('aifc_create_enabled') && isDatabasesStagingArea) {
        const { onShowDiff: onShowDiff, isShowDiffEnabled: isShowDiffEnabled, isShowDiffSelected: isShowDiffSelected } = showDiffButtonActions;
        primaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$ShowDiffButton, {
            isShowDiffSelected: isShowDiffSelected,
            isShowDiffEnabled: isShowDiffEnabled && !aiIsStreaming,
            onShowDiff: onShowDiff
        }));
    }
    const secondaryActions = [];
    const secondaryActionsTeam25 = [];
    if ((0, $9wGTI.fg)('aifc_create_enabled')) {
        if (hasCommentsButton) {
            secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$CommentPanelButton, {
                key: "comment-panel-button",
                contentId: contentId,
                isDisabled: isNetworkDisabled
            }));
            if (!sidebarIsExpanded) collapsedActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$CommentPanelButton, {
                key: "comment-panel-button-collapsed",
                contentId: contentId,
                collapsed: true,
                isDisabled: isNetworkDisabled
            }));
        }
        if (hasDetailsButton) {
            secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$DetailsPanelButton, {
                key: "details-panel-button",
                contentId: contentId,
                isDisabled: isNetworkDisabled
            }));
            if (!sidebarIsExpanded) collapsedActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$DetailsPanelButton, {
                key: "details-panel-button-collapsed",
                contentId: contentId,
                collapsed: true,
                isDisabled: isNetworkDisabled
            }));
        }
        if (hasAgentReceiptButton && agentTrustReceipt) secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$AgentReceiptPanelButton, {
            key: "agent-receipt-panel-button",
            receipt: agentTrustReceipt,
            isDisabled: isNetworkDisabled
        }));
        if ((0, $6mKj3.isExperimentEnabled)('enterprise_her')) secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d34346cf549a725a$export$2501aa4690daf770), {
            key: "enterprise-her-button-wrapper",
            contentId: contentId,
            contentType: contentType ?? ''
        }));
        if (hasAudioButton) {
            if (isAudioV3Enabled) secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$AudioListenButtonWrapper, {
                key: "audio-listen-button-wrapper",
                isRovoButtonEnabled: isRovoButtonEnabled,
                contentId: contentId,
                contentType: contentType ?? '',
                isLivePage: isLivePage,
                spaceKey: spaceKey ?? '',
                title: contentTitle ?? '',
                isAutoOpenDisabled: disabled
            }));
            else secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46bbba5af56c1c8e$export$6210e0bba7c89213), {
                key: "audio-button-loader-wrapper",
                contentId: contentId,
                contentType: contentType,
                spaceKey: spaceKey,
                contentTitle: contentTitle,
                isDisabled: isNetworkDisabled,
                isView: pageMode === (0, $cD1qu.PageMode).VIEW
            }));
        }
        if (hasLoomButton && !isLoomDisabled) secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $D7PHQ.PageHeaderLoomEntryPoint), {
            key: "page-header-loom-entry-point",
            contentId: contentId,
            crossSellPopupPlacement: "left-end",
            crossSellSpotlightPlacement: "left-start",
            spaceKey: spaceKey ?? '',
            contentType: contentType ?? '',
            isCircle: !isRovoButtonEnabled,
            testId: "sidebar-loom-button",
            source: "contentWrapper",
            isDisabled: isNetworkDisabled
        }));
        if (editorAIActions) secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$EditorAIActions, {
            key: "editor-ai-actions",
            editorAIActions: editorAIActions,
            isDisabled: aiIsStreaming
        }));
        if (hasRemixButton && (0, $6mKj3.expValEquals)('cc-maui-object-level-remix-experiment', 'isEnabled', true)) {
            const remixButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$RemixPanelButton, {
                key: "remix-panel-button",
                contentBodyValue: contentBodyDynamic?.value,
                getAdfDocument: getAdfDocument,
                isEditorEmpty: isEditorEmpty,
                isDisabled: isNetworkDisabled
            });
            secondaryActionsTeam25.push(remixButton);
        }
    } else {
        if (hasCommentsButton) {
            primaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$CommentPanelButton, {
                key: "comment-panel-button",
                contentId: contentId,
                isDisabled: isNetworkDisabled
            }));
            if (!sidebarIsExpanded) collapsedActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$CommentPanelButton, {
                key: "comment-panel-button-collapsed",
                contentId: contentId,
                collapsed: true,
                isDisabled: isNetworkDisabled
            }));
        }
        if (hasDetailsButton) {
            primaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$DetailsPanelButton, {
                key: "details-panel-button",
                contentId: contentId,
                isDisabled: isNetworkDisabled
            }));
            if (!sidebarIsExpanded) collapsedActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$DetailsPanelButton, {
                key: "details-panel-button-collapsed",
                contentId: contentId,
                collapsed: true,
                isDisabled: isNetworkDisabled
            }));
        }
        if (hasAgentReceiptButton && agentTrustReceipt) primaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$AgentReceiptPanelButton, {
            key: "agent-receipt-panel-button",
            receipt: agentTrustReceipt,
            isDisabled: isNetworkDisabled
        }));
        if (hasAudioButton) {
            if (isAudioV3Enabled) secondaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$AudioListenButtonWrapper, {
                key: "audio-listen-button-wrapper",
                isRovoButtonEnabled: isRovoButtonEnabled,
                contentId: contentId,
                contentType: contentType ?? '',
                isLivePage: isLivePage,
                spaceKey: spaceKey ?? '',
                title: contentTitle ?? '',
                isAutoOpenDisabled: disabled
            }));
            else secondaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46bbba5af56c1c8e$export$6210e0bba7c89213), {
                key: "audio-button-loader-wrapper",
                contentId: contentId,
                contentType: contentType,
                spaceKey: spaceKey,
                contentTitle: contentTitle,
                isDisabled: isNetworkDisabled,
                isView: pageMode === (0, $cD1qu.PageMode).VIEW
            }));
        }
        if (hasLoomButton && !isLoomDisabled) secondaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $D7PHQ.PageHeaderLoomEntryPoint), {
            key: "page-header-loom-entry-point",
            contentId: contentId,
            crossSellPopupPlacement: "left-end",
            crossSellSpotlightPlacement: "left-start",
            spaceKey: spaceKey ?? '',
            contentType: contentType ?? '',
            isCircle: !isRovoButtonEnabled,
            testId: "sidebar-loom-button",
            source: "contentWrapper",
            isDisabled: isNetworkDisabled
        }));
        if (hasFeedbackButton) secondaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$FeedbackCollectorButton, {
            key: "feedback-collector-button",
            contentId: contentId,
            isDisabled: isNetworkDisabled
        }));
    }
    const rovoConfiguration = (0, $42omo.useMemo)(()=>{
        if (pageMode === (0, $cD1qu.PageMode).VIEW || pageMode === (0, $cD1qu.PageMode).LIVE && isLiveViewMode) return {
            experience: (0, $dppWL.RegisteredExperience).VIEW_PAGE,
            provider: (0, $2b7ed8ae830eb95a$export$299010de885adda)
        };
        if (pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE && !isLiveViewMode) return {
            experience: (0, $dppWL.RegisteredExperience).EDIT_PAGE,
            provider: (0, $7e583ad86f1e8aa8$export$d95c465cd9bfae9f)
        };
        return undefined;
    }, [
        pageMode,
        isLiveViewMode
    ]);
    if (isOnPDFExportPageRoute) return null;
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)(); // For databases in staging area, always allow rendering (isFullScreenEmbedView is typically undefined)
    const shouldRenderWhenEmbedded = isEmbeddedConfluence ? isDatabasesStagingArea || isFullScreenEmbedView : !isEmbeddedConfluence; // If there's no AI button, when we collapse the action bar, we need to render an expand icon within the
    // existing action bar container. If there is an AI button, hovering over it should render the expand icon
    const shouldRenderIntegratedExpandButton = !hasAiButton && !sidebarIsExpanded; // We always render the toggle component into the DOM, but we change its visibility based on:
    // If the action bar is expanded: show on hover (regardless of AI button)
    // If the action bar is collapsed: always show if AI button present, otherwise never show
    const shouldDisplayHoverToggle = sidebarIsExpanded && actionBarIsHovered || hasAiButton && !sidebarIsExpanded;
    const shouldRenderAISmartButton = hasAiButton && shouldRenderWhenEmbedded && !isMobileApp;
    const isRovoMiniModalShown = shouldRenderAISmartButton && isRovoButtonEnabled && rovoExperienceMode === (0, $hR4U4.ConversationAssistantUIModes).MINI_MODAL;
    const handleMouseEnter = ()=>{
        setActionBarIsHovered(true);
    };
    const handleMouseLeave = ()=>{
        setActionBarIsHovered(false);
    };
    const onToggleClick = ()=>{
        toggleObjectSidebarControl(); // need to make sure the hover (dis)appears after clicking it
        setActionBarIsHovered(!sidebarIsExpanded);
    };
    const toggleLabel = sidebarIsExpanded ? formatMessage($3265ee1fae39f7d6$var$i18n.collapseToggleLabel) : formatMessage($3265ee1fae39f7d6$var$i18n.expandToggleLabel);
    const integratedExpandButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        position: "left",
        content: formatMessage($3265ee1fae39f7d6$var$i18n.expandToggleLabel),
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
                ...iconProps,
                size: "small"
            }),
        label: toggleLabel,
        onClick: toggleObjectSidebarControl,
        shape: "circle",
        testId: "integrated-expand-button"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "object-sidebar-container",
        "data-vc": "object-sidebar-container",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            right: pageMode === (0, $cD1qu.PageMode).VIEW ? `calc(var(${$3265ee1fae39f7d6$var$hoistedNav4RightSlotWidthVar}, 0px))` : '0px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            marginRight: 0
        },
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleMouseEnter,
        onBlur: handleMouseLeave,
        className: (0, $gMc0m.default)([
            "_v564ul29 _kqsw1n9t _94n5idpf _1pbyowjs _lcxvglyw _w1y61wug",
            isMarkdownMode && isMarkdownModeSyntaxViewToggled && (0, $9wGTI.fg)('platform_editor_md_mvp_layout') && "_94n51jfw",
            (contentType === 'page' || contentType === 'blogpost' || pageMode === (0, $cD1qu.PageMode).VIEW) && "_u5f31ejb _n3tdu2gc",
            (contentType === 'database' || contentType === 'slide') && "_u5f3u2gc _n3tdu2gc",
            largeBottomPadding && "_n3td1ejb",
            isRovoMiniModalShown && "_1pby16oo",
            pageMode === (0, $cD1qu.PageMode).VIEW && !isRovoMiniModalShown && !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && "_1pbykb7n",
            pageMode === (0, $cD1qu.PageMode).VIEW && !isRovoMiniModalShown && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && "_1pbycs5v",
            !renderServerPlaceholder && sidebarControlState === 'hidden' && "_1e0cglyw"
        ])
    }, primaryActions.length + secondaryActions.length + secondaryActionsTeam25.length > 0 && shouldRenderWhenEmbedded && !isMobileApp && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6cnUO.default), null, (0, $9wGTI.fg)('confluence_frontend_spotlight_ads_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1bsboahv _18u01wug"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        position: "left",
        content: toggleLabel,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: {
            paddingBottom: sidebarIsExpanded ? `${"var(--ds-space-100, 8px)"}` : undefined,
            visibility: shouldDisplayHoverToggle ? 'visible' : 'hidden'
        },
        "data-testid": "collapsible-hover-toggle",
        className: (0, $gMc0m.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _1bsbxy5q"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (iconProps_0)=>sidebarIsExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                ...iconProps_0,
                size: "small"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
                ...iconProps_0,
                size: "small"
            }),
        label: toggleLabel,
        onClick: onToggleClick,
        shape: "circle",
        testId: "collapsible-hover-button"
    })))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).OBJECT_SIDEBAR_CONTROL
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1bsboahv _18u01wug"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        position: "left",
        content: toggleLabel,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: {
            paddingBottom: sidebarIsExpanded ? `${"var(--ds-space-100, 8px)"}` : undefined,
            visibility: shouldDisplayHoverToggle ? 'visible' : 'hidden'
        },
        "data-testid": "collapsible-hover-toggle",
        className: (0, $gMc0m.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _1bsbxy5q"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (iconProps_1)=>sidebarIsExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                ...iconProps_1,
                size: "small"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
                ...iconProps_1,
                size: "small"
            }),
        label: toggleLabel,
        onClick: onToggleClick,
        shape: "circle",
        testId: "collapsible-hover-button"
    }))))), (0, $9wGTI.fg)('confluence_frontend_spotlight_ads_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1bsboahv _18u01wug"
        ])
    }, sidebarIsExpanded || renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        xcss: isRovoButtonEnabled ? (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'isEnabled', true) ? $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles : (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'isEnabled', true) ? $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles,
        direction: "column",
        gap: "space.100",
        justifyContent: "center",
        alignItems: "center",
        testId: "object-sidebar-control"
    }, primaryActions, (0, $9wGTI.fg)('aifc_create_enabled') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, primaryActions.length > 0 && secondaryActionsTeam25.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $3265ee1fae39f7d6$var$dividerStyle
    }), secondaryActionsTeam25) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, secondaryActions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $3265ee1fae39f7d6$var$dividerStyle
    }), secondaryActions)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, collapsedActions))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1bsboahv _18u01wug"
        ])
    }, sidebarIsExpanded || renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        xcss: isRovoButtonEnabled ? (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'isEnabled', true) ? $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles : (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'isEnabled', true) ? $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles,
        direction: "column",
        gap: "space.100",
        justifyContent: "center",
        alignItems: "center",
        testId: "object-sidebar-control"
    }, primaryActions, (0, $9wGTI.fg)('aifc_create_enabled') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, primaryActions.length > 0 && secondaryActionsTeam25.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $3265ee1fae39f7d6$var$dividerStyle
    }), secondaryActionsTeam25) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, secondaryActions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $3265ee1fae39f7d6$var$dividerStyle
    }), secondaryActions)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, collapsedActions)), shouldRenderIntegratedExpandButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1bsboahv _18u01wug"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        xcss: isRovoButtonEnabled ? (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'isEnabled', true) ? $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles : (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'isEnabled', true) ? $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles,
        direction: "column",
        gap: "space.100",
        justifyContent: "center",
        alignItems: "center",
        testId: "object-sidebar-control"
    }, integratedExpandButton)) : null, (0, $9wGTI.fg)('confluence_frontend_spotlight_ads_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$ObjectSidebarSpotlightTour, {
        contentId: contentId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3265ee1fae39f7d6$var$ObjectSidebarSpotlightTour, {
        contentId: contentId
    }))), shouldRenderAISmartButton && (isRovoButtonEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_ca0qu2gc _otyrpxbi _18u0t94y"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3tUdX.RovoConfigProvider), {
        experience: rovoConfiguration?.experience,
        provider: rovoConfiguration?.provider,
        contentId: contentId,
        contentType: contentType ?? '',
        spaceKey: spaceKey ?? '',
        contentTitle: contentTitle ?? '',
        lastModifiedDate: lastModifiedDate,
        isUnpublishedDraft: isUnpublishedDraft,
        isEditorEmpty: isEditorEmpty,
        readTime: readTime ?? undefined,
        readTimeLoading: readTimeLoading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hU34N.AISmartButtonWrapper), {
        contentId: contentId,
        contentType: contentType ?? '',
        pageMode: pageMode,
        isDisabled: isNetworkDisabled,
        spaceKey: spaceKey,
        isSidebarAvailable: isEmbeddedConfluence ? false : undefined
    })) : contentType !== 'database' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $3265ee1fae39f7d6$var$collapsibleBottomSidebarStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIQbF.AIFloatingContextMenu), {
        spaceKey: spaceKey ?? '',
        contentId: contentId,
        contentType: contentType ?? '',
        lastModifiedDate: lastModifiedDate,
        pageCommentsSectionInView: pageCommentsSectionInView,
        isLivePage: isLivePage,
        isInObjectSideBar: true,
        contentIdFromQuery: contentIdFromQuery,
        contentBodyDynamic: contentBodyDynamic
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
        metric: (0, $fgdVB.OBJECT_SIDEBAR_CONTROL_METRIC)
    }));
});
function $3265ee1fae39f7d6$var$_temp(routeName) {
    if (!routeName) return false;
    return routeName === (0, $1NBp8.PDF_EXPORT_PAGE).name;
}
function $3265ee1fae39f7d6$var$_temp2(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
        ...iconProps,
        size: "small"
    });
}
module.exports["ObjectSidebarControl"] = $3265ee1fae39f7d6$export$3fab07431350539e;

});

parcelRegister("8unJx", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $kPbXZ = parcelRequire("kPbXZ");

const $d1d2403974de0af3$var$initialState = {
    mode: undefined,
    isMiniModalAvailable: false,
    isSidebarAvailable: true,
    isFullScreenModalAvailable: false,
    initialPrompt: undefined,
    wasAutoOpened: false
};
const $d1d2403974de0af3$var$store = (0, $1P1Tu.createStore)({
    name: 'rovoExperienceAPIStore',
    initialState: $d1d2403974de0af3$var$initialState,
    actions: {
        // created for resetting store during tests
        reset: ()=>({ setState: setState })=>{
                setState($d1d2403974de0af3$var$initialState);
            },
        setMode: (mode)=>({ setState: setState })=>{
                setState({
                    mode: mode,
                    wasAutoOpened: false
                });
            },
        clearInitialPrompt: ()=>({ setState: setState })=>{
                setState({
                    initialPrompt: undefined
                });
            },
        setWasAutoOpened: (wasAutoOpened)=>({ setState: setState })=>{
                setState({
                    wasAutoOpened: wasAutoOpened
                });
            },
        toggleConversationAssistantUIMode: ({ targetMode: targetMode, sidebarApi: sidebarApi, initialPrompt: initialPrompt })=>({ getState: getState, setState: setState })=>{
                const { mode: currentMode } = getState();
                // If no target mode is provided, close any open modes
                if (!targetMode) {
                    setState({
                        mode: undefined,
                        wasAutoOpened: false
                    });
                    if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                    return;
                }
                // Toggle mode functionality
                if (currentMode === targetMode) switch(targetMode){
                    case (0, $kPbXZ.ConversationAssistantUIModes).SIDEBAR:
                        /* Handles the edge case where the sidebar space is taken by another panel
              which results in currentMode = 'sidebar' && sidebarApi.isSidebarOpen() = false */ if (!sidebarApi.isSidebarOpen()) {
                            sidebarApi.openSidebar();
                            return;
                        }
                        sidebarApi.closeSidebar();
                        setState({
                            mode: undefined,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $kPbXZ.ConversationAssistantUIModes).MINI_MODAL:
                        setState({
                            mode: undefined,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $kPbXZ.ConversationAssistantUIModes).FULL_SCREEN_MODAL:
                        setState({
                            mode: undefined,
                            wasAutoOpened: false
                        });
                        return;
                    default:
                        return;
                }
                // Switch mode functionality
                switch(targetMode){
                    case (0, $kPbXZ.ConversationAssistantUIModes).SIDEBAR:
                        if (!sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                        setState({
                            mode: (0, $kPbXZ.ConversationAssistantUIModes).SIDEBAR,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $kPbXZ.ConversationAssistantUIModes).MINI_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        setState({
                            mode: (0, $kPbXZ.ConversationAssistantUIModes).MINI_MODAL,
                            initialPrompt: initialPrompt,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $kPbXZ.ConversationAssistantUIModes).FULL_SCREEN_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        setState({
                            mode: (0, $kPbXZ.ConversationAssistantUIModes).FULL_SCREEN_MODAL,
                            initialPrompt: initialPrompt,
                            wasAutoOpened: false
                        });
                        return;
                }
            },
        openConversationAssistantUIMode: ({ targetMode: targetMode, sidebarApi: sidebarApi, initialPrompt: initialPrompt })=>({ getState: getState, setState: setState })=>{
                const { mode: currentMode } = getState();
                // Already in the desired mode — ensure the sidebar is actually
                // visible (it may have been displaced by another panel) but
                // otherwise treat this as a no-op.
                if (currentMode === targetMode) {
                    if (targetMode === (0, $kPbXZ.ConversationAssistantUIModes).SIDEBAR && !sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                    return;
                }
                // Switch to the target mode
                switch(targetMode){
                    case (0, $kPbXZ.ConversationAssistantUIModes).SIDEBAR:
                        if (!sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                        setState({
                            mode: (0, $kPbXZ.ConversationAssistantUIModes).SIDEBAR,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $kPbXZ.ConversationAssistantUIModes).MINI_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        // wasAutoOpened is managed by the dedicated setWasAutoOpened action and reset on close/toggle/setMode.
                        setState({
                            mode: (0, $kPbXZ.ConversationAssistantUIModes).MINI_MODAL,
                            initialPrompt: initialPrompt
                        });
                        return;
                    case (0, $kPbXZ.ConversationAssistantUIModes).FULL_SCREEN_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        setState({
                            mode: (0, $kPbXZ.ConversationAssistantUIModes).FULL_SCREEN_MODAL,
                            initialPrompt: initialPrompt
                        });
                        return;
                }
            },
        setIsMiniModalAvailable: (isMiniModalAvailable)=>({ setState: setState })=>{
                setState({
                    isMiniModalAvailable: isMiniModalAvailable
                });
            },
        setIsSidebarAvailable: (isSidebarAvailable)=>({ setState: setState })=>{
                setState({
                    isSidebarAvailable: isSidebarAvailable
                });
            },
        setIsFullScreenModalAvailable: (isFullScreenModalAvailable)=>({ setState: setState })=>{
                setState({
                    isFullScreenModalAvailable: isFullScreenModalAvailable
                });
            }
    }
});
const $d1d2403974de0af3$var$useStore = (0, $9zUhf.createHook)($d1d2403974de0af3$var$store);
const $d1d2403974de0af3$export$37440b51449f7ac6 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(15);
    const [t0, t1] = $d1d2403974de0af3$var$useStore();
    const { mode: mode, isMiniModalAvailable: isMiniModalAvailable, isSidebarAvailable: isSidebarAvailable, isFullScreenModalAvailable: isFullScreenModalAvailable, initialPrompt: initialPrompt, wasAutoOpened: wasAutoOpened } = t0;
    const { reset: reset, clearInitialPrompt: clearInitialPrompt, setWasAutoOpened: setWasAutoOpened, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, openConversationAssistantUIMode: openConversationAssistantUIMode, setIsMiniModalAvailable: setIsMiniModalAvailable, setIsSidebarAvailable: setIsSidebarAvailable, setIsFullScreenModalAvailable: setIsFullScreenModalAvailable } = t1;
    let t2;
    if ($[0] !== clearInitialPrompt || $[1] !== initialPrompt || $[2] !== isFullScreenModalAvailable || $[3] !== isMiniModalAvailable || $[4] !== isSidebarAvailable || $[5] !== mode || $[6] !== openConversationAssistantUIMode || $[7] !== reset || $[8] !== setIsFullScreenModalAvailable || $[9] !== setIsMiniModalAvailable || $[10] !== setIsSidebarAvailable || $[11] !== setWasAutoOpened || $[12] !== toggleConversationAssistantUIMode || $[13] !== wasAutoOpened) {
        t2 = {
            mode: mode,
            initialPrompt: initialPrompt,
            wasAutoOpened: wasAutoOpened,
            reset: reset,
            clearInitialPrompt: clearInitialPrompt,
            setWasAutoOpened: setWasAutoOpened,
            toggleConversationAssistantUIMode: toggleConversationAssistantUIMode,
            openConversationAssistantUIMode: openConversationAssistantUIMode,
            setIsMiniModalAvailable: setIsMiniModalAvailable,
            setIsSidebarAvailable: setIsSidebarAvailable,
            setIsFullScreenModalAvailable: setIsFullScreenModalAvailable,
            isMiniModalAvailable: isMiniModalAvailable,
            isSidebarAvailable: isSidebarAvailable,
            isFullScreenModalAvailable: isFullScreenModalAvailable
        };
        $[0] = clearInitialPrompt;
        $[1] = initialPrompt;
        $[2] = isFullScreenModalAvailable;
        $[3] = isMiniModalAvailable;
        $[4] = isSidebarAvailable;
        $[5] = mode;
        $[6] = openConversationAssistantUIMode;
        $[7] = reset;
        $[8] = setIsFullScreenModalAvailable;
        $[9] = setIsMiniModalAvailable;
        $[10] = setIsSidebarAvailable;
        $[11] = setWasAutoOpened;
        $[12] = toggleConversationAssistantUIMode;
        $[13] = wasAutoOpened;
        $[14] = t2;
    } else t2 = $[14];
    return t2;
} : ()=>{
    const [{ mode: mode, isMiniModalAvailable: isMiniModalAvailable, isSidebarAvailable: isSidebarAvailable, isFullScreenModalAvailable: isFullScreenModalAvailable, initialPrompt: initialPrompt, wasAutoOpened: wasAutoOpened }, { reset: reset, clearInitialPrompt: clearInitialPrompt, setWasAutoOpened: setWasAutoOpened, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, openConversationAssistantUIMode: openConversationAssistantUIMode, setIsMiniModalAvailable: setIsMiniModalAvailable, setIsSidebarAvailable: setIsSidebarAvailable, setIsFullScreenModalAvailable: setIsFullScreenModalAvailable }] = $d1d2403974de0af3$var$useStore();
    return {
        mode: mode,
        initialPrompt: initialPrompt,
        wasAutoOpened: wasAutoOpened,
        reset: reset,
        clearInitialPrompt: clearInitialPrompt,
        setWasAutoOpened: setWasAutoOpened,
        toggleConversationAssistantUIMode: toggleConversationAssistantUIMode,
        openConversationAssistantUIMode: openConversationAssistantUIMode,
        setIsMiniModalAvailable: setIsMiniModalAvailable,
        setIsSidebarAvailable: setIsSidebarAvailable,
        setIsFullScreenModalAvailable: setIsFullScreenModalAvailable,
        isMiniModalAvailable: isMiniModalAvailable,
        isSidebarAvailable: isSidebarAvailable,
        isFullScreenModalAvailable: isFullScreenModalAvailable
    };
};
const $d1d2403974de0af3$export$66cf76b7e04da11f = (0, $9zUhf.createActionsHook)($d1d2403974de0af3$var$store);
module.exports["useRovoExperienceAPIStore"] = $d1d2403974de0af3$export$37440b51449f7ac6;

});

parcelRegister("kPbXZ", function(module, exports) {
/* Duplicates ConversationAssistantUIModes from conversation-assistant package
   to avoid circular dependencies. Any changes here should be mirrored in
	 platform/packages/ai-mate/conversation-assistant/src/types.ts
*/ const $053d47555d884138$export$bc36ebf73899a71d = {
    SIDEBAR: 'sidebar',
    MINI_MODAL: 'mini-modal',
    FULL_SCREEN_MODAL: 'full-screen-modal'
};
module.exports["ConversationAssistantUIModes"] = $053d47555d884138$export$bc36ebf73899a71d;

});

parcelRegister("hR4U4", function(module, exports) {
const $991dc85317754fda$export$bc36ebf73899a71d = {
    SIDEBAR: 'sidebar',
    MINI_MODAL: 'mini-modal',
    FULL_SCREEN_MODAL: 'full-screen-modal'
};
module.exports["ConversationAssistantUIModes"] = $991dc85317754fda$export$bc36ebf73899a71d;

});

parcelRegister("JTIzG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");

var $27a67c702eae1a5a$export$419c8aa8913e9327 = /*#__PURE__*/ function(BriefingNudgeExperimentState) {
    BriefingNudgeExperimentState["CONTROL"] = "control";
    BriefingNudgeExperimentState["NUDGE"] = "nudge";
    BriefingNudgeExperimentState["NUDGE_AUTOPLAY"] = "nudge_autoplay";
    return BriefingNudgeExperimentState;
}({});
const $27a67c702eae1a5a$export$df5bf03825b93c3d = ()=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isAIEarlyAccessEnabled: isAIEarlyAccessEnabled, isAtlassianHostedLLMOnlyEnabled: isAtlassianHostedLLMOnlyEnabled } = (0, $bQm3c.useSessionData)();
    // Deferred: MediaSource is unavailable during SSR
    const [audioSupportedByBrowser, setAudioSupportedByBrowser] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        setAudioSupportedByBrowser(typeof MediaSource !== 'undefined' && MediaSource.isTypeSupported('audio/mpeg'));
    }, []);
    const isAHMOnlyEnabled = (0, $42omo.useMemo)(()=>isAtlassianHostedLLMOnlyEnabled && (0, $6mKj3.isExperimentEnabled)('confluence_audio_disable_if_ahm_enabled'), [
        isAtlassianHostedLLMOnlyEnabled
    ]);
    const isAIPolicyAndBrowserSupportEnabled = (0, $42omo.useMemo)(()=>isAdminHubAIEnabled && // AdminHub AI is enabled
        isAIEarlyAccessEnabled && // AI Early Access is enabled
        audioSupportedByBrowser && // Audio is supported by browser
        !isAHMOnlyEnabled, [
        isAdminHubAIEnabled,
        isAIEarlyAccessEnabled,
        audioSupportedByBrowser,
        isAHMOnlyEnabled
    ]);
    const isAudioV3Enabled = (0, $42omo.useMemo)(()=>isAIPolicyAndBrowserSupportEnabled && (0, $6mKj3.isExperimentEnabled)('confluence_audio_v3'), [
        isAIPolicyAndBrowserSupportEnabled
    ]);
    const isAudioBylineEntrypointEnabled = (0, $42omo.useMemo)(()=>isAIPolicyAndBrowserSupportEnabled && (0, $6mKj3.isExperimentEnabled)('confluence_ai_consumption_byline'), [
        isAIPolicyAndBrowserSupportEnabled
    ]);
    const audioBriefingNudgeExperimentState = (0, $42omo.useMemo)(()=>{
        if (!isAudioV3Enabled) return "control";
        if ((0, $6mKj3.expValEquals)('confluence_audio_v3_briefing_nudge', 'variant', 'nudge')) return "nudge";
        else if ((0, $6mKj3.expValEquals)('confluence_audio_v3_briefing_nudge', 'variant', 'nudge_autoplay')) return "nudge_autoplay";
        else return "control";
    }, [
        isAudioV3Enabled
    ]);
    return {
        isAIPolicyAndBrowserSupportEnabled: isAIPolicyAndBrowserSupportEnabled,
        isAudioV3Enabled: isAudioV3Enabled,
        isAudioBylineEntrypointEnabled: isAudioBylineEntrypointEnabled,
        audioBriefingNudgeExperimentState: audioBriefingNudgeExperimentState
    };
};
module.exports["BriefingNudgeExperimentState"] = $27a67c702eae1a5a$export$419c8aa8913e9327;
module.exports["useAudioFeatureFlags"] = $27a67c702eae1a5a$export$df5bf03825b93c3d;

});

parcelRegister("8uM2K", function(module, exports) {

var $5spQU = parcelRequire("5spQU");


var $bQm3c = parcelRequire("bQm3c");

const $214157f3efbb250b$export$dcc461521a57aee7 = ()=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    // environment-aware enablement via feature encoding
    const isAIFeatureEnabled = (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-ai');
    return isAIFeatureEnabled && isAdminHubAIEnabled && isRovoLLMEnabled;
};
module.exports["useAIRovoButtonEnablement"] = $214157f3efbb250b$export$dcc461521a57aee7;

});

parcelRegister("dppWL", function(module, exports) {
/* eslint-disable @typescript-eslint/consistent-type-imports */ var $56fbda2769629a59$export$50526ee9b1846f6c = /*#__PURE__*/ function(RegisteredExperience) {
    RegisteredExperience["VIEW_PAGE"] = "view-page";
    RegisteredExperience["EDIT_PAGE"] = "edit-page";
    RegisteredExperience["WHITEBOARD"] = "whiteboard";
    RegisteredExperience["SEARCH_PAGE"] = "search-page";
    return RegisteredExperience;
}({});
const $56fbda2769629a59$export$1e3f84bae31640f2 = (props)=>'actionsToRender' in props;
const $56fbda2769629a59$export$9fdd72360ade08c0 = (props)=>'contentType' in props;
const $56fbda2769629a59$export$b8a252bbcf90a2cb = (props)=>'getSearchQuery' in props;
module.exports["RegisteredExperience"] = $56fbda2769629a59$export$50526ee9b1846f6c;
module.exports["isWhiteboardRovoConfigProviderProps"] = $56fbda2769629a59$export$1e3f84bae31640f2;
module.exports["isPageRovoConfigProviderProps"] = $56fbda2769629a59$export$9fdd72360ade08c0;

});

parcelRegister("3tUdX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dppWL = parcelRequire("dppWL");


var $amW67 = parcelRequire("amW67");


var $8hjAS = parcelRequire("8hjAS");

const $f4bf02d66e85d52a$export$44a9046b553a8167 = (props)=>{
    if (props.experience === (0, $dppWL.RegisteredExperience).WHITEBOARD && !(0, $dppWL.isWhiteboardRovoConfigProviderProps)(props)) return null;
    if ((props.experience === (0, $dppWL.RegisteredExperience).VIEW_PAGE || props.experience === (0, $dppWL.RegisteredExperience).EDIT_PAGE) && !(0, $dppWL.isPageRovoConfigProviderProps)(props)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $amW67.RovoConfigProviderContextProvider), {
        value: props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8hjAS.RovoCurrentConfigProvider), {
        provider: props.provider
    }));
};
module.exports["RovoConfigProvider"] = $f4bf02d66e85d52a$export$44a9046b553a8167;

});

parcelRegister("amW67", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $23a8183fa434531d$var$RovoConfigProviderContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $23a8183fa434531d$export$3ae1f97e9390a638 = ()=>{
    const context = (0, $42omo.useContext)($23a8183fa434531d$var$RovoConfigProviderContext);
    if (!context) throw new Error('useRovoConfigProviderProps must be used within an RovoConfigProviderContext.Provider');
    return context;
};
const $23a8183fa434531d$export$45b0916bb24b31be = ({ children: children, value: value })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($23a8183fa434531d$var$RovoConfigProviderContext.Provider, {
        value: value
    }, children);
};
module.exports["useRovoConfigProviderProps"] = $23a8183fa434531d$export$3ae1f97e9390a638;
module.exports["RovoConfigProviderContextProvider"] = $23a8183fa434531d$export$45b0916bb24b31be;

});

parcelRegister("8hjAS", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $42omo = parcelRequire("42omo");


var $hnvzE = parcelRequire("hnvzE");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $8MKuN = parcelRequire("8MKuN");


var $6mKj3 = parcelRequire("6mKj3");


var $5ruin = parcelRequire("5ruin");

const $4d3968fc98119c84$export$9ef355ca939f0be9 = ({ provider: provider })=>{
    const { resetConfiguration: resetConfiguration, setConfiguration: setConfiguration } = (0, $5ruin.useRovoCurrentConfigStoreActions)();
    (0, $42omo.useEffect)(()=>{
        if (!provider) resetConfiguration();
        return ()=>{
            resetConfiguration();
        };
    }, [
        resetConfiguration,
        provider
    ]);
    if (!provider) return null;
    const ActiveProviderComponent = provider;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).SMARTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
        name: "rovo-current-configuration-provider"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ActiveProviderComponent, {
        setConfiguration: setConfiguration
    })));
    return (0, $6mKj3.expVal)('confluence_edit_page_conditional_ufohold_ignore', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8MKuN.ConditionalUfoHoldIgnore), null, content) : content;
};
module.exports["RovoCurrentConfigProvider"] = $4d3968fc98119c84$export$9ef355ca939f0be9;

});

parcelRegister("8MKuN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4u5NT = parcelRequire("4u5NT");


var $b1Jpy = parcelRequire("b1Jpy");

const $88668855474bc367$export$27cee8d00af73bce = [
    'edit-page.page_load',
    'edit-page.transition',
    'space-overview-edit-page.page_load',
    'space-overview-edit-page.transition',
    'live-edit.page_load',
    'live-edit.transition'
];
function $88668855474bc367$export$2510d15b8c74a469({ children: children, excludedInteractions: excludedInteractions = $88668855474bc367$export$27cee8d00af73bce }) {
    // Capture the interaction once at mount time to ensure stable behavior for the
    // component's lifetime. getActiveInteraction() can return null mid-render cycle
    // if the UFO interaction ends, which would cause the ignore prop to toggle
    // between renders and effectively un-ignore the hold on a subsequent re-render.
    const ignoreHoldsRef = (0, $42omo.useRef)(null);
    if (ignoreHoldsRef.current === null) {
        const interaction = (0, $4u5NT.getActiveInteraction)();
        if (interaction) {
            const { type: type, ufoName: ufoName } = interaction;
            ignoreHoldsRef.current = excludedInteractions.includes(`${ufoName}.${type}`);
        } else ignoreHoldsRef.current = false;
    }
    const ignoreHolds = ignoreHoldsRef.current ?? false;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b1Jpy.default), {
        ignore: ignoreHolds
    }, children);
}
module.exports["ConditionalUfoHoldIgnore"] = $88668855474bc367$export$2510d15b8c74a469;

});

parcelRegister("5ruin", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $2b71e6bc29f732db$var$noopConfiguration = {
    getActions: async ()=>[]
};
const $2b71e6bc29f732db$var$initialState = {
    configuration: $2b71e6bc29f732db$var$noopConfiguration
};
const $2b71e6bc29f732db$var$actions = {
    setConfiguration: (configuration)=>({ setState: setState })=>{
            setState({
                configuration: configuration
            });
        },
    resetConfiguration: ()=>({ setState: setState })=>{
            setState({
                configuration: $2b71e6bc29f732db$var$noopConfiguration
            });
        },
    updateConfiguration: (configuration)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                configuration: {
                    ...state.configuration,
                    ...configuration
                }
            });
        }
};
const $2b71e6bc29f732db$export$e0afd2e658e4f7ce = (0, $1P1Tu.createStore)({
    initialState: $2b71e6bc29f732db$var$initialState,
    actions: $2b71e6bc29f732db$var$actions,
    name: 'RovoCurrentConfigStore'
});
const $2b71e6bc29f732db$export$2cefdfe72db08be4 = (0, $9zUhf.createActionsHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce);
const $2b71e6bc29f732db$export$d7809b5c7bef1f6d = (0, $9zUhf.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration
});
const $2b71e6bc29f732db$export$897f16b7b08b0ac = (0, $9zUhf.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.getActions
});
const $2b71e6bc29f732db$export$1e0546f83460b30d = (0, $9zUhf.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.tags
});
const $2b71e6bc29f732db$export$2a73ca2333c94154 = (0, $9zUhf.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.customGreeting
});
const $2b71e6bc29f732db$export$9d0f592eafe765c0 = (0, $9zUhf.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.shouldShowGreeting
});
const $2b71e6bc29f732db$export$6745aa6ec6db525a = (0, $9zUhf.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.prioritizeCustomActionResults
});
const $2b71e6bc29f732db$export$77b1364ae13e9bf5 = (0, $9zUhf.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.numStartersToShow
});
module.exports["useRovoCurrentConfigStoreActions"] = $2b71e6bc29f732db$export$2cefdfe72db08be4;
module.exports["useRovoConfigGetActions"] = $2b71e6bc29f732db$export$897f16b7b08b0ac;
module.exports["useRovoConfigTags"] = $2b71e6bc29f732db$export$1e0546f83460b30d;
module.exports["useRovoConfigCustomGreeting"] = $2b71e6bc29f732db$export$2a73ca2333c94154;
module.exports["useRovoConfigShouldShowGreeting"] = $2b71e6bc29f732db$export$9d0f592eafe765c0;
module.exports["useRovoConfigPrioritizeCustomActionResults"] = $2b71e6bc29f732db$export$6745aa6ec6db525a;
module.exports["useRovoConfigNumStartersToShow"] = $2b71e6bc29f732db$export$77b1364ae13e9bf5;

});

parcelRegister("4acD6", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $48675c89bdefef9d$export$d4c72bab9d6cc13a = {
    nudges: [],
    dailyBriefUnread: null,
    isNudgeVisible: false
};
const $48675c89bdefef9d$export$e324594224ef24da = {
    setNudges: (nudges)=>({ setState: setState })=>{
            setState({
                nudges: nudges
            });
        },
    setButtonClickedTimestamp: (buttonClickedTimestamp)=>({ setState: setState })=>{
            setState({
                buttonClickedTimestamp: buttonClickedTimestamp
            });
        },
    setDailyBriefUnread: (dailyBriefUnread)=>({ setState: setState })=>{
            setState({
                dailyBriefUnread: dailyBriefUnread
            });
        },
    setIsNudgeVisible: (isNudgeVisible)=>({ setState: setState })=>{
            setState({
                isNudgeVisible: isNudgeVisible
            });
        }
};
const $48675c89bdefef9d$export$72552b26ebb37b2 = (0, $1P1Tu.createStore)({
    initialState: $48675c89bdefef9d$export$d4c72bab9d6cc13a,
    actions: $48675c89bdefef9d$export$e324594224ef24da,
    name: 'AISmartButtonStore'
});
const $48675c89bdefef9d$export$af36d029992e7a8c = (0, $9zUhf.createActionsHook)($48675c89bdefef9d$export$72552b26ebb37b2);
module.exports["AISmartButtonStore"] = $48675c89bdefef9d$export$72552b26ebb37b2;
module.exports["useAISmartButtonActions"] = $48675c89bdefef9d$export$af36d029992e7a8c;

});

parcelRegister("9QtOT", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");


var $4acD6 = parcelRequire("4acD6");

const $9fe72367d410ea7b$export$b854997b7299d67f = (0, $9zUhf.createStateHook)((0, $4acD6.AISmartButtonStore), {
    selector: (state)=>state.nudges
});
const $9fe72367d410ea7b$export$9af0fbebebbfec35 = (0, $9zUhf.createStateHook)((0, $4acD6.AISmartButtonStore), {
    selector: (state)=>state.buttonClickedTimestamp
});
const $9fe72367d410ea7b$export$2d43c7fdbd36cd6c = (0, $9zUhf.createStateHook)((0, $4acD6.AISmartButtonStore), {
    selector: (state)=>state.dailyBriefUnread
});
const $9fe72367d410ea7b$export$17170223ff11d032 = (0, $9zUhf.createStateHook)((0, $4acD6.AISmartButtonStore), {
    selector: (state)=>state.isNudgeVisible
});
module.exports["useAINudges"] = $9fe72367d410ea7b$export$b854997b7299d67f;
module.exports["useDailyBriefUnread"] = $9fe72367d410ea7b$export$2d43c7fdbd36cd6c;
module.exports["useIsNudgeVisible"] = $9fe72367d410ea7b$export$17170223ff11d032;

});

parcelRegister("3Am3T", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dDqLo = parcelRequire("dDqLo");

const $7428cb96b7623c11$export$cf1f48e05bf093f2 = /*#__PURE__*/ (0, $42omo.createContext)({
    footerCommentsCount: 0,
    unresolvedInlineCommentsCount: 0
});
const $7428cb96b7623c11$export$c2f6e8ee3b0be174 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { contentId: contentId, children: children } = t0;
    const commentCounts = (0, $dDqLo.useCommentCounts)(contentId);
    let t1;
    if ($[0] !== children || $[1] !== commentCounts) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7428cb96b7623c11$export$cf1f48e05bf093f2.Provider, {
            value: commentCounts
        }, children);
        $[0] = children;
        $[1] = commentCounts;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ contentId: contentId, children: children })=>{
    const commentCounts = (0, $dDqLo.useCommentCounts)(contentId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7428cb96b7623c11$export$cf1f48e05bf093f2.Provider, {
        value: commentCounts
    }, children);
};
module.exports["CommentCountsContext"] = $7428cb96b7623c11$export$cf1f48e05bf093f2;
module.exports["CommentCountsProvider"] = $7428cb96b7623c11$export$c2f6e8ee3b0be174;

});

parcelRegister("dDqLo", function(module, exports) {
/**
 * @graphql cc
 */ 
var $42omo = parcelRequire("42omo");


var $dkkKv = parcelRequire("dkkKv");


var $4L9ve = parcelRequire("4L9ve");


var $6mKj3 = parcelRequire("6mKj3");


var $aPT9H = parcelRequire("aPT9H");

const $c085ac79a8833850$export$453b7c79178856e5 = (contentId)=>{
    // Always call both hooks to follow React rules, but skip the queries conditionally
    // Legacy implementation using CommentsSectionQuery
    const legacyResult = (0, $aPT9H.useCommentCountsLegacy)(contentId);
    // New comments data manager - get processed data from the store
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    // ActiveCommentsQuery implementation - used when cc_comments_new_comments_data_manager is disabled
    // Call without type filter to get both inline and footer comments, then filter by location.type
    const { data: allCommentsData } = (0, $dkkKv.useActiveCommentsQuery)({
        pageId: contentId,
        // Don't pass type to get all comment types (both CommentType.INLINE and CommentType.FOOTER)
        skip: !contentId || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)
    });
    return (0, $42omo.useMemo)(()=>{
        // Priority 1: Use new comments data manager when enabled
        if (processedCommentsData.isDataProcessed && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
            const unresolvedInlineCommentsCount = processedCommentsData.openInlineComments.length;
            const footerCommentsCount = processedCommentsData.openFooterComments.length;
            return {
                unresolvedInlineCommentsCount: unresolvedInlineCommentsCount,
                footerCommentsCount: footerCommentsCount
            };
        }
        // Priority 2: Use ActiveCommentsQuery when cc_comments_new_comments_data_manager is disabled
        if (allCommentsData?.comments?.nodes && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
            // New implementation using ActiveCommentsQuery
            // ActiveCommentsQuery already filters by commentState: UNRESOLVED, so all comments are unresolved
            // Filter comments by location.type to count inline vs footer separately
            const unresolvedInlineCommentsCount = allCommentsData.comments.nodes.filter((node)=>node?.location?.type === 'INLINE').length;
            const footerCommentsCount = allCommentsData.comments.nodes.filter((node)=>node?.location?.type === 'FOOTER').length;
            return {
                unresolvedInlineCommentsCount: unresolvedInlineCommentsCount,
                footerCommentsCount: footerCommentsCount
            };
        }
        // Priority 3: Legacy implementation using CommentsSectionQuery
        // Return legacy result if available, otherwise return default values
        if (legacyResult && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return legacyResult;
        // Fallback when experiment is enabled but data hasn't loaded yet
        return {
            unresolvedInlineCommentsCount: 0,
            footerCommentsCount: 0
        };
    }, [
        processedCommentsData.isDataProcessed,
        processedCommentsData.openInlineComments.length,
        processedCommentsData.openFooterComments.length,
        allCommentsData?.comments?.nodes,
        legacyResult
    ]);
};
module.exports["useCommentCounts"] = $c085ac79a8833850$export$453b7c79178856e5;

});

parcelRegister("aPT9H", function(module, exports) {

var $k8e76 = parcelRequire("k8e76");


var $ftXPY = parcelRequire("ftXPY");


var $7Sm4c = parcelRequire("7Sm4c");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $l5y3Y = parcelRequire("l5y3Y");


var $jMyy4 = parcelRequire("jMyy4");

const $a2300d29b43bb5dd$export$e32e67cfb7516912 = (contentId)=>{
    const { unresolvedInlineComments: unresolvedInlineComments } = (0, $k8e76.useInlineCommentsState)();
    const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    // Instead of requesting 0 comments with the 'first' param here I am reusing the query that is preloaded and fetched
    // for page comments themselves. This allows me to take advantage of the caching and updates that occur in the
    // legacy classes. I've also just marked all errors as handled as we don't particularly care about the results here
    // and the page comments component has much more robust error handling than we'd want to add here.
    const { data: footerCommentsData, error: error } = (0, $jMyy4.useQueryInterop)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- This is not preloaded but there is a name collision with a preloaded query
    isReactionsEnabled ? (0, $ftXPY.CommentsSectionQuery) : (0, $ftXPY.CommentsSectionWithoutReactionsQuery), {
        variables: {
            contentId: contentId,
            offset: '',
            first: 100
        },
        fetchPolicy: window.__SSR_RENDERED__ && (0, $9wGTI.fg)('confluence_frontend_remove_comments_placeholder') ? 'cache-first' : undefined,
        skip: (0, $9wGTI.fg)('confluence_comment_use_active_comment_query') || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) || !contentId,
        __callerPackage__: "@confluence/comments-hooks"
    });
    if (error) (0, $7Sm4c.markErrorAsHandled)(error);
    // Return undefined when feature gate or experiment is enabled
    if ((0, $9wGTI.fg)('confluence_comment_use_active_comment_query') || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return undefined;
    return {
        unresolvedInlineCommentsCount: (unresolvedInlineComments && unresolvedInlineComments.length) ?? 0,
        footerCommentsCount: (footerCommentsData && footerCommentsData.comments?.totalCount) ?? 0
    };
};
module.exports["useCommentCountsLegacy"] = $a2300d29b43bb5dd$export$e32e67cfb7516912;

});

parcelRegister("k8e76", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $j1v0l = parcelRequire("j1v0l");


var $hE1Uz = parcelRequire("hE1Uz");

const $221ff47547c5dafc$var$initialState = {
    unresolvedInlineComments: []
};
const $221ff47547c5dafc$var$actions = {
    updateUnresolvedInlineComment: (unresolvedInlineComments)=>({ setState: setState })=>{
            setState({
                unresolvedInlineComments: unresolvedInlineComments
            });
        },
    addUnresolvedInlineComment: (unresolvedAnnotationId, pageModes)=>({ setState: setState, getState: getState })=>{
            if (!unresolvedAnnotationId) return;
            const { unresolvedInlineComments: unresolvedInlineComments } = getState();
            setState({
                unresolvedInlineComments: (0, $hE1Uz.findUnresolvedCommentIndex)(unresolvedAnnotationId, unresolvedInlineComments, pageModes)
            });
        },
    removeUnresolvedInlineComment: (unresolvedAnnotationId)=>({ setState: setState, getState: getState })=>{
            if (!unresolvedAnnotationId) return;
            const { unresolvedInlineComments: unresolvedInlineComments } = getState();
            const updatedUnresolvedInlineComments = [
                ...unresolvedInlineComments
            ];
            const unresolvedAnnotationIdx = updatedUnresolvedInlineComments.indexOf(unresolvedAnnotationId);
            // Remove the passed in comment if it exists and reset the state
            if (unresolvedAnnotationIdx > -1) {
                updatedUnresolvedInlineComments.splice(unresolvedAnnotationIdx, 1);
                setState({
                    unresolvedInlineComments: updatedUnresolvedInlineComments
                });
            }
        }
};
const $221ff47547c5dafc$var$InlineCommentsStore = (0, $1P1Tu.createStore)({
    initialState: $221ff47547c5dafc$var$initialState,
    actions: $221ff47547c5dafc$var$actions,
    name: 'InlineCommentsStore'
});
const $221ff47547c5dafc$export$2d5fb1576e30b55e = (0, $9zUhf.createHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$84bffd53ee003f3d = (0, $9zUhf.createActionsHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$f4e420e107a562b0 = (0, $9zUhf.createStateHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$d9930cd528b1e4f5 = (0, $j1v0l.createSubscriber)($221ff47547c5dafc$var$InlineCommentsStore);
module.exports["useInlineComments"] = $221ff47547c5dafc$export$2d5fb1576e30b55e;
module.exports["useInlineCommentsActions"] = $221ff47547c5dafc$export$84bffd53ee003f3d;
module.exports["useInlineCommentsState"] = $221ff47547c5dafc$export$f4e420e107a562b0;

});

parcelRegister("hE1Uz", function(module, exports) {
var $8288f6cefaa5e2cf$var$PageMode = /*#__PURE__*/ function(PageMode) {
    PageMode["EDIT"] = "edit";
    PageMode["VIEW"] = "view";
    PageMode["LIVE"] = "live";
    return PageMode;
}($8288f6cefaa5e2cf$var$PageMode || {});
const $8288f6cefaa5e2cf$export$556f3f3c22ea5327 = (unresolvedAnnotationId, unresolvedInlineComments, pageMode)=>{
    const isFullPageEditor = pageMode === "live" || pageMode === "edit";
    let activeAnnotationMarks;
    if (isFullPageEditor) {
        // In the full-page editor mode, collect parent spans with unique IDs for annotation boundaries
        const parentSpansSet = new Set();
        const annotations = document.querySelectorAll('.ak-editor-annotation-focus, .ak-editor-annotation-blur');
        annotations.forEach((element)=>{
            const parentSpan = element.closest('span[id]');
            if (parentSpan) parentSpansSet.add(parentSpan);
        });
        activeAnnotationMarks = Array.from(parentSpansSet);
    } else // For renderer or view mode, collect marks with active annotation state
    activeAnnotationMarks = Array.from(document.querySelectorAll("mark[data-mark-annotation-state='active']"));
    // Attempt to find the index of the new unresolved annotation by matching its element
    const newlyUnresolvedAnnotation = document.getElementById(unresolvedAnnotationId);
    const allUnresolvedAnnotations = Array.from(activeAnnotationMarks);
    const matchedIndex = newlyUnresolvedAnnotation ? allUnresolvedAnnotations.indexOf(newlyUnresolvedAnnotation) : -1;
    // Construct the new array with unresolved comments
    const newUnresolvedInlineComments = [
        ...unresolvedInlineComments
    ];
    if (matchedIndex !== -1) newUnresolvedInlineComments.splice(matchedIndex, 0, unresolvedAnnotationId);
    else newUnresolvedInlineComments.push(unresolvedAnnotationId);
    return newUnresolvedInlineComments;
};
module.exports["findUnresolvedCommentIndex"] = $8288f6cefaa5e2cf$export$556f3f3c22ea5327;

});

parcelRegister("l5y3Y", function(module, exports) {

var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $eSLr0 = parcelRequire("eSLr0");


var $9Z1sw = parcelRequire("9Z1sw");


var $dPJCf = parcelRequire("dPJCf");

const $13602a0094cde4d6$export$da23010c6e2ddd94 = (contentId)=>{
    const isPDFExport = (0, $dPJCf.usePathnameMatcher)({
        selector: (pathname)=>pathname?.indexOf('/wiki/pdf/') !== -1
    });
    const baseOptions = {
        variables: {
            contentId: contentId,
            location: (0, $eSLr0.ATL_PAGE_CONTENT_FOOTER_ACTIONS)
        },
        skip: isPDFExport
    };
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: data } = (0, $6mKj3.expValEquals)('confluence_stop_watching_webpanellocationquery', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $9Z1sw.WebPanelLocationQuery), baseOptions) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        fetchPolicy: 'cache-first',
        __callerPackage__: "@confluence/comments-hooks"
    });
    return !isPDFExport && Boolean(data?.webPanels?.length);
};
module.exports["useIsReactionsEnabled"] = $13602a0094cde4d6$export$da23010c6e2ddd94;

});

parcelRegister("2bR8c", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5qqdA = parcelRequire("5qqdA");


var $jln20 = parcelRequire("jln20");

const $da7293b7c8deb7d1$export$c27f18f8bab3d8b9 = ()=>{
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { panelId: panelId } = rightSidebarContext.getCurrent() || {};
    const isConversationAssistantSidebarActive = panelId === (0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID);
    return (0, $42omo.useMemo)(()=>{
        return {
            isSidebarOpen: ()=>{
                return isConversationAssistantSidebarActive;
            },
            openSidebar: ()=>{
                rightSidebarContext.open((0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID), (0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_WIDTH));
            },
            closeSidebar: ()=>{
                if (isConversationAssistantSidebarActive) rightSidebarContext.close((0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID));
            }
        };
    }, [
        isConversationAssistantSidebarActive,
        rightSidebarContext
    ]);
};
module.exports["useCreateRovoExperienceSidebarController"] = $da7293b7c8deb7d1$export$c27f18f8bab3d8b9;

});

parcelRegister("5qqdA", function(module, exports) {
// Exported through entry point /src/utils.
/**
 * Used as the identifier for container on the consumer side.
 *
 * Example:
 * ```
 * <div id={CONVERSATION_ASSISTANT_CONTAINER_ID}>
 *  <ConversationAssistant />
 * </div>
 * ```
 */ const $76e32f06e038930c$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $76e32f06e038930c$export$64aee74ba59709e5 = 439; // px
const $76e32f06e038930c$export$1c07393c5bb1bc27 = 439; // px
const $76e32f06e038930c$export$aa3478deee7adbeb = 350; // px
const $76e32f06e038930c$export$21e515a86cd1733b = 'Chat';
const $76e32f06e038930c$export$e942bf04e23ff966 = 'Rovo';
module.exports["CONVERSATION_ASSISTANT_CONTAINER_ID"] = $76e32f06e038930c$export$dffb4ed44e20ea9a;
module.exports["CONVERSATION_ASSISTANT_CONTAINER_WIDTH"] = $76e32f06e038930c$export$64aee74ba59709e5;
module.exports["CONVERSATION_ASSISTANT_MINIMUM_HEIGHT"] = $76e32f06e038930c$export$aa3478deee7adbeb;
module.exports["CONVERSATION_ASSISTANT_BRAND_NAME"] = $76e32f06e038930c$export$21e515a86cd1733b;
module.exports["DEFAULT_PAGE_TITLE"] = $76e32f06e038930c$export$e942bf04e23ff966;

});

parcelRegister("h2uld", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $j25oo = parcelRequire("j25oo");


var $jtuBN = parcelRequire("jtuBN");


var $72md5 = parcelRequire("72md5");


var $h3vPv = parcelRequire("h3vPv");

const $8b6571c5cd7e604c$export$9a0a69714186a2dc = (0, $j25oo.default);
const $8b6571c5cd7e604c$export$bf3941b9bff5380a = (contentId, skipQuery)=>{
    const $ = (0, $frIzR.c)(20);
    let t0;
    if ($[0] !== contentId) {
        t0 = {
            contentId: contentId
        };
        $[0] = contentId;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== skipQuery || $[3] !== t0) {
        t1 = {
            variables: t0,
            skip: skipQuery
        };
        $[2] = skipQuery;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    const readTimeQueryOptions = t1;
    const { data: data, loading: loading, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($8b6571c5cd7e604c$export$9a0a69714186a2dc, readTimeQueryOptions);
    let t2;
    if ($[5] !== contentId || $[6] !== data || $[7] !== error || $[8] !== loading) {
        bb0: {
            const adfFromData = (0, $72md5.getAdf)(data ?? undefined);
            if (!adfFromData || loading || error || !contentId) {
                let t3;
                if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
                    t3 = {
                        readTime: null,
                        wordCount: null,
                        features: null,
                        featuresSkipExpand: null
                    };
                    $[10] = t3;
                } else t3 = $[10];
                t2 = t3;
                break bb0;
            }
            t2 = {
                adf: adfFromData,
                readTime: (0, $72md5.calculateEstimatedReadTime)(adfFromData),
                wordCount: (0, $72md5.getWordCount)(adfFromData),
                features: (0, $h3vPv.extractContentFeatures)(adfFromData),
                featuresSkipExpand: (0, $h3vPv.extractContentFeaturesSkipExpand)(adfFromData)
            };
        }
        $[5] = contentId;
        $[6] = data;
        $[7] = error;
        $[8] = loading;
        $[9] = t2;
    } else t2 = $[9];
    const { adf: adf, readTime: readTime, wordCount: wordCount, features: features, featuresSkipExpand: featuresSkipExpand } = t2;
    const contentNode = data?.content?.nodes?.[0];
    const contentType = contentNode?.type;
    let t3;
    if ($[11] !== adf || $[12] !== contentType || $[13] !== error || $[14] !== features || $[15] !== featuresSkipExpand || $[16] !== loading || $[17] !== readTime || $[18] !== wordCount) {
        t3 = {
            loading: loading,
            error: error,
            adf: adf,
            contentType: contentType,
            readTime: readTime,
            wordCount: wordCount,
            features: features,
            featuresSkipExpand: featuresSkipExpand
        };
        $[11] = adf;
        $[12] = contentType;
        $[13] = error;
        $[14] = features;
        $[15] = featuresSkipExpand;
        $[16] = loading;
        $[17] = readTime;
        $[18] = wordCount;
        $[19] = t3;
    } else t3 = $[19];
    return t3;
};
module.exports["ReadTimeQuery"] = $8b6571c5cd7e604c$export$9a0a69714186a2dc;
module.exports["useReadTime"] = $8b6571c5cd7e604c$export$bf3941b9bff5380a;

});

parcelRegister("j25oo", function(module, exports) {
/**
 * @generated SignedSource<<b0ed3f943392beb78acd9d9ea9b42788>>
 * @relayHash 24201b9545ec89a2ece8511e9a2a8999
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b3c5854ab0548b89c651d5a1e8fc47a2aa65f94c49e96a88597856cd78fc203c
const $6b1bc0e8ad61af00$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "includeContentBody"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "condition": "includeContentBody",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "ContentBodyPerRepresentation",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBody",
                                            "kind": "LinkedField",
                                            "name": "dynamic",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "representation"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useReadTimeQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useReadTimeQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "24201b9545ec89a2ece8511e9a2a8999",
            "id": "b3c5854ab0548b89c651d5a1e8fc47a2aa65f94c49e96a88597856cd78fc203c",
            "metadata": {},
            "name": "useReadTimeQuery",
            "operationKind": "query",
            "text": "query useReadTimeQuery($contentId:ID,$status:[String],$includeContentBody:Boolean=true){content(id:$contentId,status:$status){nodes{id,type,body@include(if:$includeContentBody){dynamic{value,representation}},operations{operation,targetType}}}}"
        }
    };
}();
$6b1bc0e8ad61af00$var$node.hash = "1de89fa5a6335c6c91c524557c055ef1";
var $6b1bc0e8ad61af00$export$2e2bcd8739ae039 = $6b1bc0e8ad61af00$var$node;
module.exports["default"] = $6b1bc0e8ad61af00$export$2e2bcd8739ae039;

});

parcelRegister("72md5", function(module, exports) {

var $h3vPv = parcelRequire("h3vPv");

const $7a7682e083b4bc67$var$wpm = 265; // words per minute, inspired by Medium.com
const $7a7682e083b4bc67$var$minute = 60;
const $7a7682e083b4bc67$export$dbd433271872c208 = (imageCount)=>{
    let readTime = 0;
    for(let i = 0; i < imageCount; i++)readTime += Math.max(12 - i, 3);
    return readTime;
};
const $7a7682e083b4bc67$export$a44553c2ca45b9b3 = (adf)=>{
    if (adf) {
        const extractedFeatures = (0, $h3vPv.extractContentFeaturesSkipExpand)(adf);
        const features = extractedFeatures;
        const readTime = (features.wordCount / $7a7682e083b4bc67$var$wpm * 60 + $7a7682e083b4bc67$export$dbd433271872c208(features.imageCount)) / $7a7682e083b4bc67$var$minute;
        if (readTime > 0.5) return Math.round(readTime);
    }
    return 0;
};
const $7a7682e083b4bc67$export$da369a1128d64cc6 = (response)=>{
    const representation = response?.content?.nodes?.[0]?.body?.dynamic?.representation;
    if (representation === 'atlas_doc_format') {
        const adfString = response?.content?.nodes?.[0]?.body?.dynamic?.value;
        if (adfString) try {
            return JSON.parse(adfString);
        } catch  {
            return null;
        }
    }
    return null;
};
const $7a7682e083b4bc67$export$d7ca718a8dbe1f35 = ({ contentType: contentType, contentId: contentId, adf: adf, isInEditor: isInEditor })=>({
        type: 'sendOperationalEvent',
        data: {
            source: 'confluence-frontend',
            action: 'extracted',
            actionSubject: 'contentFeature',
            objectType: contentType,
            objectId: contentId,
            attributes: {
                ...(0, $h3vPv.extractContentFeatures)(adf),
                isInEditor: isInEditor
            }
        }
    });
const $7a7682e083b4bc67$export$dba3e2bcdbd49da4 = (adf)=>{
    if (!adf) return 0;
    const features = (0, $h3vPv.extractContentFeaturesSkipExpand)(adf);
    return features.wordCount;
};
const $7a7682e083b4bc67$export$2ac19802f4188b34 = (bodyDynamic)=>{
    if (!bodyDynamic || bodyDynamic.representation !== 'atlas_doc_format') return false;
    const adfString = bodyDynamic.value;
    if (!adfString) return false;
    let adf;
    try {
        adf = JSON.parse(adfString);
    } catch  {
        return false;
    }
    const { wordCount: wordCount, imageCount: imageCount } = (0, $h3vPv.extractContentFeaturesSkipExpand)(adf);
    return wordCount > 0 || imageCount > 0;
};
module.exports["calculateImageReadTime"] = $7a7682e083b4bc67$export$dbd433271872c208;
module.exports["calculateEstimatedReadTime"] = $7a7682e083b4bc67$export$a44553c2ca45b9b3;
module.exports["getAdf"] = $7a7682e083b4bc67$export$da369a1128d64cc6;
module.exports["getContentFeatureExtractedEventObject"] = $7a7682e083b4bc67$export$d7ca718a8dbe1f35;
module.exports["getWordCount"] = $7a7682e083b4bc67$export$dba3e2bcdbd49da4;
module.exports["docHasContent"] = $7a7682e083b4bc67$export$2ac19802f4188b34;

});

parcelRegister("h3vPv", function(module, exports) {

var $1A9t2 = parcelRequire("1A9t2");

// helper function to traverse ADF tree while skipping expand nodes
const $a8469c4e0ee76bb2$var$reduceSkipExpand = (node, reducer, initialValue)=>{
    // skip if this is an expand node
    if (node.type === 'expand' || node.type === 'nestedExpand') return initialValue;
    // process current node
    let result = reducer(initialValue, node);
    // process child nodes if they exist
    if (node.content) result = node.content.reduce((acc, child)=>$a8469c4e0ee76bb2$var$reduceSkipExpand(child, reducer, acc), result);
    return result;
};
const $a8469c4e0ee76bb2$var$wordCount = (text)=>{
    if (text) {
        const matches = text.match(/\S+/g);
        if (matches) return matches.length;
    }
    return 0;
};
const $a8469c4e0ee76bb2$var$processADFNode = (currentValue, node)=>{
    switch(node.type){
        case 'text':
            return {
                ...currentValue,
                textLength: currentValue.textLength + (node.text ? node.text.length : 0),
                wordCount: currentValue.wordCount + $a8469c4e0ee76bb2$var$wordCount(node.text)
            };
        case 'media':
            return {
                ...currentValue,
                imageCount: currentValue.imageCount + 1,
                mediaFiles: node.attrs?.type === 'file' && node.attrs?.id ? currentValue.mediaFiles.concat(node.attrs.id) : currentValue.mediaFiles
            };
        case 'inlineExtension':
            return {
                ...currentValue,
                inlineMacroCount: currentValue.macroCount + 1
            };
        case 'extension':
            return {
                ...currentValue,
                macroCount: currentValue.macroCount + 1
            };
        case 'table':
            return {
                ...currentValue,
                tableCount: currentValue.tableCount + 1
            };
        case 'embedCard':
            const url = node.attrs?.url;
            if (!url.includes('loom')) return currentValue;
            const videoId = url?.split('/').pop().split('?')[0];
            return {
                ...currentValue,
                looms: videoId ? currentValue.looms.concat({
                    id: videoId,
                    url: url
                }) : currentValue.looms
            };
    }
    return currentValue;
};
const $a8469c4e0ee76bb2$export$a148305df2eb5487 = (adf)=>{
    const initialFeatures = {
        rawLength: JSON.stringify(adf).length,
        textLength: 0,
        wordCount: 0,
        imageCount: 0,
        inlineMacroCount: 0,
        macroCount: 0,
        tableCount: 0,
        mediaFiles: [],
        looms: []
    };
    return (0, $1A9t2.reduce)(adf, (currentValue, node)=>$a8469c4e0ee76bb2$var$processADFNode(currentValue, node), initialFeatures);
};
const $a8469c4e0ee76bb2$export$8e18062037dcc9dd = (adf)=>{
    const initialFeatures = {
        rawLength: JSON.stringify(adf).length,
        textLength: 0,
        wordCount: 0,
        imageCount: 0,
        inlineMacroCount: 0,
        macroCount: 0,
        tableCount: 0,
        mediaFiles: [],
        looms: []
    };
    return $a8469c4e0ee76bb2$var$reduceSkipExpand(adf, (currentValue, node)=>$a8469c4e0ee76bb2$var$processADFNode(currentValue, node), initialFeatures);
};
module.exports["extractContentFeatures"] = $a8469c4e0ee76bb2$export$a148305df2eb5487;
module.exports["extractContentFeaturesSkipExpand"] = $a8469c4e0ee76bb2$export$8e18062037dcc9dd;

});

parcelRegister("dWpd3", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $eb4732679a1ccd43$var$initialState = {
    activeContent: null,
    eligibleForChangeboarding: false
};
const $eb4732679a1ccd43$var$actions = {
    setActiveContent: (activeContent)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            return setState({
                ...state,
                activeContent: activeContent
            });
        },
    setEligibleForChangeboarding: (eligibleForChangeboarding)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            return setState({
                ...state,
                eligibleForChangeboarding: eligibleForChangeboarding
            });
        }
};
const $eb4732679a1ccd43$var$AudioButtonWrapperStore = (0, $1P1Tu.createStore)({
    name: 'AudioButtonWrapperStore',
    initialState: $eb4732679a1ccd43$var$initialState,
    actions: $eb4732679a1ccd43$var$actions
});
const $eb4732679a1ccd43$export$ab1ee966cd621cb0 = (0, $9zUhf.createStateHook)($eb4732679a1ccd43$var$AudioButtonWrapperStore, {
    selector: (state)=>({
            activeContent: state.activeContent,
            eligibleForChangeboarding: state.eligibleForChangeboarding
        })
});
const $eb4732679a1ccd43$export$9980b31ff728dec1 = (0, $9zUhf.createActionsHook)($eb4732679a1ccd43$var$AudioButtonWrapperStore);
module.exports["useAudioButtonWrapperStore"] = $eb4732679a1ccd43$export$ab1ee966cd621cb0;
module.exports["useAudioButtonWrapperActions"] = $eb4732679a1ccd43$export$9980b31ff728dec1;

});

parcelRegister("g5jMy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2d6ff2113712652381db2eeef0f24380>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb5c754bd5a605c4$var$_react = $bb5c754bd5a605c4$var$_interopRequireDefault((parcelRequire("42omo")));

var $bb5c754bd5a605c4$var$_baseNew = $bb5c754bd5a605c4$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $bb5c754bd5a605c4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sunset".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Farewell feed in hello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bb5c754bd5a605c4$var$SunsetIcon = (props)=>/*#__PURE__*/ $bb5c754bd5a605c4$var$_react.default.createElement($bb5c754bd5a605c4$var$_baseNew.default, Object.assign({
        name: "SunsetIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v2h-1.5V1zm3 2.845 1.414-1.415 1.06 1.061-1.413 1.414zm-8.586 1.07L1.75 3.5l1.06-1.06 1.415 1.414zM8 6a3 3 0 0 0-3 3H3.5a4.5 4.5 0 0 1 9 0H11a3 3 0 0 0-3-3M2 9H0V7.5h2zm14 0h-2V7.5h2zm-1 3H1v-1.5h14zm-4.5 1.5V15h-5v-1.5z" clip-rule="evenodd"/>`
    }, props));
$bb5c754bd5a605c4$var$SunsetIcon.displayName = 'SunsetIcon';
var $bb5c754bd5a605c4$var$_default = module.exports.default = $bb5c754bd5a605c4$var$SunsetIcon;

});

parcelRegister("6Htct", function(module, exports) {
var $4c47f75c6ef52bb8$export$87497e63e164f4b3 = /*#__PURE__*/ function(HandleActionType) {
    HandleActionType["Base"] = "Base";
    HandleActionType["Chat"] = "Chat";
    HandleActionType["Nested"] = "Nested";
    HandleActionType["Skill"] = "Skill";
    return HandleActionType;
}({});
const $4c47f75c6ef52bb8$export$c91e07269f22915a = new Set([
    'invite-users',
    'grant-app-access',
    'troubleshoot-invitation-errors',
    'troubleshoot-user-access',
    'troubleshoot-user-provisioning',
    'troubleshoot-single-sign-on',
    'review-api-security',
    'policy-assist'
]);
var $4c47f75c6ef52bb8$export$7f7a6f1c2ab5127 = /*#__PURE__*/ function(PageContextType) {
    PageContextType["ADMIN_HUB"] = "admin-hub";
    PageContextType["BITBUCKET"] = "bitbucket";
    PageContextType["BITBUCKET_PULL_REQUEST"] = "bitbucket-pull-request";
    PageContextType["BITBUCKET_CREATE_PULL_REQUEST"] = "bitbucket-create-pull-request";
    PageContextType["BITBUCKET_PULL_REQUEST_WITHOUT_PIPELINES_STARTERS"] = "bitbucket-pull-request-without-pipelines-starters";
    PageContextType["BITBUCKET_PIPELINES"] = "bitbucket-pipelines";
    PageContextType["BITBUCKET_REPOSITORY_SOURCE"] = "bitbucket-repository-source";
    PageContextType["CONFLUENCE_HOME"] = "confluence-home";
    PageContextType["CONFLUENCE_PAGE_VIEW"] = "confluence-page-view";
    PageContextType["CONFLUENCE_PAGE_EDIT"] = "confluence-page-edit";
    PageContextType["CONFLUENCE_BLOG_VIEW"] = "confluence-blog-view";
    PageContextType["CONFLUENCE_BLOG_EDIT"] = "confluence-blog-edit";
    PageContextType["CONFLUENCE_WHITEBOARD"] = "confluence-whiteboard";
    PageContextType["JIRA_HOME"] = "jira-home";
    PageContextType["JIRA_FOR_YOU"] = "jira-for-you";
    PageContextType["JIRA_ISSUE_VIEW"] = "jira-issue-view";
    PageContextType["JIRA_PROJECT"] = "jira-project";
    PageContextType["JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY"] = "jira-cmp-space-settings-people-legacy";
    PageContextType["JIRA_CMP_SPACE_SETTINGS_PERMISSIONS_LEGACY"] = "jira-cmp-space-settings-permissions-legacy";
    PageContextType["JIRA_TMP_SPACE_SETTINGS_ACCESS"] = "jira-tmp-space-settings-access";
    PageContextType["JSM_INCIDENT_VIEW"] = "jsm-incident-view";
    PageContextType["JSM_INCIDENT_LIST_VIEW"] = "jsm-incident-list-view";
    PageContextType["JSM_ALERT_VIEW"] = "jsm-alert-view";
    PageContextType["JSM_ALERT_LIST_VIEW"] = "jsm-alert-list-view";
    PageContextType["JSM_ALERT_GROUP_DETAIL_VIEW"] = "jsm-alert-group-detail-view";
    PageContextType["ATLAS_HOME"] = "atlas-home";
    PageContextType["ATLAS_HOME_MAIN"] = "atlas-home-main";
    PageContextType["ATLAS_HOME_DISCOVER"] = "atlas-home-discover";
    PageContextType["ATLAS_HOME_RECENTS"] = "atlas-home-recents";
    PageContextType["ATLAS_HOME_FULL_PAGE_NOTIFICATIONS"] = "atlas-home-full-page-notifications";
    PageContextType["ATLAS_HOME_PROJECT_UPDATES_LIST"] = "atlas-home-project-updates-list";
    PageContextType["ATLAS_HOME_GOAL_UPDATES_LIST"] = "atlas-home-goal-updates-list";
    PageContextType["ATLAS_HOME_TEAM_UPDATES_LIST"] = "atlas-home-team-updates-list";
    PageContextType["ATLAS_HOME_TAG_UPDATES_LIST"] = "atlas-home-tag-updates-list";
    PageContextType["FOCUS"] = "focus";
    PageContextType["FOCUS_FOR_YOU"] = "focus-for-you";
    PageContextType["FOCUS_FOCUS_AREA_PAGE"] = "focus-focus-area-page";
    PageContextType["FOCUS_FOCUS_AREA_GOAL_VIEW"] = "focus-focus-area-goal-view";
    PageContextType["FOCUS_FOCUS_AREA_WORK_VIEW"] = "focus-focus-area-work-view";
    PageContextType["SAC"] = "sac";
    PageContextType["TRELLO_BOARD"] = "trello-board";
    PageContextType["TRELLO_CARD"] = "trello-card";
    PageContextType["UNKNOWN"] = "unknown";
    return PageContextType;
}({});
const $4c47f75c6ef52bb8$export$4f757e7d9540e8f9 = 'prompt-of-day';
module.exports["HandleActionType"] = $4c47f75c6ef52bb8$export$87497e63e164f4b3;
module.exports["LEGACY_DYNAMIC_SKILL_IDS"] = $4c47f75c6ef52bb8$export$c91e07269f22915a;
module.exports["PageContextType"] = $4c47f75c6ef52bb8$export$7f7a6f1c2ab5127;
module.exports["PROMPT_OF_DAY_ACTION_ID"] = $4c47f75c6ef52bb8$export$4f757e7d9540e8f9;

});

parcelRegister("5gEqE", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $2CHXX = parcelRequire("2CHXX");

const $815712ef274e8115$export$6fdb848aa0eff3d1 = {
    isActive: false
};
const $815712ef274e8115$var$initialState = {
    activeMenu: 'none',
    mounted: false,
    isAgentSelectorMenuOpen: false,
    streaming: false,
    isChatOnboardingMiniModalOpen: false,
    // If productionized will look to move this logic into conversation-assistant-onboarding
    emptyChatLaunchGreeting: undefined,
    emptyChatLaunchProjectContext: undefined,
    emptyChatLaunchConversationActions: undefined,
    emptyChatLaunchReplaceProviderActions: false,
    emptyChatLaunchSkillRegistryTags: undefined,
    emptyChatLaunchId: 0,
    selectedSpace: undefined,
    activeTabId: 'suggestions',
    previousTabId: 'suggestions',
    lastTabConversationId: '',
    lastLifecycleConversationId: (0, $2CHXX.EMPTY_CONVERSATION_ID),
    lastLifecycleLaunchId: undefined,
    smartLink3PPostAuth: $815712ef274e8115$export$6fdb848aa0eff3d1
};
const $815712ef274e8115$var$store = (0, $1P1Tu.createStore)({
    name: 'uiStore',
    initialState: $815712ef274e8115$var$initialState,
    actions: {
        // created for resetting store during tests
        reset: ()=>({ setState: setState })=>{
                setState({
                    ...$815712ef274e8115$var$initialState,
                    conversationHeader: null,
                    selectedSpace: undefined
                });
            },
        setActiveMenu: (menu)=>({ setState: setState })=>{
                setState({
                    activeMenu: menu
                });
            },
        setMounted: (mounted)=>({ setState: setState })=>{
                setState({
                    mounted: mounted
                });
            },
        setIsAgentSelectorMenuOpen: (isOpen)=>({ setState: setState })=>{
                setState({
                    isAgentSelectorMenuOpen: isOpen
                });
            },
        setStreamingStatus: (status)=>({ setState: setState })=>{
                setState({
                    streaming: status
                });
            },
        setIsChatOnboardingMiniModalOpen: (status)=>({ setState: setState })=>{
                setState({
                    isChatOnboardingMiniModalOpen: status
                });
            },
        setSmartLink3PPostAuth: (payload)=>({ setState: setState })=>{
                setState({
                    smartLink3PPostAuth: payload
                });
            },
        clearSmartLink3PPostAuth: ()=>({ setState: setState })=>{
                setState({
                    smartLink3PPostAuth: $815712ef274e8115$export$6fdb848aa0eff3d1
                });
            },
        setConversationHeader: (header)=>({ setState: setState })=>{
                setState({
                    conversationHeader: header
                });
            },
        getIsMounted: ()=>({ getState: getState })=>{
                return getState().mounted;
            },
        setEmptyChatLaunch: (payload)=>({ setState: setState, getState: getState })=>{
                setState({
                    emptyChatLaunchGreeting: payload.customGreeting,
                    emptyChatLaunchConversationActions: payload.customConversationActions,
                    emptyChatLaunchProjectContext: payload.projectContext,
                    emptyChatLaunchReplaceProviderActions: payload.replaceProviderActions ?? false,
                    emptyChatLaunchSkillRegistryTags: payload.skillRegistryTags,
                    emptyChatLaunchId: getState().emptyChatLaunchId + 1
                });
            },
        clearEmptyChatLaunchGreeting: ()=>({ setState: setState })=>{
                setState({
                    emptyChatLaunchGreeting: undefined,
                    emptyChatLaunchConversationActions: undefined,
                    emptyChatLaunchReplaceProviderActions: false,
                    emptyChatLaunchSkillRegistryTags: undefined
                });
            },
        clearEmptyChatLaunchAll: ()=>({ setState: setState })=>{
                setState({
                    emptyChatLaunchGreeting: undefined,
                    emptyChatLaunchConversationActions: undefined,
                    emptyChatLaunchProjectContext: undefined,
                    emptyChatLaunchReplaceProviderActions: false,
                    emptyChatLaunchSkillRegistryTags: undefined
                });
            },
        setSelectedSpace: (space)=>({ setState: setState })=>{
                setState({
                    selectedSpace: space
                });
            },
        clearSelectedSpace: ()=>({ setState: setState })=>{
                setState({
                    selectedSpace: undefined
                });
            },
        setActiveTabId: (tabId)=>({ setState: setState })=>{
                setState({
                    activeTabId: tabId
                });
            },
        setPreviousTabId: (tabId)=>({ setState: setState })=>{
                setState({
                    previousTabId: tabId
                });
            },
        setLastTabConversationId: (id)=>({ setState: setState })=>{
                setState({
                    lastTabConversationId: id
                });
            },
        checkAndUpdateLifecycleGuard: (conversationId, launchId)=>({ getState: getState, setState: setState })=>{
                const { lastLifecycleConversationId: lastLifecycleConversationId, lastLifecycleLaunchId: lastLifecycleLaunchId } = getState();
                if (lastLifecycleConversationId === conversationId && lastLifecycleLaunchId === launchId) return false;
                setState({
                    lastLifecycleConversationId: conversationId,
                    lastLifecycleLaunchId: launchId
                });
                return true;
            }
    }
});
const $815712ef274e8115$var$useStore = (0, $9zUhf.createHook)($815712ef274e8115$var$store);
const $815712ef274e8115$export$13a6c73a57f1d6a6 = (0, $9zUhf.createHook)($815712ef274e8115$var$store, {
    selector: (state)=>({
            customGreeting: state.emptyChatLaunchGreeting,
            projectContext: state.emptyChatLaunchProjectContext,
            customConversationActions: state.emptyChatLaunchConversationActions,
            replaceProviderActions: state.emptyChatLaunchReplaceProviderActions,
            skillRegistryTags: state.emptyChatLaunchSkillRegistryTags,
            launchId: state.emptyChatLaunchId
        })
});
const $815712ef274e8115$export$81a40d215ef1c1de = (0, $9zUhf.createHook)($815712ef274e8115$var$store, {
    selector: (state)=>({
            activeTabId: state.activeTabId,
            previousTabId: state.previousTabId,
            lastTabConversationId: state.lastTabConversationId
        })
});
const $815712ef274e8115$export$5f449dc44751be0a = (0, $9zUhf.createHook)($815712ef274e8115$var$store, {
    selector: (state)=>({
            selectedSpace: state.selectedSpace
        })
});
const $815712ef274e8115$export$78ce19c6cc1eeb16 = (0, $9zUhf.createHook)($815712ef274e8115$var$store, {
    selector: (state)=>({
            activeMenu: state.activeMenu,
            isAgentSelectorMenuOpen: state.isAgentSelectorMenuOpen,
            isChatOnboardingMiniModalOpen: state.isChatOnboardingMiniModalOpen,
            selectedSpace: state.selectedSpace
        })
});
const $815712ef274e8115$export$5b2ba9b8ea3b0771 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(26);
    const [t0, t1] = $815712ef274e8115$var$useStore();
    const { activeMenu: activeMenu, mounted: mounted, streaming: streaming, isAgentSelectorMenuOpen: isAgentSelectorMenuOpen, isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen, conversationHeader: conversationHeader, selectedSpace: selectedSpace, activeTabId: activeTabId, previousTabId: previousTabId, lastTabConversationId: lastTabConversationId, smartLink3PPostAuth: smartLink3PPostAuth } = t0;
    const { reset: reset, setActiveMenu: setActiveMenu, setMounted: setMounted, setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen, setStreamingStatus: setStreamingStatus, setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen, setConversationHeader: setConversationHeader, setSelectedSpace: setSelectedSpace, clearSelectedSpace: clearSelectedSpace, setActiveTabId: setActiveTabId, setPreviousTabId: setPreviousTabId, setLastTabConversationId: setLastTabConversationId, setSmartLink3PPostAuth: setSmartLink3PPostAuth, clearSmartLink3PPostAuth: clearSmartLink3PPostAuth } = t1;
    const t2 = conversationHeader ?? null;
    let t3;
    if ($[0] !== activeMenu || $[1] !== activeTabId || $[2] !== clearSelectedSpace || $[3] !== clearSmartLink3PPostAuth || $[4] !== isAgentSelectorMenuOpen || $[5] !== isChatOnboardingMiniModalOpen || $[6] !== lastTabConversationId || $[7] !== mounted || $[8] !== previousTabId || $[9] !== reset || $[10] !== selectedSpace || $[11] !== setActiveMenu || $[12] !== setActiveTabId || $[13] !== setConversationHeader || $[14] !== setIsAgentSelectorMenuOpen || $[15] !== setIsChatOnboardingMiniModalOpen || $[16] !== setLastTabConversationId || $[17] !== setMounted || $[18] !== setPreviousTabId || $[19] !== setSelectedSpace || $[20] !== setSmartLink3PPostAuth || $[21] !== setStreamingStatus || $[22] !== smartLink3PPostAuth || $[23] !== streaming || $[24] !== t2) {
        t3 = {
            activeMenu: activeMenu,
            mounted: mounted,
            streaming: streaming,
            isAgentSelectorMenuOpen: isAgentSelectorMenuOpen,
            conversationHeader: t2,
            selectedSpace: selectedSpace,
            reset: reset,
            setActiveMenu: setActiveMenu,
            setMounted: setMounted,
            setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen,
            setStreamingStatus: setStreamingStatus,
            isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen,
            setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen,
            setConversationHeader: setConversationHeader,
            setSelectedSpace: setSelectedSpace,
            clearSelectedSpace: clearSelectedSpace,
            activeTabId: activeTabId,
            previousTabId: previousTabId,
            lastTabConversationId: lastTabConversationId,
            smartLink3PPostAuth: smartLink3PPostAuth,
            setSmartLink3PPostAuth: setSmartLink3PPostAuth,
            clearSmartLink3PPostAuth: clearSmartLink3PPostAuth,
            setActiveTabId: setActiveTabId,
            setPreviousTabId: setPreviousTabId,
            setLastTabConversationId: setLastTabConversationId
        };
        $[0] = activeMenu;
        $[1] = activeTabId;
        $[2] = clearSelectedSpace;
        $[3] = clearSmartLink3PPostAuth;
        $[4] = isAgentSelectorMenuOpen;
        $[5] = isChatOnboardingMiniModalOpen;
        $[6] = lastTabConversationId;
        $[7] = mounted;
        $[8] = previousTabId;
        $[9] = reset;
        $[10] = selectedSpace;
        $[11] = setActiveMenu;
        $[12] = setActiveTabId;
        $[13] = setConversationHeader;
        $[14] = setIsAgentSelectorMenuOpen;
        $[15] = setIsChatOnboardingMiniModalOpen;
        $[16] = setLastTabConversationId;
        $[17] = setMounted;
        $[18] = setPreviousTabId;
        $[19] = setSelectedSpace;
        $[20] = setSmartLink3PPostAuth;
        $[21] = setStreamingStatus;
        $[22] = smartLink3PPostAuth;
        $[23] = streaming;
        $[24] = t2;
        $[25] = t3;
    } else t3 = $[25];
    return t3;
} : ()=>{
    const [{ activeMenu: activeMenu, mounted: mounted, streaming: streaming, isAgentSelectorMenuOpen: isAgentSelectorMenuOpen, isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen, conversationHeader: conversationHeader, selectedSpace: selectedSpace, activeTabId: activeTabId, previousTabId: previousTabId, lastTabConversationId: lastTabConversationId, smartLink3PPostAuth: smartLink3PPostAuth }, { reset: reset, setActiveMenu: setActiveMenu, setMounted: setMounted, setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen, setStreamingStatus: setStreamingStatus, setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen, setConversationHeader: setConversationHeader, setSelectedSpace: setSelectedSpace, clearSelectedSpace: clearSelectedSpace, setActiveTabId: setActiveTabId, setPreviousTabId: setPreviousTabId, setLastTabConversationId: setLastTabConversationId, setSmartLink3PPostAuth: setSmartLink3PPostAuth, clearSmartLink3PPostAuth: clearSmartLink3PPostAuth }] = $815712ef274e8115$var$useStore();
    return {
        activeMenu: activeMenu,
        mounted: mounted,
        streaming: streaming,
        isAgentSelectorMenuOpen: isAgentSelectorMenuOpen,
        conversationHeader: conversationHeader ?? null,
        selectedSpace: selectedSpace,
        reset: reset,
        setActiveMenu: setActiveMenu,
        setMounted: setMounted,
        setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen,
        setStreamingStatus: setStreamingStatus,
        isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen,
        setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen,
        setConversationHeader: setConversationHeader,
        setSelectedSpace: setSelectedSpace,
        clearSelectedSpace: clearSelectedSpace,
        activeTabId: activeTabId,
        previousTabId: previousTabId,
        lastTabConversationId: lastTabConversationId,
        smartLink3PPostAuth: smartLink3PPostAuth,
        setSmartLink3PPostAuth: setSmartLink3PPostAuth,
        clearSmartLink3PPostAuth: clearSmartLink3PPostAuth,
        setActiveTabId: setActiveTabId,
        setPreviousTabId: setPreviousTabId,
        setLastTabConversationId: setLastTabConversationId
    };
};
const $815712ef274e8115$export$cd2fc25ddd3752d4 = (0, $9zUhf.createActionsHook)($815712ef274e8115$var$store);
module.exports["useEmptyChatLaunchSelector"] = $815712ef274e8115$export$13a6c73a57f1d6a6;
module.exports["useActiveTabSelector"] = $815712ef274e8115$export$81a40d215ef1c1de;
module.exports["useSelectedSpaceSelector"] = $815712ef274e8115$export$5f449dc44751be0a;
module.exports["useChatHeaderUISelector"] = $815712ef274e8115$export$78ce19c6cc1eeb16;
module.exports["useUIStore"] = $815712ef274e8115$export$5b2ba9b8ea3b0771;
module.exports["useUIStoreActions"] = $815712ef274e8115$export$cd2fc25ddd3752d4;

});

parcelRegister("1AJi3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5qqdA = parcelRequire("5qqdA");


var $hR4U4 = parcelRequire("hR4U4");


var $8unJx = parcelRequire("8unJx");


var $2bR8c = parcelRequire("2bR8c");


var $jln20 = parcelRequire("jln20");

const $ca70225f28efd254$export$a81c3fee0d63dde7 = ()=>{
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { panelId: panelId } = rightSidebarContext.getCurrent() || {};
    const { mode: mode, isMiniModalAvailable: isMiniModalAvailable, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, openConversationAssistantUIMode: openConversationAssistantUIMode } = (0, $8unJx.useRovoExperienceAPIStore)();
    const isConversationAssistantSidebarActive = panelId === (0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID);
    const sidebarApi = (0, $2bR8c.useCreateRovoExperienceSidebarController)();
    const toggleConversationAssistant = (0, $42omo.useCallback)((openChatMode = 'sidebar')=>{
        toggleConversationAssistantUIMode({
            targetMode: openChatMode === 'mini-modal' && isMiniModalAvailable ? (0, $hR4U4.ConversationAssistantUIModes).MINI_MODAL : (0, $hR4U4.ConversationAssistantUIModes).SIDEBAR,
            sidebarApi: sidebarApi
        });
    }, [
        toggleConversationAssistantUIMode,
        sidebarApi,
        isMiniModalAvailable
    ]);
    const openConversationAssistant = (0, $42omo.useCallback)((openChatMode = 'sidebar')=>{
        openConversationAssistantUIMode({
            targetMode: openChatMode === 'mini-modal' && isMiniModalAvailable ? (0, $hR4U4.ConversationAssistantUIModes).MINI_MODAL : (0, $hR4U4.ConversationAssistantUIModes).SIDEBAR,
            sidebarApi: sidebarApi
        });
    }, [
        openConversationAssistantUIMode,
        sidebarApi,
        isMiniModalAvailable
    ]);
    return (0, $42omo.useMemo)(()=>({
            mode: mode,
            toggleConversationAssistant: toggleConversationAssistant,
            openConversationAssistant: openConversationAssistant,
            isConversationAssistantSidebarActive: isConversationAssistantSidebarActive
        }), [
        mode,
        toggleConversationAssistant,
        openConversationAssistant,
        isConversationAssistantSidebarActive
    ]);
};
module.exports["useToggleConversationAssistant"] = $ca70225f28efd254$export$a81c3fee0d63dde7;

});

parcelRegister("7c4rV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $5a7a73b748300e1f$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $5a7a73b748300e1f$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState({
                data: null,
                loading: false,
                error: null
            });
        }
};
const $5a7a73b748300e1f$export$9bcfef244f363dbe = (0, $1P1Tu.createStore)({
    initialState: $5a7a73b748300e1f$var$initialState,
    actions: $5a7a73b748300e1f$var$actions,
    name: 'atlassianAccountTraitsStore'
});
const $5a7a73b748300e1f$export$c35c4239c4894215 = (0, $9zUhf.createHook)($5a7a73b748300e1f$export$9bcfef244f363dbe);
const $5a7a73b748300e1f$export$aa4cdf7390fbf455 = (0, $9zUhf.createActionsHook)($5a7a73b748300e1f$export$9bcfef244f363dbe);
async function $5a7a73b748300e1f$var$fetchAtlassianAccountTraitsData(userId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/user/${userId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $5a7a73b748300e1f$var$hasFetched = false;
function $5a7a73b748300e1f$export$f1fbc6ad89f91b89() {
    $5a7a73b748300e1f$var$hasFetched = false;
}
function $5a7a73b748300e1f$var$getAtlassianAccountTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.user);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.user);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $5a7a73b748300e1f$export$88411c3a679154ab({ skipBootstrap: skipBootstrap } = {}) {
    const preloadedData = (0, $42omo.useMemo)(()=>$5a7a73b748300e1f$var$getAtlassianAccountTraitsFromSources(), []);
    const [{ data: data, loading: loading, error: error }, storeActions] = $5a7a73b748300e1f$export$c35c4239c4894215();
    const { accessStatus: accessStatus, userId: userId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    (0, $42omo.useEffect)(()=>{
        if (preloadedData || data || loading || error) return;
        if ($5a7a73b748300e1f$var$hasFetched || skipBootstrap) return;
        if (!hasLicensedAccess || !userId) return;
        $5a7a73b748300e1f$var$hasFetched = true;
        storeActions.start();
        $5a7a73b748300e1f$var$fetchAtlassianAccountTraitsData(userId).then(storeActions.success).catch(storeActions.error);
    }, [
        skipBootstrap,
        preloadedData,
        data,
        loading,
        error,
        storeActions,
        hasLicensedAccess,
        userId
    ]);
    if (preloadedData) return {
        data: preloadedData,
        loading: false,
        error: null
    };
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useAtlassianAccountTraits"] = $5a7a73b748300e1f$export$88411c3a679154ab;

});

parcelRegister("dcJRl", function(module, exports) {
const $1eca0028b5407519$export$bab1229873daab56 = (tapTraits)=>{
    if (!tapTraits || Object.entries(tapTraits).length === 0) return null;
    return Object.entries(tapTraits).reduce((acc, [name, value])=>[
            ...acc,
            {
                name: name,
                value: String(value)
            }
        ], []);
};
module.exports["formatTapTraits"] = $1eca0028b5407519$export$bab1229873daab56;

});

parcelRegister("la9AC", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $ij2FZ = parcelRequire("ij2FZ");


var $kfhjt = parcelRequire("kfhjt");

const $08b97b2e27a84eff$var$PROMPT_CATEGORIES = [
    'Analyze',
    'Brainstorm',
    'Review',
    'Summarize',
    'Create',
    'Execute',
    'Find',
    'Learn'
];
const $08b97b2e27a84eff$var$PROMPT_ROLES = [
    'General',
    'Engineering',
    'Product',
    'Program Management',
    'Design',
    'Marketing',
    'IT Ops',
    'Sales',
    'Customer Support',
    'Helpdesk Support',
    'Security'
];
const $08b97b2e27a84eff$var$createFilterOptions = (values)=>values.map((value)=>({
            id: value,
            label: value
        }));
const $08b97b2e27a84eff$export$9fa6e712ef03097f = $08b97b2e27a84eff$var$createFilterOptions($08b97b2e27a84eff$var$PROMPT_CATEGORIES);
const $08b97b2e27a84eff$export$9472c6a87dde5170 = $08b97b2e27a84eff$var$createFilterOptions($08b97b2e27a84eff$var$PROMPT_ROLES);
const $08b97b2e27a84eff$export$1ac99e1b5b1a8cfe = 'rovo-chat-prompt-gallery';
const $08b97b2e27a84eff$export$bee44b12dce7b448 = (prompt)=>{
    const slugs = [];
    const slashSkillPattern = new RegExp((0, $ij2FZ.ROVO_SKILL_TAG_PATTERN).source, 'g');
    for (const m of prompt.matchAll(slashSkillPattern))slugs.push(m[1]);
    return slugs;
};
// Prompts with multiple placeholders are commented out until they are supported by this
// PR https://bitbucket.org/atlassian/atlassian-frontend-monorepo/pull-requests/217105
const $08b97b2e27a84eff$var$staticPrompts = [
    {
        id: 'analyze-customer-feedback-trends',
        title: 'Analyze customer feedback trends',
        prompt: 'Gather and synthesize customer feedback on `product/feature` from various channels such as emails, calls, surveys, support tickets to identify key themes, pain points, opportunities such as upsell and adoption, and organize findings into actionable recommendations. If relevant, map them to stages of the customer journey.',
        useCase: 'Analyze',
        roles: [
            'Product',
            'Marketing',
            'Engineering',
            'Program Management',
            'Customer Support',
            'Sales'
        ],
        enableDeepResearch: true
    },
    // {
    // 	id: 'analyze-it-support-trends',
    // 	title: 'Analyze Trends in IT Support Requests',
    // 	prompt:
    // 		'Examine all IT support requests related to `request type` from the past `number of months` months. Break down the request type by identifying the most common sub-categories and providing counts for each. Investigate resolution notes or agent comments to uncover recurring root causes behind these issues. Identify any time-based patterns, such as spikes in requests during specific times of day, days of the week, or months. Based on your findings, recommend actionable strategies to effectively reduce the volume of this request type.',
    // 	useCase: 'Analyze',
    // 	roles: ['Helpdesk Support', 'IT Ops', 'Customer Support', 'Program Management'],
    // },
    {
        id: 'brainstorm-project-ideas',
        title: 'Brainstorm ideas for project',
        prompt: "We're running a brainstorming session on `topic/problem/goal`. Generate a diverse list of creative ideas, solutions, and/or approaches. For each idea, include a brief description, potential benefits, and any risks or challenges. Organize the ideas by theme or category if possible.",
        useCase: 'Brainstorm',
        roles: [
            'General'
        ]
    },
    {
        id: 'send-slack-weekly-progress',
        title: 'Send Slack message of weekly progress',
        prompt: 'Draft a summary of the key updates and additions I made over the past week. Send this summary in Slack to `Teams channel link`. Confirm the draft with me before sending.',
        useCase: 'Execute',
        roles: [
            'General'
        ]
    },
    {
        id: 'compare-jira-support-article',
        title: 'Compare Jira work item to support article',
        prompt: 'Review the summary, description, and comments of the current request `work item ID`. Based on this information and considering common themes from recently resolved requests, determine if this issue points to a recurring problem that currently lacks a dedicated knowledge base article. If so, propose a concise title for a new knowledge base article and 2-3 key topics or resolution steps it should cover. This should be a distinct problem, not a minor variation of an existing knowledge base article.',
        useCase: 'Review',
        roles: [
            'Helpdesk Support',
            'Customer Support',
            'IT Ops',
            'Program Management'
        ]
    },
    // {
    // 	id: 'conduct-competitive-research',
    // 	title: 'Conduct competitive research',
    // 	prompt:
    // 		'Analyze the competitive landscape for `product` against `Competitor A, B, C, and D` by comparing features, pricing, market positioning, and strengths. Identify market gaps for `product` to explore. Summarize findings in a narrative, including a comparison matrix.',
    // 	useCase: 'Analyze',
    // 	roles: ['Product', 'Program Management', 'Marketing', 'Sales'],
    // },
    {
        id: 'convert-request-jql-query',
        title: 'Convert request into JQL query',
        prompt: 'Write a JQL query to find all unresolved bugs assigned to my team in the last 30 days.',
        useCase: 'Execute',
        roles: [
            'Engineering',
            'Product',
            'IT Ops'
        ]
    },
    // {
    // 	id: 'create-jira-work-item-summaries',
    // 	title: 'Create a document of Jira work item summaries',
    // 	prompt:
    // 		'Generate a Confluence page summarizing information in these work items: `work item ID(s)`.',
    // 	useCase: 'Summarize',
    // 	roles: ['Product', 'Program Management', 'Engineering', 'Customer Support'],
    // },
    // {
    // 	id: 'create-new-sprint',
    // 	title: 'Create a new sprint',
    // 	prompt:
    // 		'Create a new sprint named `sprint name` on the board: `board key`. Set the sprint goal to `sprint goal`, start date to `YYYY-MM-DD`, and end date to `YYYY-MM-DD`.',
    // 	useCase: 'Execute',
    // 	roles: ['Engineering', 'Product', 'Program Management'],
    // },
    {
        id: 'create-ab-testing-plan',
        title: 'Create A/B testing plan',
        prompt: 'Create a detailed A/B testing plan for `project/feature`. Start by defining the hypothesis and primary goal, specifying the variants to be tested, and identifying the key metric(s) for success. Outline the target audience and sample size, describe how users will be randomly assigned to each group, and set the test duration and timeline. Include steps for implementation, data collection, and analysis, and note any tools or platforms to be used. Finally, add placeholders for documenting results, learnings, and next steps, ensuring the plan is clear, actionable, and easy to adapt for different experiments, with space for users to add or modify details as needed.',
        useCase: 'Create',
        roles: [
            'Product',
            'Marketing',
            'Engineering',
            'Design'
        ]
    },
    // {
    // 	id: 'create-effective-okr',
    // 	title: 'Create an effective OKR',
    // 	prompt: 'Help me create an effective OKR for my team.',
    // 	useCase: 'Create',
    // 	roles: ['General', 'Product', 'Program Management'],
    // },
    {
        id: 'create-background-research-plan',
        title: 'Create background research plan',
        prompt: 'Create a first draft or conduct background research on `topic/work item`. Summarise key points, relevant history, and provide links to supporting documents.',
        useCase: 'Summarize',
        roles: [
            'Product',
            'Program Management',
            'Engineering',
            'Design'
        ]
    },
    {
        id: 'create-customer-onboarding-strategy',
        title: 'Create customer onboarding strategy',
        prompt: 'As a customer success lead, outline a clear customer onboarding strategy for `product or service`, including key objectives, main onboarding steps, communication touchpoints, and success metrics; highlight best practices for activation and engagement, and provide space for users to add project-specific details or adapt the strategy for different customer segments, ensuring the plan is concise, actionable, and easy to share with stakeholders.',
        useCase: 'Create',
        roles: [
            'Customer Support',
            'Sales',
            'Product',
            'Program Management'
        ]
    },
    // {
    // 	id: 'create-jira-work-item',
    // 	title: 'Create Jira work item',
    // 	prompt:
    // 		'Create a Jira work item in project `project key` with work type as `bug/task/story/epic`, status as TO DO, classification level as project default, and the summary "`summary`."',
    // 	useCase: 'Execute',
    // 	roles: ['Engineering', 'Product', 'IT Ops', 'Customer Support'],
    // },
    // {
    // 	id: 'create-meeting-agenda',
    // 	title: 'Create meeting agenda',
    // 	prompt:
    // 		'Create a `number of minutes/hours` meeting agenda with `person/team/department` on `meeting topic` to discuss `objectives for the meeting`. Based on these objectives, suggest key topics, allocate appropriate time for each, and list any supporting materials needed.',
    // 	useCase: 'Create',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'create-personalized-onboarding-plan',
    // 	title: 'Create personalized onboarding plan',
    // 	prompt:
    // 		'Create a 30-day plan to help me get up to speed. I am onboarding onto `team` as a `role`. Include learning resources, team priorities, key contacts, and engagement strategies.',
    // 	useCase: 'Create',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'create-presentation-outline',
    // 	title: 'Create presentation outline',
    // 	prompt:
    // 		'Outline a talk track for a presentation targeting `company/product` clients in the `sector` to educate them on the `solution`. Ensure the talk track is clear, informative, and formatted with timestamps in a table.',
    // 	useCase: 'Create',
    // 	roles: ['Product', 'Marketing', 'Sales'],
    // },
    // {
    // 	id: 'create-pricing-model-customers',
    // 	title: 'Create pricing model for customers',
    // 	prompt:
    // 		'Generate a pricing model for `customer/product` using the latest customer data. Include scenario analysis and pricing plan comparisons.',
    // 	useCase: 'Create',
    // 	roles: ['Sales', 'Product', 'Marketing'],
    // },
    {
        id: 'create-product-requirements-document',
        title: 'Create product requirements document',
        prompt: 'Draft a PRD for `project/feature`. Depending on context such as OKRs, PRD, A/B test, retrospective, include objectives, hypotheses, requirements, metrics, learnings, and next steps.',
        useCase: 'Create',
        roles: [
            'Program Management',
            'Design',
            'Product',
            'Engineering'
        ]
    },
    // {
    // 	id: 'create-recurring-calendar-meeting',
    // 	title: 'Create recurring calendar meeting',
    // 	prompt:
    // 		'Create a `number of minutes` recurring calendar meeting every `day` at `HH:MM am/pm` `timezone` for `project` with `person`.',
    // 	useCase: 'Execute',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'create-release-notes',
    // 	title: 'Create release notes',
    // 	prompt:
    // 		'Create clear release documentation for `project/product`. Include release date, features, fixes, known issues, and Jira work items/references if found. Provide output in multiple formats such as Confluence, PDF, Markdown as needed.',
    // 	useCase: 'Create',
    // 	roles: ['Engineering', 'Program Management', 'Product', 'Customer Support'],
    // },
    // {
    // 	id: 'create-resolution-notes',
    // 	title: 'Create resolution notes',
    // 	prompt:
    // 		'Create resolution notes for future reference suitable for other agents and team leads to quickly understand the following work item and its resolution: `work item link`. Include a brief and clear description of the problem, the identified root cause, and a summary of the diagnostic steps and actions performed. Clearly state the exact resolution that was implemented. Specify the total time from ticket creation to resolution using HH:MM format, or days/hours if longer.',
    // 	useCase: 'Create',
    // 	roles: ['Helpdesk Support', 'Customer Support', 'IT Ops'],
    // },
    // {
    // 	id: 'draft-blog-post',
    // 	title: 'Draft a blog post',
    // 	prompt:
    // 		'Draft a blog post or marketing collateral for `product/feature`. Highlight key benefits, use cases, and include customer testimonials if available.',
    // 	useCase: 'Create',
    // 	roles: ['Marketing', 'Product', 'Sales'],
    // },
    // {
    // 	id: 'draft-usability-testing-script',
    // 	title: 'Draft a usability testing script',
    // 	prompt:
    // 		'Draft a detailed usability testing script for the following feature/product `Confluence page link`. The script should be suitable for a moderated session and include the following sections: Introduction for the participant (Reassure the participant that the focus is on the product, not their performance), Warm-up/background questions, Scenario setup, Task instructions, and Wrap-up questions. For each task, specify what a successful outcome looks like and, if appropriate, include a rating scale for ease of use. Throughout, use accessible, concise, and clear language, avoid jargon and directional UI language, keep instructions and questions short and focused, and ensure the script is easy to follow for both moderator and participant, formatting it as a template that can be easily adapted for different products or features',
    // 	useCase: 'Create',
    // 	roles: ['Design', 'Product'],
    // },
    // {
    // 	id: 'draft-and-send-email',
    // 	title: 'Draft and send email',
    // 	prompt:
    // 		"Draft an email to `email address` with the subject `Subject` with a message regarding `topic/purpose`. Once I've confirmed, send this email.",
    // 	useCase: 'Execute',
    // 	roles: ['General'],
    // },
    {
        id: 'edit-confluence-page-status',
        title: 'Edit Confluence page status',
        prompt: "Update this page's status to Ready for Review: `Confluence page link`",
        useCase: 'Execute',
        roles: [
            'General',
            'Engineering',
            'Product',
            'Program Management'
        ]
    },
    // {
    // 	id: 'explain-acronym',
    // 	title: 'Explain an acronym',
    // 	prompt:
    // 		"Explain the meaning of the acronym '`acronym`' in this context: `context`. Provide its full form and a brief definition.",
    // 	useCase: 'Learn',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'explain-end-to-end-service-flow',
    // 	title: 'Explain End-to-End Service Flow',
    // 	prompt:
    // 		'Explain the `process/system flow` for `feature` as experienced by `end-user/customer`. Include each step from `start event` to `end event`. Highlight any system interactions, notifications, and common issues or exceptions. Provide diagrams or documentation links if available.',
    // 	useCase: 'Learn',
    // 	roles: [
    // 		'Sales',
    // 		'IT Ops',
    // 		'Program Management',
    // 		'Customer Support',
    // 		'Product',
    // 		'Security',
    // 		'Helpdesk Support',
    // 		'Engineering',
    // 	],
    // },
    {
        id: 'explain-code',
        title: 'Explain this code',
        prompt: 'Explain what the code below does, describing its purpose, how it works, and any important details or logic involved. Use clear, concise language suitable for someone with basic programming knowledge. `Insert code snippet`.',
        useCase: 'Learn',
        roles: [
            'Engineering'
        ]
    },
    {
        id: 'extract-key-insights-datasets',
        title: 'Extract key insights from datasets',
        prompt: '`Upload dataset file(s)` Based on the provided dataset, please analyze and present the top 5 most interesting observations, highlights, or trends, identifying segments that were more likely to respond in a certain way, significant patterns, or unexpected insights from the data.',
        useCase: 'Analyze',
        roles: [
            'Product',
            'Marketing',
            'Engineering'
        ]
    },
    // {
    // 	id: 'find-analyze-customer-contracts',
    // 	title: 'Find and analyze information from customer contracts',
    // 	prompt:
    // 		'Analyze all existing contracts for `project/customer segment/time period` and extract information on response times, maintenance obligations, and product rates. Present findings in a comparative table, highlighting any variations between customers. If available, include contract names (`Contract name/ID`), customer names (`Customer A, Customer B]), and any relevant contract dates (`Effective Date, Expiry Date`).',
    // 	useCase: 'Analyze',
    // 	roles: ['Product', 'Program Management'],
    // },
    {
        id: 'find-prioritize-open-pull-requests',
        title: 'Find and prioritize open pull requests',
        prompt: "Summarize all my open pull requests in across all repositories I have access to in Bitbucket, as well as all pull requests where I'm assigned as a reviewer. Clearly indicate the number of pull requests pending my review and the total number of open PRs involving me. Group the results by repository and include key details such as PR title, status, author, and last updated date.",
        useCase: 'Summarize',
        roles: [
            'Engineering'
        ]
    },
    // {
    // 	id: 'find-hr-policies',
    // 	title: 'Find HR policies',
    // 	prompt:
    // 		'Find all the HR policies that a new hire joining the `location` office would need during onboarding. Reference the latest HR policy resources. Organize results in a table and check if all required policies and contacts are included.',
    // 	useCase: 'Find',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'find-information-3p-sources',
    // 	title: 'Find information from 3P sources',
    // 	prompt: 'Find the latest `topic` presentation in our Google Drive or other 3rd party sources.',
    // 	useCase: 'Find',
    // 	roles: ['Product', 'Marketing', 'Sales'],
    // },
    {
        id: 'find-overdue-jira-work-items',
        title: 'Find overdue Jira work items for my team',
        prompt: 'Show all overdue work items for my team, including links to them and how long they have been overdue.',
        useCase: 'Find',
        roles: [
            'Engineering',
            'IT Ops',
            'Helpdesk Support',
            'Program Management'
        ]
    },
    // {
    // 	id: 'find-potential-security-vulnerabilities',
    // 	title: 'Find potential security vulnerabilities',
    // 	prompt:
    // 		'For this pull request `pull request ID`, identify and summarize any changes that were made that have potential security vulnerabilities.',
    // 	useCase: 'Find',
    // 	roles: ['Security', 'IT Ops'],
    // },
    // {
    // 	id: 'find-related-jira-projects',
    // 	title: 'Find related Jira projects',
    // 	prompt: 'What Jira projects have ongoing work that relates to this decision: `description`?',
    // 	useCase: 'Find',
    // 	roles: ['Program Management', 'Product', 'Engineering'],
    // },
    {
        id: 'find-relevant-confluence-pages',
        title: 'Find relevant Confluence pages',
        prompt: 'For `work item ID/project/feature`, find and list any related Confluence pages or reference work items. Include links and a brief summary of how each is relevant.',
        useCase: 'Find',
        roles: [
            'Program Management',
            'Product',
            'Engineering'
        ]
    },
    // {
    // 	id: 'find-requirements-jira-work-item',
    // 	title: 'Find requirements for a Jira work item',
    // 	prompt:
    // 		'Identify and document the requirements for work item `work item ID`. Ensure all necessary details are captured, including dependencies and acceptance criteria.',
    // 	useCase: 'Find',
    // 	roles: ['Engineering', 'Product', 'Program Management'],
    // },
    // {
    // 	id: 'find-subject-matter-expertise',
    // 	title: 'Find subject-matter expertise',
    // 	prompt:
    // 		'Find the subject matter expert for `topic`. I need to contact them for `purpose, e.g., advice, review, collaboration`. Confirm the recommended person is the most relevant and available expert.',
    // 	useCase: 'Find',
    // 	roles: ['General', 'Engineering', 'Product', 'Program Management'],
    // },
    // {
    // 	id: 'draft-it-support-response',
    // 	title: 'Draft IT Support response',
    // 	prompt:
    // 		'Draft a reply to a user who is experiencing `topic` issues. Provide clear, empathetic guidance and suggest next steps for resolving the problem using this guide/playbook [Confluence page link]. Here is the user request: `User request`.',
    // 	useCase: 'Create',
    // 	roles: ['Customer Support', 'Helpdesk Support'],
    // },
    {
        id: 'find-latest-company-policies',
        title: 'Find the latest company policies',
        prompt: 'How do I request reimbursements for my travels?',
        useCase: 'Learn',
        roles: [
            'General'
        ]
    },
    {
        id: 'generate-faq',
        title: 'Generate an FAQ',
        prompt: "Map out the typical customer journey for `product/service`, from initial discovery through onboarding, usage, and support. Then, generate top FAQs that customers most frequently ask at each stage\u2014covering how to get started, feature usage, troubleshooting, billing, and best practices\u2014with concise, step-by-step answers formatted for a chatbot.",
        useCase: 'Create',
        roles: [
            'Customer Support',
            'Program Management',
            'Product',
            'Marketing'
        ]
    },
    {
        id: 'generate-post-project-surveys',
        title: 'Generate post-project surveys',
        prompt: "Create a comprehensive evaluation survey for `project` to assess the project's performance, including successes, challenges, areas for improvement, and lessons learned. Include questions such as scale, multiple choice, and open answer covering: objectives and outcomes, budget and resources, team performance and collaboration, challenges and problem-solving, stakeholder satisfaction, and recommendations for future projects.",
        useCase: 'Create',
        roles: [
            'Program Management',
            'Product',
            'General'
        ]
    },
    // {
    // 	id: 'identify-upsell-opportunities',
    // 	title: 'Identify upsell opportunities',
    // 	prompt:
    // 		"Analyze the provided call transcript `link to call transcript` with the customer `customer name` and identify all instances where the customer expresses interest in additional features or services. For each instance, include relevant background context, the exact customer quote indicating interest, and a brief explanation of why it represents a potential upsell opportunity. Additionally, recommend the most suitable upsell product or service based on the customer's expressed needs or goals.",
    // 	useCase: 'Analyze',
    // 	roles: ['Sales', 'Product', 'Customer Support', 'Marketing'],
    // },
    {
        id: 'learn-company-procedure-information',
        title: 'Learn about company procedure information',
        prompt: 'Summarize the standard procedures for `process/activity` across the company. Include step-by-step instructions and reference documents.',
        useCase: 'Summarize',
        roles: [
            'General',
            'IT Ops',
            'Program Management'
        ]
    },
    // {
    // 	id: 'plan-sprint-tasks',
    // 	title: 'Plan sprint tasks',
    // 	prompt:
    // 		'Generate a detailed task list for our upcoming sprint using the information provided in `project poster`. For each task, include the task name, a brief description, the responsible team member, and estimated completion time. Organize the tasks by priority level and group them according to their related user stories to ensure clarity and alignment with sprint goals. Flag any missing details needed to finalize sprint planning.',
    // 	useCase: 'Create',
    // 	roles: ['Engineering', 'Program Management', 'Product', 'IT Ops'],
    // },
    // {
    // 	id: 'prepare-performance-review',
    // 	title: 'Prepare for your performance review',
    // 	prompt:
    // 		'Prepare talking points for an upcoming growth conversation with my manager, summarizing my work between `dates`, organized by key projects. The points should facilitate a productive discussion about my performance, achievements, and areas for improvement. They should be clear, concise, and backed by specific examples and evidence. Organize into sections for each major project, including: project overview, my specific contributions, and relevant links.',
    // 	useCase: 'Summarize',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'retrieve-pull-request-insights-jira',
    // 	title: 'Retrieve pull request insights from Jira',
    // 	prompt:
    // 		'For the given Jira work item Jira work item `link to Jira work item`, retrieve all linked pull requests across repositories. Include each pull request number, title, current review status such as Draft, Open, Approved, Merged, or Rejected, the associated reviewers, and the merge date if applicable. Output a structured table with the columns PR Number, Title, Status, Reviewers, and Merge Date.',
    // 	useCase: 'Find',
    // 	roles: ['Engineering'],
    // },
    // {
    // 	id: 'review-improve-presentation',
    // 	title: 'Review and improve presentation',
    // 	prompt:
    // 		'Review this presentation `upload or link presentation slides/script` and provide me with suggestions on how to improve it. Please consider the following context: the audience consists of [audience, e.g., senior executives, students, clients], the primary goal is [goal, e.g., to persuade, to inform, to inspire], and the desired outcome is `outcome, e.g., increased engagement, clear understanding, actionable next steps`. Focus your feedback on the overall structure, flow, clarity, and impact, and tailor your suggestions to maximize effectiveness for this specific audience and goal.',
    // 	useCase: 'Review',
    // 	roles: ['General'],
    // },
    {
        id: 'review-improve-writing',
        title: 'Review and improve writing',
        prompt: 'Rewrite the following message to make it more clear, concise, and professional while retaining all key details: `Insert message here`.',
        useCase: 'Review',
        roles: [
            'General',
            'Sales',
            'Customer Support'
        ]
    },
    {
        id: 'search-policies-questionnaires',
        title: 'Search policies related to questionnaires',
        prompt: 'Search all internal security and compliance policies and provide answers to the following questionnaire. Reference policy documents and highlight relevant sections for each answer.',
        useCase: 'Find',
        roles: [
            'Security',
            'IT Ops'
        ]
    },
    // {
    // 	id: 'send-ms-teams-weekly-progress',
    // 	title: 'Send MS Teams message of weekly progress',
    // 	prompt:
    // 		'Draft a summary of the key updates and additions I made over the past week. Send this summary in MS Teams to `Teams channel link`. Confirm the draft with me before sending.',
    // 	useCase: 'Execute',
    // 	roles: ['General'],
    // },
    {
        id: 'suggest-process-streamlining',
        title: 'Suggest process streamlining',
        prompt: 'Suggest ways to streamline the process for `process/task`. Identify steps that can be automated or simplified to reduce manual work and produce more succinct outputs.',
        useCase: 'Learn',
        roles: [
            'Program Management',
            'IT Ops',
            'Engineering'
        ]
    },
    {
        id: 'summarize-track-project-updates',
        title: 'Summarize and track project updates',
        prompt: 'Summarize the status and history of `project/topic/feature`. Include key initiatives, progress made, stakeholders, decisions, timelines, and relevant documents. Highlight upcoming milestones or blockers.',
        useCase: 'Summarize',
        roles: [
            'General',
            'Engineering',
            'Product',
            'Program Management'
        ]
    },
    // {
    // 	id: 'summarize-confluence-page-google-doc',
    // 	title: 'Summarize Confluence page and add to Google doc',
    // 	prompt:
    // 		'Summarize key points and any action items/next steps in this Confluence page: `Confluence page link` and add this summary to a new Google doc titled "`title`" under the folder "`folder`."',
    // 	useCase: 'Summarize',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'summarize-engineering-requests',
    // 	title: 'Summarize engineering requests',
    // 	prompt: 'Review and summarize recent Engineering Requests (ERs) for my team.',
    // 	useCase: 'Review',
    // 	roles: ['Engineering', 'Product', 'Program Management'],
    // },
    {
        id: 'summarize-meeting-notes',
        title: 'Summarize meeting notes',
        prompt: 'Summarize the meeting with the transcript `attach file or paste transcript`, including main topics discussed, key decisions, and action items.',
        useCase: 'Summarize',
        roles: [
            'General'
        ]
    },
    {
        id: 'synthesize-user-testing-findings',
        title: 'Synthesize findings from user testing',
        prompt: 'Synthesize key insights from my user testing: `Confluence page link/transcript`. Identify the top pain points or issues that users faced during the testing. Categorize these issues by severity and impact on user experience.',
        useCase: 'Analyze',
        roles: [
            'Design'
        ]
    },
    {
        id: 'visualize-data-charts',
        title: 'Visualize your data into charts',
        prompt: '`Upload your dataset file(s)` Based on the uploaded dataset file, determine the most effective way to visualize the data. Identify the key structure and variables within the dataset and the most likely user goals for this data, to suggest and describe the most appropriate type of visualization.',
        useCase: 'Analyze',
        roles: [
            'Product',
            'Engineering',
            'Marketing'
        ]
    }
];
const $08b97b2e27a84eff$export$802094cfe9873dbe = [
    // Salesforce
    {
        id: '3p-salesforce-recommend-next-steps-deals',
        title: 'Recommend next steps for my deals',
        prompt: 'Recommend next steps for my deals',
        useCase: 'Execute',
        roles: [
            'Sales'
        ],
        appIds: [
            'salesforce'
        ]
    },
    // SharePoint & One Drive & Google Drive
    {
        id: '3p-onboarding-guide',
        title: 'Create onboarding guide',
        prompt: 'Create an onboarding guide for new hires using documents in `product` folder',
        useCase: 'Create',
        roles: [
            'General',
            'Product',
            'Program Management'
        ],
        appIds: [
            'google_drive',
            'microsoft_sharepoint',
            'microsoft_onedrive'
        ]
    },
    {
        id: '3p-find-product-specs-last-month',
        title: 'Find product specs from last month',
        prompt: 'Find product specs in `Google Drive/Sharepoint/Onedrive` that were created in the last month',
        useCase: 'Find',
        roles: [
            'Product',
            'Engineering',
            'Program Management'
        ],
        appIds: [
            'google_drive',
            'microsoft_sharepoint',
            'microsoft_onedrive'
        ]
    },
    {
        id: '3p-callout-risks-fy27',
        title: 'Callout the risks in Strategy doc',
        prompt: 'Callout the risks you see in the FY27 Strategy doc shared with me.',
        useCase: 'Review',
        roles: [
            'General',
            'Product',
            'Program Management'
        ],
        appIds: [
            'google_drive',
            'microsoft_sharepoint',
            'microsoft_onedrive'
        ]
    }
];
const $08b97b2e27a84eff$var$staticPromptsWithSkill = [
    // {
    // 	id: 'summarize-release',
    // 	title: 'Summarize release',
    // 	prompt:
    // 		"/summarize-release this `Jira release` for `product` to generate an executive snapshot. Include: 1) key changes grouped by epic or component, 2) risks and blockers with owners and dates, 3) quality signals (open bugs, regressions, flaky tests), 4) planned rollout and key dates, and 5) clear next steps for stakeholders.",
    // 	useCase: 'Summarize',
    // 	roles: ['Product', 'Engineering'],
    // 	enableDeepResearch: true,
    // },
    {
        id: 'create-release',
        title: 'Create release',
        prompt: "/create-release in this `Jira space` to create a new release with start and release dates. Include completed work items and summarize what's included by epic or team.",
        useCase: 'Create',
        roles: [
            'Program Management',
            'Engineering'
        ],
        tags: [
            'jira-releases'
        ]
    },
    // {
    // 	id: 'draft-release-notes',
    // 	title: 'Draft release notes',
    // 	prompt:
    // 		"/draft-release-notes for this `Jira release` and related `Confluence page` to generate customer-facing release notes. Organize into \"What's new\", \"Improvements\", \"Fixes\", and \"Known issues\" with clear, non-technical language.",
    // 	useCase: 'Create',
    // 	roles: ['Marketing', 'Engineering'],
    // 	enableDeepResearch: true,
    // },
    // {
    // 	id: 'create-work-items',
    // 	title: 'Create work items',
    // 	prompt:
    // 		"/create-work-items from this `Confluence page` (feature spec) in this `Jira space`. Break the feature into epics, stories, and tasks with summaries, descriptions, and estimates. List everything created, grouped by epic.",
    // 	useCase: 'Create',
    // 	roles: ['Product', 'Engineering'],
    // 	enableDeepResearch: true,
    // },
    // {
    // 	id: 'write-status-update',
    // 	title: 'Write status update',
    // 	prompt:
    // 		"/write-status-update with this `Jira space` and these `Confluence pages` to draft a status update for `project/initiative` over the last `time period`. Include overall RAG, key achievements, major risks/blockers with owners, and next steps.",
    // 	useCase: 'Create',
    // 	roles: ['Program Management', 'Product'],
    // 	enableDeepResearch: true,
    // },
    // {
    // 	id: 'page-catchup',
    // 	title: 'Page catchup',
    // 	prompt:
    // 		"/page-catchup this `Confluence page` to summarize what changed in the last `time period`. Highlight new sections, major edits, important comments, and open tasks or questions.",
    // 	useCase: 'Summarize',
    // 	roles: ['General'],
    // },
    // {
    // 	id: 'update-work-items',
    // 	title: 'Update work items',
    // 	prompt:
    // 		"/update-work-items for these `Jira work items` in this `Jira space` to bulk update: set assignee, add label, and move items to a new status if no blockers. Show a summary of planned changes first.",
    // 	useCase: 'Execute',
    // 	roles: ['Program Management', 'Engineering'],
    // },
    // {
    // 	id: 'manage-jira-permissions',
    // 	title: 'Manage Jira permissions',
    // 	prompt:
    // 		"/manage-jira-permissions for this `Jira work item` or `Jira space` to diagnose permission issues, explain missing permissions, and provide admin guidance to resolve.",
    // 	useCase: 'Execute',
    // 	roles: ['IT Ops', 'Security'],
    // },
    // {
    // 	id: 'find-jira-settings',
    // 	title: 'Find Jira settings',
    // 	prompt:
    // 		"/find-jira-settings for this `Jira space` and my goal \"`desired behavior`\". Tell me which settings to change, where to find them, and any trade-offs.",
    // 	useCase: 'Find',
    // 	roles: ['IT Ops'],
    // },
    {
        id: 'manage-jira-workflows',
        title: 'Manage Jira workflows',
        prompt: '/manage-jira-workflows for this `Jira space` to analyze its workflow: explain statuses, transitions, top workflow rules, and propose simplifications.',
        useCase: 'Execute',
        roles: [
            'IT Ops',
            'Program Management'
        ],
        tags: [
            'jira-workflows'
        ]
    },
    // {
    // 	id: 'search-assets',
    // 	title: 'Search Assets',
    // 	prompt:
    // 		"/search-assets in this `JSM project` for \"`asset search criteria`\" and highlight any related to this `JSM incident` or `Jira work item`. Return a table of matching assets.",
    // 	useCase: 'Find',
    // 	roles: ['IT Ops'],
    // },
    // {
    // 	id: 'create-pir',
    // 	title: 'Create PIR',
    // 	prompt:
    // 		"/create-pir for this `JSM incident` and related `Confluence pages` to draft a complete Post Incident Review with all standard sections.",
    // 	useCase: 'Create',
    // 	roles: ['IT Ops'],
    // 	enableDeepResearch: true,
    // },
    {
        id: 'analyze-incident-root-cause',
        title: 'Find root cause of an incident (RCA)',
        prompt: '/analyze-incident-root-cause for this `JSM incident` to analyze details, linked alerts, changes, assets, and similar incidents. Propose likely root cause and investigation steps.',
        useCase: 'Analyze',
        roles: [
            'IT Ops'
        ],
        enableDeepResearch: true
    },
    {
        id: 'find-incident-root-cause',
        title: 'Find incident root cause',
        prompt: '/find-incident-root-cause for this `JSM incident` to infer the most likely root cause and provide a stakeholder-friendly summary.',
        useCase: 'Find',
        roles: [
            'IT Ops',
            'General'
        ],
        enableDeepResearch: true
    },
    // {
    // 	id: 'find-incidents',
    // 	title: 'Find incidents',
    // 	prompt:
    // 		"/find-incidents in this `JSM project` for incidents from the last `time period` matching \"`criteria`\". Group by status or service, show counts, and surface the most impactful incidents.",
    // 	useCase: 'Find',
    // 	roles: ['IT Ops'],
    // },
    {
        id: 'find-similar-incidents',
        title: 'Find similar incidents',
        prompt: '/find-similar-incidents for this `JSM incident` to find the most similar historical incidents, how they were resolved, and any recurring patterns.',
        useCase: 'Find',
        roles: [
            'IT Ops'
        ],
        enableDeepResearch: true
    },
    {
        id: 'suggest-problem-ticket',
        title: 'Suggest problem ticket',
        prompt: '/suggest-problem-ticket for this `JSM incident` to check for similar incidents and, if recurring, propose a problem ticket with all key details and links.',
        useCase: 'Create',
        roles: [
            'IT Ops'
        ]
    },
    {
        id: 'suggest-incident-fields',
        title: 'Suggest incident fields',
        prompt: '/suggest-incident-fields for this `JSM incident` to propose values for service, component, priority, impact, urgency, and major incident flag, with justifications.',
        useCase: 'Execute',
        roles: [
            'Helpdesk Support',
            'IT Ops'
        ]
    },
    {
        id: 'suggest-incident-sme',
        title: 'Suggest incident SME',
        prompt: '/suggest-incident-expert for this `JSM incident` to recommend the best people or teams to involve, with reasons and suggested actions.',
        useCase: 'Find',
        roles: [
            'IT Ops'
        ]
    },
    {
        id: 'summarize-incident',
        title: 'Summarize incident',
        prompt: '/summarize-incident for this `JSM incident` to create an executive summary with impact, timeline, root cause, mitigation, and next steps.',
        useCase: 'Summarize',
        roles: [
            'IT Ops',
            'General'
        ]
    },
    // {
    // 	id: 'find-alerts',
    // 	title: 'Find alerts',
    // 	prompt:
    // 		"/find-alerts in this `JSM project` for alerts from the last `time period`. Group by service and severity, highlight recurring alerts, and relate to incidents or changes.",
    // 	useCase: 'Find',
    // 	roles: ['IT Ops', 'Engineering'],
    // },
    // {
    // 	id: 'recommend-playbook',
    // 	title: 'Recommend playbook',
    // 	prompt:
    // 		"/recommend-playbook for this `alert` or `JSM incident` to suggest the best runbooks or playbooks, with links and first steps.",
    // 	useCase: 'Find',
    // 	roles: ['IT Ops', 'Engineering'],
    // },
    {
        id: 'assess-change-risk-insights',
        title: 'Assess change risk insights',
        prompt: '/assess-change-risk for this `JSM change request` to assess risk, explain drivers, and suggest safeguards like canary deployments or extra approvals.',
        useCase: 'Analyze',
        roles: [
            'IT Ops'
        ]
    },
    {
        id: 'get-data-insights',
        title: 'Get data insights',
        prompt: '/get-data-insights for this `Jira space` to create charts (throughput, cycle time, WIP) and interpret trends, bottlenecks, and recommendations.',
        useCase: 'Analyze',
        roles: [
            'Engineering',
            'Program Management'
        ],
        enableDeepResearch: true
    }
];
// Filters out prompt cards that reference skills but have no skill metadata.
// This will also act as an entitlement check for the user.
const $08b97b2e27a84eff$var$filterCardsBySkillMetadata = (cards, skillMetadataMap)=>{
    if (skillMetadataMap === undefined) return cards;
    return cards.filter((card)=>{
        const slugs = $08b97b2e27a84eff$export$bee44b12dce7b448(card.prompt);
        if (slugs.length === 0) return true;
        return slugs.every((slug)=>slug in skillMetadataMap);
    });
};
const $08b97b2e27a84eff$export$47aa2ee75b720c2e = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(2);
    const skillMetadata = (0, $kfhjt.useSkillMetadata)();
    let t0;
    if ($[0] !== skillMetadata?.skillMetadataMap) {
        const first3Prompts = $08b97b2e27a84eff$var$staticPrompts.slice(0, 3);
        const remainingPrompts = $08b97b2e27a84eff$var$staticPrompts.slice(3);
        const skillsPrompts = $08b97b2e27a84eff$var$filterCardsBySkillMetadata($08b97b2e27a84eff$var$staticPromptsWithSkill, skillMetadata?.skillMetadataMap);
        const promptCards = [
            ...first3Prompts,
            ...skillsPrompts,
            ...remainingPrompts
        ];
        t0 = {
            promptCards: promptCards
        };
        $[0] = skillMetadata?.skillMetadataMap;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const skillMetadata = (0, $kfhjt.useSkillMetadata)();
    // First 3 curated prompts, then skills prompts, then the rest
    const first3Prompts = $08b97b2e27a84eff$var$staticPrompts.slice(0, 3);
    const remainingPrompts = $08b97b2e27a84eff$var$staticPrompts.slice(3);
    const skillsPrompts = $08b97b2e27a84eff$var$filterCardsBySkillMetadata($08b97b2e27a84eff$var$staticPromptsWithSkill, skillMetadata?.skillMetadataMap);
    const promptCards = [
        ...first3Prompts,
        ...skillsPrompts,
        ...remainingPrompts
    ];
    return {
        promptCards: promptCards
    };
};
module.exports["useCaseOptions"] = $08b97b2e27a84eff$export$9fa6e712ef03097f;
module.exports["roleOptions"] = $08b97b2e27a84eff$export$9472c6a87dde5170;
module.exports["PROMPT_LIBRARY_SKILL_TAG"] = $08b97b2e27a84eff$export$1ac99e1b5b1a8cfe;
module.exports["usePromptCards"] = $08b97b2e27a84eff$export$47aa2ee75b720c2e;

});

parcelRegister("02cx8", function(module, exports) {
/* eslint-disable object-shorthand */ 
var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $4c5988c837301b49$export$d4c72bab9d6cc13a = {
    actions: [],
    agentMentionId: null,
    agentMentionInsertionCount: 0,
    resolvedAgentMentionId: null,
    agentMentionContext: null,
    agentMentionName: null,
    agentMentionParentNodeType: null
};
const $4c5988c837301b49$export$e324594224ef24da = {
    setActions: (actions)=>({ setState: setState })=>{
            setState({
                actions: actions
            });
        },
    setContext: (context)=>({ setState: setState })=>{
            setState({
                context: context
            });
        },
    removeContext: ()=>({ setState: setState })=>{
            setState({
                context: undefined
            });
        },
    removeActions: ()=>({ setState: setState })=>{
            setState({
                actions: []
            });
        },
    setAgentMentionState: (state)=>({ setState: setState, getState: getState })=>{
            // Only reset resolvedAgentMentionId when the agent itself changes — not when
            // agentMentionContext updates (user typing after the mention) — to prevent the nudge
            // from flashing on every keystroke while the resolved UUID is already available.
            const current = getState();
            // Reset resolvedAgentMentionId when the agent changes OR when a new insertion
            // is made for the same agent — the insertion count increase means a new fetch
            // is about to start, and the old resolved UUID should not persist if it fails.
            const shouldResetResolved = state.agentMentionId !== current.agentMentionId || state.agentMentionInsertionCount !== current.agentMentionInsertionCount;
            setState({
                ...state,
                ...shouldResetResolved ? {
                    resolvedAgentMentionId: null
                } : {}
            });
        },
    setResolvedAgentMentionId: (resolvedAgentMentionId)=>({ setState: setState })=>{
            setState({
                resolvedAgentMentionId: resolvedAgentMentionId
            });
        }
};
const $4c5988c837301b49$export$e72cf4a64160987e = (0, $1P1Tu.createStore)({
    initialState: $4c5988c837301b49$export$d4c72bab9d6cc13a,
    actions: $4c5988c837301b49$export$e324594224ef24da,
    name: 'EditorRovoButtonActionsStore'
});
const $4c5988c837301b49$export$b95031893a3d9d63 = (0, $9zUhf.createActionsHook)($4c5988c837301b49$export$e72cf4a64160987e);
const $4c5988c837301b49$export$c693678b9cc11679 = (0, $9zUhf.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.actions
});
const $4c5988c837301b49$export$59213a5c9f9d59b8 = (0, $9zUhf.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.context
});
const $4c5988c837301b49$export$f47243b349b78626 = (0, $9zUhf.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.agentMentionId
});
const $4c5988c837301b49$export$65c1c9c4f5245bef = (0, $9zUhf.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.agentMentionInsertionCount
});
const $4c5988c837301b49$export$c4372fb8872a2f0b = (0, $9zUhf.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.resolvedAgentMentionId
});
const $4c5988c837301b49$export$5c060a79a26e7361 = (0, $9zUhf.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.agentMentionContext
});
const $4c5988c837301b49$export$95a191dd4fa0d1fd = (0, $9zUhf.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.agentMentionName
});
const $4c5988c837301b49$export$f79a54b315516f9f = (0, $9zUhf.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.agentMentionParentNodeType
});
module.exports["useEditorRovoButtonActions"] = $4c5988c837301b49$export$b95031893a3d9d63;
module.exports["useEditorRovoButtonActionsActions"] = $4c5988c837301b49$export$c693678b9cc11679;
module.exports["useEditorRovoButtonActionsContext"] = $4c5988c837301b49$export$59213a5c9f9d59b8;
module.exports["useEditorRovoButtonAgentMentionId"] = $4c5988c837301b49$export$f47243b349b78626;
module.exports["useEditorRovoButtonAgentMentionInsertionCount"] = $4c5988c837301b49$export$65c1c9c4f5245bef;
module.exports["useEditorRovoButtonResolvedAgentMentionId"] = $4c5988c837301b49$export$c4372fb8872a2f0b;
module.exports["useEditorRovoButtonAgentMentionContext"] = $4c5988c837301b49$export$5c060a79a26e7361;
module.exports["useEditorRovoButtonAgentMentionName"] = $4c5988c837301b49$export$95a191dd4fa0d1fd;
module.exports["useEditorRovoButtonAgentMentionParentNodeType"] = $4c5988c837301b49$export$f79a54b315516f9f;

});

parcelRegister("boRaI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gj7hi = parcelRequire("gj7hi");


var $b0ri0 = parcelRequire("b0ri0");


var $dAyNE = parcelRequire("dAyNE");


var $1nYBG = parcelRequire("1nYBG");


var $7vkPX = parcelRequire("7vkPX");


var $70S4K = parcelRequire("70S4K");


var $i3kbP = parcelRequire("i3kbP");


var $2ONP7 = parcelRequire("2ONP7");


var $jvJxv = parcelRequire("jvJxv");


var $e9z1z = parcelRequire("e9z1z");

const $90920980e2243e44$var$createIcon = (src)=>()=>(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            src: src,
            alt: ''
        });
const $90920980e2243e44$var$defaultIcon = $90920980e2243e44$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($i3kbP))));
const $90920980e2243e44$export$cbe04d535daede57 = {
    Analyze: $90920980e2243e44$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($b0ri0)))),
    Brainstorm: $90920980e2243e44$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($dAyNE)))),
    Review: $90920980e2243e44$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($jvJxv)))),
    Summarize: $90920980e2243e44$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($e9z1z)))),
    Create: $90920980e2243e44$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($1nYBG)))),
    Execute: $90920980e2243e44$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($7vkPX)))),
    Find: $90920980e2243e44$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($70S4K)))),
    Learn: $90920980e2243e44$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($2ONP7))))
};
const $90920980e2243e44$export$8581fc8a588fa6e0 = $90920980e2243e44$var$defaultIcon;
const $90920980e2243e44$export$9b54dda66a3b3d54 = (useCase)=>{
    if (useCase === undefined || !(useCase in $90920980e2243e44$export$cbe04d535daede57)) return $90920980e2243e44$var$defaultIcon;
    return $90920980e2243e44$export$cbe04d535daede57[useCase];
};
module.exports["promptUseCaseIconMap"] = $90920980e2243e44$export$cbe04d535daede57;
module.exports["defaultPromptUseCaseIcon"] = $90920980e2243e44$export$8581fc8a588fa6e0;
module.exports["getUseCaseIcon"] = $90920980e2243e44$export$9b54dda66a3b3d54;

});

parcelRegister("b0ri0", function(module, exports) {
module.exports = new URL("analyze-icon.5c4c7ecb.svg", import.meta.url).toString();

});

parcelRegister("dAyNE", function(module, exports) {
module.exports = new URL("brainstorm-icon.f24d96f2.svg", import.meta.url).toString();

});

parcelRegister("1nYBG", function(module, exports) {
module.exports = new URL("create-icon.59c93a6c.svg", import.meta.url).toString();

});

parcelRegister("7vkPX", function(module, exports) {
module.exports = new URL("execute-icon.d7c359b6.svg", import.meta.url).toString();

});

parcelRegister("70S4K", function(module, exports) {
module.exports = new URL("find-icon.63225fe6.svg", import.meta.url).toString();

});

parcelRegister("i3kbP", function(module, exports) {
module.exports = new URL("general-prompt-icon.5618909f.svg", import.meta.url).toString();

});

parcelRegister("2ONP7", function(module, exports) {
module.exports = new URL("learn-icon.7e0ca0d6.svg", import.meta.url).toString();

});

parcelRegister("jvJxv", function(module, exports) {
module.exports = new URL("review-icon.7da7ded4.svg", import.meta.url).toString();

});

parcelRegister("e9z1z", function(module, exports) {
module.exports = new URL("summarize-icon.5a91c5af.svg", import.meta.url).toString();

});

parcelRegister("cMOU8", function(module, exports) {

let $94f1744708de0a7d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $94f1744708de0a7d$var$load("6wr18"),
    $94f1744708de0a7d$var$load("7t5Ax"),
    $94f1744708de0a7d$var$load("lVBal"),
    $94f1744708de0a7d$var$load("3ZAtx"),
    $94f1744708de0a7d$var$load("2Gceu"),
    $94f1744708de0a7d$var$load("lLK0D"),
    $94f1744708de0a7d$var$load("7EorR"),
    $94f1744708de0a7d$var$load("fisfU"),
    $94f1744708de0a7d$var$load("ffEVr"),
    $94f1744708de0a7d$var$load("aEk9k")
]).then(()=>parcelRequire('e1z3L'));

});

parcelRegister("h8ZMZ", function(module, exports) {

var $lbhE8 = parcelRequire("lbhE8");


var $iSfaF = parcelRequire("iSfaF");

const $53a95f2f1e6fae13$export$9b1c009846eb666 = ()=>{
    const state = (0, $lbhE8.useAtom)((0, $iSfaF.herState));
    return {
        // State
        isHerActive: state.isHerActive,
        isExpanded: state.isExpanded,
        isAnimating: state.isAnimating,
        contentId: state.contentId,
        contentType: state.contentType,
        cloudID: state.cloudID,
        textPreview: state.textPreview,
        tasks: state.tasks,
        notifications: state.notifications,
        toggleHer: // Actions
        $iSfaF.toggleHer,
        openHer: $iSfaF.openHer,
        closeHer: $iSfaF.closeHer,
        setExpanded: $iSfaF.setExpanded,
        setAnimating: $iSfaF.setAnimating,
        appendTextPreview: $iSfaF.appendTextPreview,
        clearTextPreview: $iSfaF.clearTextPreview,
        addNotification: $iSfaF.addNotification,
        removeNotification: $iSfaF.removeNotification
    };
};
module.exports["useHerStore"] = $53a95f2f1e6fae13$export$9b1c009846eb666;

});

parcelRegister("iSfaF", function(module, exports) {

var $9TRAA = parcelRequire("9TRAA");

const $6f93404dd586c0f7$var$initialState = {
    isHerActive: false,
    isExpanded: true,
    isAnimating: true,
    contentId: null,
    contentType: 'page',
    cloudID: '',
    textPreview: '',
    tasks: {},
    notifications: {}
};
const $6f93404dd586c0f7$export$b1d93e626697721f = (0, $9TRAA.e)($6f93404dd586c0f7$var$initialState);
const $6f93404dd586c0f7$export$780673425ffb59a7 = (contentId, cloudID, contentType)=>{
    $6f93404dd586c0f7$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            isHerActive: !prevState.isHerActive,
            // Reset to expanded when opening
            isExpanded: !prevState.isHerActive ? true : prevState.isExpanded,
            isAnimating: !prevState.isHerActive ? true : prevState.isAnimating,
            contentId: !prevState.isHerActive ? contentId ?? null : null,
            contentType: !prevState.isHerActive ? contentType ?? 'page' : 'page',
            cloudID: !prevState.isHerActive ? cloudID ?? prevState.cloudID : prevState.cloudID,
            textPreview: !prevState.isHerActive ? '' : prevState.textPreview
        }));
};
const $6f93404dd586c0f7$export$cc30aca21148df52 = (contentId, cloudID, contentType)=>{
    $6f93404dd586c0f7$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            isHerActive: true,
            isExpanded: true,
            isAnimating: true,
            contentId: contentId ?? null,
            contentType: contentType ?? 'page',
            cloudID: cloudID ?? prevState.cloudID
        }));
};
const $6f93404dd586c0f7$export$d1dd051dd158cf2a = ()=>{
    $6f93404dd586c0f7$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            isHerActive: false,
            contentId: null,
            contentType: 'page',
            textPreview: ''
        }));
};
const $6f93404dd586c0f7$export$daffe9b53f21fd39 = (expanded)=>{
    $6f93404dd586c0f7$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            isExpanded: expanded
        }));
};
const $6f93404dd586c0f7$export$3a38c3c547ba462b = (animating)=>{
    $6f93404dd586c0f7$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            isAnimating: animating
        }));
};
const $6f93404dd586c0f7$export$52a0cc4030ebe376 = (text)=>{
    $6f93404dd586c0f7$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            textPreview: prevState.textPreview + text
        }));
};
const $6f93404dd586c0f7$export$cd85393335c99d14 = ()=>{
    $6f93404dd586c0f7$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            textPreview: ''
        }));
};
const $6f93404dd586c0f7$export$38a248e5348a1dc = (task)=>{
    $6f93404dd586c0f7$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            tasks: {
                ...prevState.tasks,
                [task.task_id]: task
            }
        }));
};
const $6f93404dd586c0f7$export$e8e0154b7bb02be4 = (task)=>{
    $6f93404dd586c0f7$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            tasks: {
                ...prevState.tasks,
                [task.task_id]: task
            }
        }));
};
const $6f93404dd586c0f7$export$e0f6ca2291a97572 = (taskId)=>{
    $6f93404dd586c0f7$export$b1d93e626697721f.set((prevState)=>{
        const { [taskId]: _, ...rest } = prevState.tasks;
        return {
            ...prevState,
            tasks: rest
        };
    });
};
const $6f93404dd586c0f7$export$c7def531c087da85 = (notification)=>{
    $6f93404dd586c0f7$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            notifications: {
                ...prevState.notifications,
                [notification.id]: notification
            }
        }));
};
const $6f93404dd586c0f7$export$92eb0ea44f8c9242 = (notificationId)=>{
    $6f93404dd586c0f7$export$b1d93e626697721f.set((prevState)=>{
        const { [notificationId]: _, ...rest } = prevState.notifications;
        return {
            ...prevState,
            notifications: rest
        };
    });
};
module.exports["herState"] = $6f93404dd586c0f7$export$b1d93e626697721f;
module.exports["toggleHer"] = $6f93404dd586c0f7$export$780673425ffb59a7;
module.exports["openHer"] = $6f93404dd586c0f7$export$cc30aca21148df52;
module.exports["closeHer"] = $6f93404dd586c0f7$export$d1dd051dd158cf2a;
module.exports["setExpanded"] = $6f93404dd586c0f7$export$daffe9b53f21fd39;
module.exports["setAnimating"] = $6f93404dd586c0f7$export$3a38c3c547ba462b;
module.exports["appendTextPreview"] = $6f93404dd586c0f7$export$52a0cc4030ebe376;
module.exports["clearTextPreview"] = $6f93404dd586c0f7$export$cd85393335c99d14;
module.exports["addTask"] = $6f93404dd586c0f7$export$38a248e5348a1dc;
module.exports["updateTask"] = $6f93404dd586c0f7$export$e8e0154b7bb02be4;
module.exports["removeTask"] = $6f93404dd586c0f7$export$e0f6ca2291a97572;
module.exports["addNotification"] = $6f93404dd586c0f7$export$c7def531c087da85;
module.exports["removeNotification"] = $6f93404dd586c0f7$export$92eb0ea44f8c9242;

});

parcelRegister("ag08F", function(module, exports) {

let $777b818fb8055dce$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $777b818fb8055dce$var$load("1jVx9").then(()=>parcelRequire('3D12W'));

});

parcelRegister("9Ima4", function(module, exports) {

let $712969ee490642ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $712969ee490642ea$var$load("k3amn").then(()=>parcelRequire('5A18u'));

});

parcelRegister("8qfS5", function(module, exports) {

let $621d1029373e3a4f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $621d1029373e3a4f$var$load("6wr18"),
    $621d1029373e3a4f$var$load("eEyVs"),
    $621d1029373e3a4f$var$load("ffEVr"),
    $621d1029373e3a4f$var$load("2Hp35")
]).then(()=>parcelRequire('dRspb'));

});

parcelRegister("7rWz7", function(module, exports) {

let $56c87be7be078a90$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $56c87be7be078a90$var$load("1dIEH").then(()=>parcelRequire('1hCz7'));

});

parcelRegister("7K4N2", function(module, exports) {

let $5a308b7718b214de$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5a308b7718b214de$var$load("6wr18"),
    $5a308b7718b214de$var$load("ffEVr"),
    $5a308b7718b214de$var$load("lX2ZR")
]).then(()=>parcelRequire('bl7WT'));

});

parcelRegister("3abxA", function(module, exports) {

let $24db420245279b37$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $24db420245279b37$var$load("4wPZ7").then(()=>parcelRequire('eQF4d'));

});

parcelRegister("6HPDw", function(module, exports) {

let $4e1ed0214d2ddd70$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4e1ed0214d2ddd70$var$load("6wr18"),
    $4e1ed0214d2ddd70$var$load("ffEVr"),
    $4e1ed0214d2ddd70$var$load("3aT4s")
]).then(()=>parcelRequire('ce71E'));

});

parcelRegister("6hYoU", function(module, exports) {

let $49432eed888110e4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $49432eed888110e4$var$load("fjSG8").then(()=>parcelRequire('gMGbk'));

});

parcelRegister("iJqig", function(module, exports) {

let $da30d35519871327$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $da30d35519871327$var$load("31msE").then(()=>parcelRequire('9POeP'));

});

parcelRegister("7mgQ0", function(module, exports) {

let $55b7a61ff96f40e0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $55b7a61ff96f40e0$var$load("KSMZE").then(()=>parcelRequire('jFrMf'));

});

parcelRegister("8nle6", function(module, exports) {
$parcel$export(module.exports, "preloadSpaceDetail", () => (parcelRequire("5SzHz")).preloadSpaceDetail);
$parcel$export(module.exports, "preloadPersonalSpaceDetail", () => (parcelRequire("jLyos")).preloadPersonalSpaceDetail);
$parcel$export(module.exports, "preloadPersonalSpaceDetailsQuery", () => (parcelRequire("jLyos")).preloadPersonalSpaceDetailsQuery);
$parcel$export(module.exports, "ConfluenceSpaceType", () => (parcelRequire("bgmQP")).ConfluenceSpaceType);

var $jmjWc = parcelRequire("jmjWc");


var $5SzHz = parcelRequire("5SzHz");


var $jLyos = parcelRequire("jLyos");


var $bgmQP = parcelRequire("bgmQP");


const $b92195a33e0fb686$export$f10aab7c26f92d55 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7NksR",
    name: "SpaceTargetSelect",
    loader: async ()=>(await Promise.resolve((parcelRequire("bgmQP")))).SpaceTargetSelect
});
module.exports["SpaceTargetSelect"] = $b92195a33e0fb686$export$f10aab7c26f92d55;

});

parcelRegister("5SzHz", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $4ZxLt = parcelRequire("4ZxLt");

const $01831239f93415a0$var$getEmptyResult = ()=>Promise.resolve({
        data: null,
        loading: false,
        error: null
    });
const $01831239f93415a0$export$ec3af86ec6a1dfc6 = async (spaceKey = '', { includeSpaceTypeSettings: includeSpaceTypeSettings = false } = {})=>{
    if (spaceKey) return (0, $dYU3e.query)({
        query: (0, $4ZxLt.default),
        variables: {
            spaceKey: spaceKey,
            includeSpaceTypeSettings: includeSpaceTypeSettings
        },
        __callerPackage__: "@confluence/space-utils"
    });
    return $01831239f93415a0$var$getEmptyResult();
};
const $01831239f93415a0$export$2403e25f29f92c16 = async (spaceKey = '', options)=>{
    return $01831239f93415a0$export$ec3af86ec6a1dfc6(spaceKey, options);
};
module.exports["fetchSpaceDetail"] = $01831239f93415a0$export$ec3af86ec6a1dfc6;
module.exports["preloadSpaceDetail"] = $01831239f93415a0$export$2403e25f29f92c16;

});

parcelRegister("jLyos", function(module, exports) {

var $a2WOL = parcelRequire("a2WOL");


var $dYU3e = parcelRequire("dYU3e");

const $51133d1487ddd8f7$export$945871a9cdda3d0b = (0, $a2WOL.default);
const $51133d1487ddd8f7$export$88da34a67bdae7e0 = ()=>{
    return (0, $dYU3e.query)({
        query: $51133d1487ddd8f7$export$945871a9cdda3d0b,
        __callerPackage__: "@confluence/space-utils"
    });
};
module.exports["preloadPersonalSpaceDetailsQuery"] = $51133d1487ddd8f7$export$945871a9cdda3d0b;
module.exports["preloadPersonalSpaceDetail"] = $51133d1487ddd8f7$export$88da34a67bdae7e0;

});

parcelRegister("a2WOL", function(module, exports) {
/**
 * @generated SignedSource<<99c90ef1034a28215bdf926b84b02699>>
 * @relayHash 0616a22c791eb8d27cd97c38dbbaaaed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fdab4f721e30e106cb6e937af7ef465a8e7ce5047eb501ede326a1f7618e0cbb
const $fb9284d373020379$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v0 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "dataClassificationTags"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "preloadPersonalSpaceDetailsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "preloadPersonalSpaceDetailsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "0616a22c791eb8d27cd97c38dbbaaaed",
            "id": "fdab4f721e30e106cb6e937af7ef465a8e7ce5047eb501ede326a1f7618e0cbb",
            "metadata": {},
            "name": "preloadPersonalSpaceDetailsQuery",
            "operationKind": "query",
            "text": "query preloadPersonalSpaceDetailsQuery{user:confluence_atlassianUser(current:true){id,confluence{space{id,key,dataClassificationTags}}}}"
        }
    };
}();
$fb9284d373020379$var$node.hash = "a2cf47cae3a68d2f66118a725dfea818";
var $fb9284d373020379$export$2e2bcd8739ae039 = $fb9284d373020379$var$node;
module.exports["default"] = $fb9284d373020379$export$2e2bcd8739ae039;

});

parcelRegister("bgmQP", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $6T8v4 = parcelRequire("6T8v4");


var $3hOY6 = parcelRequire("3hOY6");


var $gdv5Z = parcelRequire("gdv5Z");


var $iXCQx = parcelRequire("iXCQx");


var $g5lKx = parcelRequire("g5lKx");

var $c8b68f6ea32b0094$export$2fabe69f8125d5a7 = /*#__PURE__*/ function(ConfluenceSpaceType) {
    ConfluenceSpaceType["ALL"] = "ALL";
    ConfluenceSpaceType["ALL_EXCEPT_PERSONAL"] = "ALL_EXCEPT_PERSONAL";
    ConfluenceSpaceType["ALL_EXCEPT_SPECIFIC"] = "ALL_EXCEPT_SPECIFIC";
    ConfluenceSpaceType["PERSONAL"] = "PERSONAL";
    ConfluenceSpaceType["SPECIFIC"] = "SPECIFIC";
    return ConfluenceSpaceType;
}({});
const $c8b68f6ea32b0094$var$i18n = (0, $aXWIB.defineMessages)({
    ariaLabel: {
        id: "space-utils.permissions-export.form.space-target-select.aria-label",
        defaultMessage: "For which spaces"
    },
    all: {
        id: "space-utils.space-target-select.all",
        defaultMessage: "All"
    },
    allDescription: {
        id: "space-utils.space-target-select.allDescription",
        defaultMessage: "All spaces, regardless of type"
    },
    allExcludingPersonal: {
        id: "space-utils.space-target-select.allExcludingPersonal",
        defaultMessage: "All (excluding personal)"
    },
    allExcludingPersonalDescription: {
        id: "space-utils.space-target-select.allExcludingPersonalDescription",
        defaultMessage: "Don't include any personal spaces"
    },
    allExcludingSpecific: {
        id: "space-utils.space-target-select.allExcludingSpecific",
        defaultMessage: "All (excluding specific spaces)"
    },
    allExcludingSpecificDescription: {
        id: "space-utils.space-target-select.allExcludingSpecificDescription",
        defaultMessage: "Choose specific spaces to exclude"
    },
    personal: {
        id: "space-utils.space-target-select.personal",
        defaultMessage: "Only personal"
    },
    personalDescription: {
        id: "space-utils.space-target-select.personalDescription",
        defaultMessage: "All personal spaces"
    },
    specific: {
        id: "space-utils.space-target-select.specific",
        defaultMessage: "Only specific spaces"
    },
    specificDescription: {
        id: "space-utils.space-target-select.specificDescription",
        defaultMessage: "Choose specific spaces to include"
    }
});
const $c8b68f6ea32b0094$var$menuItemStyle = {
    style: "_zulp1b66 _1e0c1txw _2lx21bp4"
};
const $c8b68f6ea32b0094$var$CustomOption = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    const $ = (0, $frIzR.c)(10);
    let t0;
    if ($[0] !== props.data.label) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, props.data.label);
        $[0] = props.data.label;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props.data.description) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.text.subtlest"
        }, props.data.description);
        $[2] = props.data.description;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t0 || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $c8b68f6ea32b0094$var$menuItemStyle.style
        }, t0, t1);
        $[4] = t0;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== props || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).Option, props, t2);
        $[7] = props;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
});
const $c8b68f6ea32b0094$var$SELECT_STYLE_PROPS = {
    isSearchable: false,
    styles: {
        menu: (base)=>({
                ...base,
                width: '320px',
                padding: 0,
                margin: 0,
                zIndex: (0, $g5lKx.layers).modal() + 1 // Higher than modal to appear above modal content
            }),
        menuPortal: (base)=>({
                ...base,
                zIndex: (0, $g5lKx.layers).modal() + 1 // Higher than modal to appear above modal content
            }),
        control: (base)=>({
                ...base,
                width: '320px',
                padding: 0,
                margin: 0
            })
    }
};
const $c8b68f6ea32b0094$var$SPACE_TARGET_OPTIONS = [
    {
        label: 'all',
        value: "ALL",
        description: 'allDescription'
    },
    {
        label: 'allExcludingPersonal',
        value: "ALL_EXCEPT_PERSONAL",
        description: 'allExcludingPersonalDescription'
    },
    {
        label: 'allExcludingSpecific',
        value: "ALL_EXCEPT_SPECIFIC",
        description: 'allExcludingSpecificDescription'
    },
    {
        label: 'personal',
        value: "PERSONAL",
        description: 'personalDescription'
    },
    {
        label: 'specific',
        value: "SPECIFIC",
        description: 'specificDescription'
    }
];
const $c8b68f6ea32b0094$export$f10aab7c26f92d55 = (t0)=>{
    const $ = (0, $frIzR.c)(23);
    const { onChange: onChange, spaceTargetValue: spaceTargetValue, menuPortalTarget: menuPortalTarget } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let T0;
    let t1;
    let t2;
    let t3;
    if ($[0] !== formatMessage || $[1] !== onChange || $[2] !== spaceTargetValue) {
        let t4;
        if ($[7] !== formatMessage) {
            t4 = (option)=>({
                    label: formatMessage($c8b68f6ea32b0094$var$i18n[option.label]),
                    value: option.value,
                    description: formatMessage($c8b68f6ea32b0094$var$i18n[option.description])
                });
            $[7] = formatMessage;
            $[8] = t4;
        } else t4 = $[8];
        const options = $c8b68f6ea32b0094$var$SPACE_TARGET_OPTIONS.map(t4);
        T0 = (0, $6T8v4.default);
        t1 = options;
        if ($[9] !== onChange) {
            t2 = (newValue)=>onChange(newValue?.value);
            $[9] = onChange;
            $[10] = t2;
        } else t2 = $[10];
        let t5;
        if ($[11] !== spaceTargetValue) {
            t5 = (option_0)=>String(option_0.value) === String(spaceTargetValue);
            $[11] = spaceTargetValue;
            $[12] = t5;
        } else t5 = $[12];
        t3 = options.find(t5);
        $[0] = formatMessage;
        $[1] = onChange;
        $[2] = spaceTargetValue;
        $[3] = T0;
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else {
        T0 = $[3];
        t1 = $[4];
        t2 = $[5];
        t3 = $[6];
    }
    let t4;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            Option: $c8b68f6ea32b0094$var$CustomOption
        };
        $[13] = t4;
    } else t4 = $[13];
    let t5;
    if ($[14] !== formatMessage) {
        t5 = formatMessage($c8b68f6ea32b0094$var$i18n.ariaLabel);
        $[14] = formatMessage;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== T0 || $[17] !== menuPortalTarget || $[18] !== t1 || $[19] !== t2 || $[20] !== t3 || $[21] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            options: t1,
            onChange: t2,
            value: t3,
            components: t4,
            menuPosition: "fixed",
            menuPortalTarget: menuPortalTarget,
            "aria-label": t5,
            ...$c8b68f6ea32b0094$var$SELECT_STYLE_PROPS
        });
        $[16] = T0;
        $[17] = menuPortalTarget;
        $[18] = t1;
        $[19] = t2;
        $[20] = t3;
        $[21] = t5;
        $[22] = t6;
    } else t6 = $[22];
    return t6;
};
module.exports["ConfluenceSpaceType"] = $c8b68f6ea32b0094$export$2fabe69f8125d5a7;
module.exports["SpaceTargetSelect"] = $c8b68f6ea32b0094$export$f10aab7c26f92d55;

});

parcelRegister("1KHQh", function(module, exports) {
// eslint-disable-next-line confluence-feature-gating/unsafe-no-exposure

var $6mKj3 = parcelRequire("6mKj3");

/**
 * Reads the experimentStartDate param from the cfind_5565_creation_focused_nav_xflow
 * experiment config without firing an exposure. Falls back to 2026-05-07 (the gate
 * rollout date) if the param is missing. Returns null only if the value is not a valid date.
 */ // eslint-disable-next-line confluence-feature-gating/unsafe-no-exposure
const $47ca1d22622dd352$var$XFLOW_EXPERIMENT_START_DATE_FALLBACK = '2026-05-07';
const $47ca1d22622dd352$export$9aeee5d7687bf679 = ()=>{
    // eslint-disable-next-line confluence-feature-gating/unsafe-no-exposure
    const [expConfig] = (0, $6mKj3.UNSAFE_noExposureExp)('cfind_5565_creation_focused_nav_xflow'); // Experiment exposure is fired elsewhere
    const rawValue = expConfig.get('experimentStartDate', $47ca1d22622dd352$var$XFLOW_EXPERIMENT_START_DATE_FALLBACK);
    const date = new Date(rawValue);
    return isNaN(date.getTime()) ? null : date;
};
module.exports["getXflowExperimentStartDate"] = $47ca1d22622dd352$export$9aeee5d7687bf679;

});

parcelRegister("6Dfc9", function(module, exports) {

var $8uR5k = parcelRequire("8uR5k");

var $cFEpk = parcelRequire("cFEpk");

var $da71s = parcelRequire("da71s");

function $e250b9cfd6dd2931$export$46cbbdfdd4d2fcb(isoTimestamp) {
    if (!isoTimestamp) return false;
    const parsed = (0, $da71s.default)(isoTimestamp);
    return (0, $cFEpk.default)(parsed) && (0, $8uR5k.default)(new Date(), parsed) < 24;
}
function $e250b9cfd6dd2931$export$193a557a4d23c9aa(epochMs) {
    const date = new Date(epochMs);
    return (0, $cFEpk.default)(date) && (0, $8uR5k.default)(new Date(), date) < 24;
}
module.exports["isWithinD0Window"] = $e250b9cfd6dd2931$export$46cbbdfdd4d2fcb;

});

parcelRegister("8uR5k", function(module, exports) {
$parcel$export(module.exports, "default", () => $62fa4da7b1bddd96$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $62guz = parcelRequire("62guz");


var $b5utg = parcelRequire("b5utg");


var $fls5L = parcelRequire("fls5L");

function $62fa4da7b1bddd96$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $b5utg.default)(2, arguments);
    var diff = (0, $62guz.default)(dateLeft, dateRight) / (0, $jx0NF.millisecondsInHour);
    return (0, $fls5L.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("jx0NF", function(module, exports) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $e381b83e7c88ee8c$export$dfd9b671c89acc8e = 7;
var $e381b83e7c88ee8c$export$3913210603d8e9ae = 365.2425;
var $e381b83e7c88ee8c$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $e381b83e7c88ee8c$export$91246f0b9bd9beff = 60000;
var $e381b83e7c88ee8c$export$7f72910d6dfd237a = 3600000;
var $e381b83e7c88ee8c$export$397c2d5776aa9055 = 1000;
var $e381b83e7c88ee8c$export$4dec998e48f9c246 = -$e381b83e7c88ee8c$export$81caae6e1cc7a622;
var $e381b83e7c88ee8c$export$f2f5ae5a8e2d8f9f = 60;
var $e381b83e7c88ee8c$export$3c58128db900d44e = 3;
var $e381b83e7c88ee8c$export$80d7e435f744f319 = 12;
var $e381b83e7c88ee8c$export$4db7641526e3241f = 4;
var $e381b83e7c88ee8c$export$698aec755e92c695 = 3600;
var $e381b83e7c88ee8c$export$a77c1a7ebebe2a5a = 60;
var $e381b83e7c88ee8c$export$815a9362476d2fe3 = $e381b83e7c88ee8c$export$698aec755e92c695 * 24;
var $e381b83e7c88ee8c$export$34804a017b31e2fe = $e381b83e7c88ee8c$export$815a9362476d2fe3 * 7;
var $e381b83e7c88ee8c$export$7271e9e3478110d1 = $e381b83e7c88ee8c$export$815a9362476d2fe3 * $e381b83e7c88ee8c$export$3913210603d8e9ae;
var $e381b83e7c88ee8c$export$8e6600bbdee7dabb = $e381b83e7c88ee8c$export$7271e9e3478110d1 / 12;
var $e381b83e7c88ee8c$export$be1dccf2de902d31 = $e381b83e7c88ee8c$export$8e6600bbdee7dabb * 3;
module.exports["millisecondsInMinute"] = $e381b83e7c88ee8c$export$91246f0b9bd9beff;
module.exports["millisecondsInHour"] = $e381b83e7c88ee8c$export$7f72910d6dfd237a;
module.exports["millisecondsInSecond"] = $e381b83e7c88ee8c$export$397c2d5776aa9055;

});

parcelRegister("62guz", function(module, exports) {
$parcel$export(module.exports, "default", () => $464fb8f83176ac12$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $464fb8f83176ac12$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $b5utg.default)(2, arguments);
    return (0, $egXhZ.default)(dateLeft).getTime() - (0, $egXhZ.default)(dateRight).getTime();
}

});

parcelRegister("fls5L", function(module, exports) {
var $b2be9bac2e487919$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $b2be9bac2e487919$var$defaultRoundingMethod = 'trunc';
function $b2be9bac2e487919$export$b6474a47258c1211(method) {
    return method ? $b2be9bac2e487919$var$roundingMap[method] : $b2be9bac2e487919$var$roundingMap[$b2be9bac2e487919$var$defaultRoundingMethod];
}
module.exports["getRoundingMethod"] = $b2be9bac2e487919$export$b6474a47258c1211;

});

parcelRegister("da71s", function(module, exports) {
$parcel$export(module.exports, "default", () => $9951a80eb1f73a12$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $b5utg = parcelRequire("b5utg");


var $jZ39j = parcelRequire("jZ39j");

function $9951a80eb1f73a12$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $b5utg.default)(1, arguments);
    var additionalDigits = (0, $jZ39j.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $9951a80eb1f73a12$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $9951a80eb1f73a12$var$parseYear(dateStrings.date, additionalDigits);
        date = $9951a80eb1f73a12$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $9951a80eb1f73a12$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $9951a80eb1f73a12$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $9951a80eb1f73a12$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $9951a80eb1f73a12$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $9951a80eb1f73a12$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $9951a80eb1f73a12$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $9951a80eb1f73a12$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($9951a80eb1f73a12$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($9951a80eb1f73a12$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($9951a80eb1f73a12$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $9951a80eb1f73a12$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $9951a80eb1f73a12$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $9951a80eb1f73a12$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($9951a80eb1f73a12$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $9951a80eb1f73a12$var$parseDateUnit(captures[1]);
    var month = $9951a80eb1f73a12$var$parseDateUnit(captures[2]) - 1;
    var day = $9951a80eb1f73a12$var$parseDateUnit(captures[3]);
    var week = $9951a80eb1f73a12$var$parseDateUnit(captures[4]);
    var dayOfWeek = $9951a80eb1f73a12$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$9951a80eb1f73a12$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $9951a80eb1f73a12$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$9951a80eb1f73a12$var$validateDate(year, month, day) || !$9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $9951a80eb1f73a12$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $9951a80eb1f73a12$var$parseTime(timeString) {
    var captures = timeString.match($9951a80eb1f73a12$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $9951a80eb1f73a12$var$parseTimeUnit(captures[1]);
    var minutes = $9951a80eb1f73a12$var$parseTimeUnit(captures[2]);
    var seconds = $9951a80eb1f73a12$var$parseTimeUnit(captures[3]);
    if (!$9951a80eb1f73a12$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute) + seconds * 1000;
}
function $9951a80eb1f73a12$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $9951a80eb1f73a12$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($9951a80eb1f73a12$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$9951a80eb1f73a12$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute));
}
function $9951a80eb1f73a12$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $9951a80eb1f73a12$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $9951a80eb1f73a12$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $9951a80eb1f73a12$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($9951a80eb1f73a12$var$daysInMonths[month] || ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 29 : 28));
}
function $9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 366 : 365);
}
function $9951a80eb1f73a12$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $9951a80eb1f73a12$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $9951a80eb1f73a12$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("41KFX", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $dBcar = parcelRequire("dBcar");


var $ivb8S = parcelRequire("ivb8S");


var $6Dfc9 = parcelRequire("6Dfc9");


var $879OR = parcelRequire("879OR");

const $73d6907ec9f8e642$export$fce5991a3cbd7c5a = new Set([
    'default-templates',
    'pin-templates'
]);
const $73d6907ec9f8e642$var$DEFAULT_RESULT = {
    navStyle: 'control',
    isWithinD0: false,
    source: null
};
function $73d6907ec9f8e642$export$9e39472fc9788dd0() {
    if ((0, $9wGTI.fg)('cfind_5565_creation_focused_nav_xflow_preload')) return [
        ...(0, $dBcar.NAV_EXPERIMENT_ONBOARDING_KEYS),
        (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).CHECKED_ELIGIBLE,
        (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).START_AT
    ];
    return [
        ...(0, $dBcar.NAV_EXPERIMENT_ONBOARDING_KEYS)
    ];
}
const $73d6907ec9f8e642$export$aed714501b2c585 = ()=>{
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)($73d6907ec9f8e642$export$9e39472fc9788dd0(), !(0, $9wGTI.fg)('cc_activation_simplify_nav_preloader_enabled'));
    const { isEligible: isEligibleForSimplifyNavXflow, isLoading: isLoadingIsEligibleForSimplifyNavXflow, hasError: hasEligibleForSimplifyNavXflowError, isWithinD0Window: isWithinD0WindowForSimplifyNavXflow } = (0, $879OR.useIsEligibleForSimplifyNavXflow)({
        onboardingStateData: onboardingStateData,
        onboardingStateLoading: onboardingStateLoading,
        onboardingStateError: onboardingStateError,
        skip: !(0, $9wGTI.fg)('cfind_5565_creation_focused_nav_xflow_preload')
    });
    if (onboardingStateLoading) {
        if ((0, $9wGTI.fg)('cc_activation_simplify_nav_preloader_enabled')) return {
            navStyle: 'loading',
            isWithinD0: false,
            source: null
        };
        return $73d6907ec9f8e642$var$DEFAULT_RESULT;
    }
    if (onboardingStateError) return $73d6907ec9f8e642$var$DEFAULT_RESULT;
    const entries = onboardingStateData?.onboardingState;
    if (!entries) return $73d6907ec9f8e642$var$DEFAULT_RESULT;
    const eligibleEntry = entries.find((s)=>s.key === (0, $dBcar.SIMPLIFY_NAV_NEW_USER).NTH_USER_D0_SIMPLIFIED_NAV_ELIGIBLE);
    if (eligibleEntry?.value !== 'true') {
        // Not eligible for new user experiment, but might be for xflow.
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('cfind_5565_creation_focused_nav_xflow_preload')) {
            if (isLoadingIsEligibleForSimplifyNavXflow) // This may happen if TAP traits are loading, although they should generally be preloaded.
            // Case of onboarding state loading is handled in previous conditionals.
            return {
                navStyle: 'loading',
                isWithinD0: false,
                source: null
            };
            if (hasEligibleForSimplifyNavXflowError) return $73d6907ec9f8e642$var$DEFAULT_RESULT;
            if (isEligibleForSimplifyNavXflow) {
                const navStyle = (0, $6mKj3.expVal)('cfind_5565_creation_focused_nav_xflow', 'cohort', 'control');
                if ($73d6907ec9f8e642$export$fce5991a3cbd7c5a.has(navStyle)) return {
                    navStyle: navStyle,
                    isWithinD0: isWithinD0WindowForSimplifyNavXflow,
                    source: 'xflow'
                };
            }
        }
        return $73d6907ec9f8e642$var$DEFAULT_RESULT;
    }
    const navStyle = (0, $6mKj3.expVal)('cc_activation_simplify_nav_new_user', 'cohort', 'control');
    if (!$73d6907ec9f8e642$export$fce5991a3cbd7c5a.has(navStyle)) return $73d6907ec9f8e642$var$DEFAULT_RESULT;
    const startAtEntry = entries.find((s)=>s.key === (0, $dBcar.SIMPLIFY_NAV_NEW_USER).NTH_USER_D0_SIMPLIFIED_NAV_START_AT);
    return {
        navStyle: navStyle,
        isWithinD0: (0, $6Dfc9.isWithinD0Window)(startAtEntry?.value),
        source: 'new-user'
    };
};
module.exports["TREATMENT_COHORTS"] = $73d6907ec9f8e642$export$fce5991a3cbd7c5a;
module.exports["useSimplifiedNavNewUsers"] = $73d6907ec9f8e642$export$aed714501b2c585;

});

parcelRegister("879OR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $kOUwv = parcelRequire("kOUwv");


var $dBcar = parcelRequire("dBcar");


var $ivb8S = parcelRequire("ivb8S");


var $1KHQh = parcelRequire("1KHQh");


var $6Dfc9 = parcelRequire("6Dfc9");

const $1f55678574e67c8a$var$FIRST_ACTIVATION_DATE_TRAIT = 'firstActivationDate';
// Use a module-level variable to ensure the effect only fires once per app lifecycle,
// even if the hook is called from multiple places simultaneously.
let $1f55678574e67c8a$var$hasRunEffect = false;
function $1f55678574e67c8a$export$5b324fbcfda94020() {
    $1f55678574e67c8a$var$hasRunEffect = false;
}
const $1f55678574e67c8a$export$bbe7d46982302b03 = ({ onboardingStateData: onboardingStateData, onboardingStateLoading: onboardingStateLoading, onboardingStateError: onboardingStateError, skip: skip })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    const { data: siteTraitsData, loading: siteTraitsDataLoading, error: siteTraitsDataError } = (0, $kOUwv.useSiteTraits)({
        skipBootstrap: skip
    });
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const entries = onboardingStateData?.onboardingState;
    const isInCfindLandCreationFocusedNavExperiment = !!entries?.find((s)=>s.key === (0, $dBcar.CREATION_FOCUSED_NAV_START_TIME))?.value;
    const isInActivationExperiment = entries?.find(({ key: key })=>key === (0, $dBcar.SIMPLIFY_NAV_NEW_USER).NTH_USER_D0_SIMPLIFIED_NAV_ELIGIBLE)?.value === 'true';
    const isOnboardingStateForExperimentSet = entries?.find(({ key: key })=>key === (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).CHECKED_ELIGIBLE)?.value === 'true';
    const xflowStartAt = entries?.find(({ key: key })=>key === (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).START_AT)?.value;
    // We checked the user's eligibility at one point and determined they were not in treatment.
    const isReturningControlUser = isOnboardingStateForExperimentSet && !xflowStartAt;
    // A user who already has a START_AT recorded is a returning enrolled user and is always eligible.
    const isReturningEnrolledUser = !!xflowStartAt;
    const siteActivationDateTrait = siteTraitsData?.attributes?.find(({ name: name })=>name === $1f55678574e67c8a$var$FIRST_ACTIVATION_DATE_TRAIT)?.value;
    // TAP site traits data is only needed when the user might be a first-time eligible user.
    // If onboarding state alone can determine eligibility, don't wait for TAP data to load —
    // this avoids an unnecessary loading state that hides navigation items.
    const canDetermineWithoutTap = skip || !hasLicensedAccess || isInCfindLandCreationFocusedNavExperiment || isInActivationExperiment || isReturningControlUser || isReturningEnrolledUser;
    const isLoading = !!(onboardingStateLoading || !canDetermineWithoutTap && siteTraitsDataLoading);
    const hasError = !!(onboardingStateError || !canDetermineWithoutTap && siteTraitsDataError);
    // A new user is eligible if their site's firstActivationDate is non-null and
    // after the experiment start date. Returning enrolled users are always eligible.
    const isSiteActivationAfterExperimentStart = ()=>{
        if (!siteActivationDateTrait) return false;
        const experimentStartDate = (0, $1KHQh.getXflowExperimentStartDate)();
        if (!experimentStartDate) return false;
        try {
            return new Date(siteActivationDateTrait) >= experimentStartDate;
        } catch  {
            return false;
        }
    };
    const isEligible = !skip && !isLoading && !hasError && hasLicensedAccess && !isInCfindLandCreationFocusedNavExperiment && !isInActivationExperiment && !isReturningControlUser && (isReturningEnrolledUser || isSiteActivationAfterExperimentStart());
    (0, $42omo.useEffect)(()=>{
        if (!isEligible || isOnboardingStateForExperimentSet || $1f55678574e67c8a$var$hasRunEffect) return;
        $1f55678574e67c8a$var$hasRunEffect = true;
        if ((0, $6mKj3.expValEquals)('cfind_5565_creation_focused_nav_xflow', 'cohort', 'pin-templates')) setOnboardingState([
            {
                key: (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).CHECKED_ELIGIBLE,
                value: 'true'
            },
            {
                key: (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).START_AT,
                value: new Date().toISOString()
            }
        ]);
        else setOnboardingState({
            key: (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).CHECKED_ELIGIBLE,
            value: 'true'
        });
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'eligible',
                actionSubject: 'cfind-5565-simplify-nav-xflow',
                actionSubjectId: 'cfind-5565-simplify-nav-xflow',
                source: 'cfind-5565-simplify-nav-xflow',
                attributes: {
                    siteActivationDate: siteActivationDateTrait
                }
            }
        }).fire();
    }, [
        isEligible,
        isOnboardingStateForExperimentSet,
        setOnboardingState,
        siteActivationDateTrait,
        createAnalyticsEvent
    ]);
    return {
        isLoading: isLoading,
        hasError: hasError,
        isEligible: isEligible,
        // For returning enrolled users, use their START_AT timestamp to determine if they're
        // within the D0 window. For first-time users (no START_AT yet), they're implicitly
        // within their D0 window if and only if they're eligible.
        isWithinD0Window: xflowStartAt ? (0, $6Dfc9.isWithinD0Window)(xflowStartAt) : isEligible
    };
};
module.exports["useIsEligibleForSimplifyNavXflow"] = $1f55678574e67c8a$export$bbe7d46982302b03;

});

parcelRegister("kOUwv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $d684465712516a35$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $d684465712516a35$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState({
                data: null,
                loading: false,
                error: null
            });
        }
};
const $d684465712516a35$export$2d97e7bb018b0cfb = (0, $1P1Tu.createStore)({
    initialState: $d684465712516a35$var$initialState,
    actions: $d684465712516a35$var$actions,
    name: 'siteTraitsStore'
});
const $d684465712516a35$export$c84f691b170cbee3 = (0, $9zUhf.createHook)($d684465712516a35$export$2d97e7bb018b0cfb);
const $d684465712516a35$export$2aca02eeb1d46515 = (0, $9zUhf.createActionsHook)($d684465712516a35$export$2d97e7bb018b0cfb);
async function $d684465712516a35$var$fetchSiteTraitsData(cloudId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $d684465712516a35$var$hasFetched = false;
function $d684465712516a35$export$f1fbc6ad89f91b89() {
    $d684465712516a35$var$hasFetched = false;
}
function $d684465712516a35$var$getSiteTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.site);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.site);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $d684465712516a35$export$fcebe75065597a98({ skipBootstrap: skipBootstrap } = {}) {
    const preloadedData = (0, $42omo.useMemo)(()=>$d684465712516a35$var$getSiteTraitsFromSources(), []);
    const [{ data: data, loading: loading, error: error }, storeActions] = $d684465712516a35$export$c84f691b170cbee3();
    const { accessStatus: accessStatus, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    (0, $42omo.useEffect)(()=>{
        if (preloadedData || data || loading || error) return;
        if ($d684465712516a35$var$hasFetched || skipBootstrap) return;
        if (!hasLicensedAccess || !cloudId) return;
        $d684465712516a35$var$hasFetched = true;
        storeActions.start();
        $d684465712516a35$var$fetchSiteTraitsData(cloudId).then(storeActions.success).catch(storeActions.error);
    }, [
        skipBootstrap,
        preloadedData,
        data,
        loading,
        error,
        storeActions,
        hasLicensedAccess,
        cloudId
    ]);
    if (preloadedData) return {
        data: preloadedData,
        loading: false,
        error: null
    };
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSiteTraits"] = $d684465712516a35$export$fcebe75065597a98;

});

parcelRegister("8G3G6", function(module, exports) {
/**
 * @generated SignedSource<<c5b5f73002999b27d52061f945d6fdad>>
 * @relayHash 4454a52ea4ab532f76ee4e80586f3a56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1b93f6dc06e9898ae5a96da49582122e7834ced458f11ee2b79ed14f9d9b3a87
const $3a0ab9c788e793cd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentType"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentType",
                    "variableName": "contentType"
                }
            ],
            "concreteType": "CatchupLastViewedTimeResponse",
            "kind": "LinkedField",
            "name": "catchupGetLastViewedTime",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "lastViewedTimeISO"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "4454a52ea4ab532f76ee4e80586f3a56",
            "id": "1b93f6dc06e9898ae5a96da49582122e7834ced458f11ee2b79ed14f9d9b3a87",
            "metadata": {},
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "operationKind": "query",
            "text": "query useDynamicSplitButtonCatchupLastViewedTimeQuery($contentId:ID!,$contentType:CatchupContentType!){catchupGetLastViewedTime(contentId:$contentId,contentType:$contentType){lastViewedTimeISO}}"
        }
    };
}();
$3a0ab9c788e793cd$var$node.hash = "4580906c8b823122d6a7f5ad8c2e2c6c";
var $3a0ab9c788e793cd$export$2e2bcd8739ae039 = $3a0ab9c788e793cd$var$node;
module.exports["default"] = $3a0ab9c788e793cd$export$2e2bcd8739ae039;

});

parcelRegister("d282Z", function(module, exports) {
const $a18eeb1d05dccc62$export$fc9b2402bb5adac2 = {
    CONTEXTUAL_FLOATING_BUTTON_NUDGE: 'onboarding-insights:hasContextualFloatingButtonBeenSeen',
    AUDIO_BRIEFING: 'onboarding-insights:hasAudioBriefingChangeboardingBeenSeen',
    AUDIO_V3_CHANGEBOARDING: 'onboarding-insights:hasAudioV3ChangeboardingBeenSeen'
};
const $a18eeb1d05dccc62$export$fac0a92023e58acd = [
    ...Object.values($a18eeb1d05dccc62$export$fc9b2402bb5adac2)
];
module.exports["ONBOARDING_INSIGHTS"] = $a18eeb1d05dccc62$export$fc9b2402bb5adac2;
module.exports["InsightsOnboardingKeys"] = $a18eeb1d05dccc62$export$fac0a92023e58acd;

});

parcelRegister("aXjWU", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");

const $6d6c82fa2f331bd2$var$initialActiveTriggerState = {
    activeTriggerState: {}
};
const $6d6c82fa2f331bd2$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $6d6c82fa2f331bd2$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($6d6c82fa2f331bd2$var$initialActiveTriggerState);
const $6d6c82fa2f331bd2$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($6d6c82fa2f331bd2$var$initialTriggerDispatchState);
const $6d6c82fa2f331bd2$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    // Legacy state — type and update logic are verbatim from the original implementation
    const [legacyState, setLegacyState] = (0, $42omo.useState)({
        activeTriggerId: undefined
    });
    // New record state — each trigger tracks its own boolean independently
    const [recordState, setRecordState] = (0, $42omo.useState)({});
    const setTriggerState = (0, $42omo.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        if ((0, $dh538.fg)('post-office_enable-trigger-record-state')) // New: each trigger tracks its own state independently.
        // Mutual exclusion is enforced at render time by the choreographer.
        setRecordState((current)=>{
            if (!!current[triggerId] === isActive) return current;
            if (isActive) return {
                ...current,
                [triggerId]: true
            };
            const { [triggerId]: excludedTrigger, ...rest } = current;
            return rest;
        });
        else // Legacy: verbatim original logic — only one trigger active at a time
        setLegacyState((current_0)=>{
            const hasStateChanged = current_0.activeTriggerId !== triggerId || current_0.activeTriggerId === triggerId && isActive === false;
            if (!hasStateChanged) return current_0;
            if (isActive) return {
                activeTriggerId: triggerId
            };
            return {
                activeTriggerId: undefined
            };
        });
    }, []);
    // Unified record view exposed to context consumers.
    // In legacy mode, converts the single activeTriggerId to a one-entry record
    // so useTrigger works identically for both paths.
    const activeTriggerState = (0, $42omo.useMemo)(()=>{
        if ((0, $dh538.fg)('post-office_enable-trigger-record-state')) return recordState;
        const { activeTriggerId: activeTriggerId } = legacyState;
        return activeTriggerId ? {
            [activeTriggerId]: true
        } : {};
    }, [
        recordState,
        legacyState
    ]);
    const triggerContextValue = (0, $42omo.useMemo)(()=>({
            activeTriggerState: activeTriggerState
        }), [
        activeTriggerState
    ]);
    const triggerContexDispatchValue = (0, $42omo.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d6c82fa2f331bd2$var$TriggerContext.Provider, {
        value: triggerContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d6c82fa2f331bd2$var$TriggerDispatchContext.Provider, {
        value: triggerContexDispatchValue
    }, children));
};
const $6d6c82fa2f331bd2$export$454c1d7c35958f5e = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $42omo.useContext)($6d6c82fa2f331bd2$var$TriggerContext);
} : ()=>(0, $42omo.useContext)($6d6c82fa2f331bd2$var$TriggerContext);
const $6d6c82fa2f331bd2$export$23cbf084e08bdb93 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $42omo.useContext)($6d6c82fa2f331bd2$var$TriggerDispatchContext);
} : ()=>(0, $42omo.useContext)($6d6c82fa2f331bd2$var$TriggerDispatchContext);
const $6d6c82fa2f331bd2$export$3b196fe93a948c18 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (triggerId)=>{
    const $ = (0, $frIzR.c)(3);
    const { activeTriggerState: activeTriggerState } = $6d6c82fa2f331bd2$export$454c1d7c35958f5e();
    let t0;
    if ($[0] !== activeTriggerState || $[1] !== triggerId) {
        t0 = triggerId ? {
            isActive: !!activeTriggerState[triggerId]
        } : {
            isActive: undefined
        };
        $[0] = activeTriggerState;
        $[1] = triggerId;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $6d6c82fa2f331bd2$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: !!activeTriggerState[triggerId]
    } : {
        isActive: undefined
    };
};
const $6d6c82fa2f331bd2$export$83b33e5fe4cce64 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { triggerId: triggerId } = t0;
    const { setTriggerState: setContextTriggerState } = $6d6c82fa2f331bd2$export$23cbf084e08bdb93();
    let t1;
    if ($[0] !== setContextTriggerState || $[1] !== triggerId) {
        t1 = (t2)=>{
            const { isActive: isActive } = t2;
            return setContextTriggerState({
                triggerId: triggerId,
                isActive: isActive
            });
        };
        $[0] = setContextTriggerState;
        $[1] = triggerId;
        $[2] = t1;
    } else t1 = $[2];
    const fireTrigger = t1;
    let t2;
    if ($[3] !== fireTrigger) {
        t2 = {
            fireTrigger: fireTrigger
        };
        $[3] = fireTrigger;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $6d6c82fa2f331bd2$export$23cbf084e08bdb93();
    const fireTrigger = (0, $42omo.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};
const $6d6c82fa2f331bd2$export$e45375ff75169f = (0, $4pOgL.isReactCompilerActivePlatform)() ? (messageId)=>{
    const $ = (0, $frIzR.c)(21);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $dh538.fg)("post-office_enable-ep-external-message-cleanup");
        $[0] = t0;
    } else t0 = $[0];
    const enableEpExternalMessageCleanup = t0;
    const { activeTriggerState: activeTriggerState } = $6d6c82fa2f331bd2$export$454c1d7c35958f5e();
    let t1;
    if ($[1] !== activeTriggerState) {
        const activeTriggerId = (0, $dh538.fg)("post-office_enable-trigger-record-state") ? undefined : Object.keys(activeTriggerState).find((k)=>activeTriggerState[k]);
        t1 = enableEpExternalMessageCleanup && activeTriggerId?.endsWith("-started");
        $[1] = activeTriggerState;
        $[2] = t1;
    } else t1 = $[2];
    const hasMessageAlreadyStarted = t1;
    const { isActive: hasMessageStarted } = $6d6c82fa2f331bd2$export$3b196fe93a948c18(`${messageId}-started`);
    const t2 = `${messageId}-start`;
    let t3;
    if ($[3] !== t2) {
        t3 = {
            triggerId: t2
        };
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    const { fireTrigger: requestMessageStartTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64(t3);
    const t4 = `${messageId}-dismiss`;
    let t5;
    if ($[5] !== t4) {
        t5 = {
            triggerId: t4
        };
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    const { fireTrigger: fireDismissClickTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64(t5);
    const t6 = `${messageId}-cta-click`;
    let t7;
    if ($[7] !== t6) {
        t7 = {
            triggerId: t6
        };
        $[7] = t6;
        $[8] = t7;
    } else t7 = $[8];
    const { fireTrigger: fireCtaClickTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64(t7);
    let t8;
    if ($[9] !== hasMessageAlreadyStarted || $[10] !== requestMessageStartTrigger) {
        t8 = ()=>{
            if (hasMessageAlreadyStarted) return;
            requestMessageStartTrigger({
                isActive: true
            });
        };
        $[9] = hasMessageAlreadyStarted;
        $[10] = requestMessageStartTrigger;
        $[11] = t8;
    } else t8 = $[11];
    const requestMessageStart = t8;
    let t9;
    if ($[12] !== fireDismissClickTrigger) {
        t9 = ()=>{
            fireDismissClickTrigger({
                isActive: true
            });
        };
        $[12] = fireDismissClickTrigger;
        $[13] = t9;
    } else t9 = $[13];
    const dismissMessage = t9;
    let t10;
    if ($[14] !== fireCtaClickTrigger) {
        t10 = ()=>{
            fireCtaClickTrigger({
                isActive: true
            });
        };
        $[14] = fireCtaClickTrigger;
        $[15] = t10;
    } else t10 = $[15];
    const handlePostOfficeClickTracking = t10;
    let t11;
    if ($[16] !== dismissMessage || $[17] !== handlePostOfficeClickTracking || $[18] !== hasMessageStarted || $[19] !== requestMessageStart) {
        t11 = {
            hasMessageStarted: hasMessageStarted,
            requestMessageStart: requestMessageStart,
            dismissMessage: dismissMessage,
            handlePostOfficeClickTracking: handlePostOfficeClickTracking
        };
        $[16] = dismissMessage;
        $[17] = handlePostOfficeClickTracking;
        $[18] = hasMessageStarted;
        $[19] = requestMessageStart;
        $[20] = t11;
    } else t11 = $[20];
    return t11;
} : (messageId)=>{
    const enableEpExternalMessageCleanup = (0, $dh538.fg)('post-office_enable-ep-external-message-cleanup');
    const { activeTriggerState: activeTriggerState } = $6d6c82fa2f331bd2$export$454c1d7c35958f5e();
    // In legacy mode (gate off), the record has at most one true entry, so we reconstruct
    // activeTriggerId to preserve the original guard logic verbatim.
    // In record mode (gate on), the guard is unnecessary — setTriggerState is a no-op if
    // the trigger is already active, so we skip the reconstruction.
    const activeTriggerId = (0, $dh538.fg)('post-office_enable-trigger-record-state') ? undefined : Object.keys(activeTriggerState).find((k)=>activeTriggerState[k]);
    const hasMessageAlreadyStarted = enableEpExternalMessageCleanup && activeTriggerId?.endsWith('-started');
    // listeners
    const { isActive: hasMessageStarted } = $6d6c82fa2f331bd2$export$3b196fe93a948c18(`${messageId}-started`);
    // actions
    const { fireTrigger: requestMessageStartTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: fireDismissClickTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-dismiss`
    });
    const { fireTrigger: fireCtaClickTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-cta-click`
    });
    const requestMessageStart = (0, $42omo.useCallback)(()=>{
        if (hasMessageAlreadyStarted) return;
        requestMessageStartTrigger({
            isActive: true
        });
    }, [
        requestMessageStartTrigger,
        hasMessageAlreadyStarted
    ]);
    const dismissMessage = (0, $42omo.useCallback)(()=>{
        fireDismissClickTrigger({
            isActive: true
        });
    }, [
        fireDismissClickTrigger
    ]);
    const handlePostOfficeClickTracking = (0, $42omo.useCallback)(()=>{
        fireCtaClickTrigger({
            isActive: true
        });
    }, [
        fireCtaClickTrigger
    ]);
    return {
        hasMessageStarted: hasMessageStarted,
        requestMessageStart: requestMessageStart,
        dismissMessage: dismissMessage,
        handlePostOfficeClickTracking: handlePostOfficeClickTracking
    };
};
module.exports["TriggerContextProvider"] = $6d6c82fa2f331bd2$export$e80a5720bb4c8fe3;
module.exports["useTrigger"] = $6d6c82fa2f331bd2$export$3b196fe93a948c18;
module.exports["useFirePostOfficeTrigger"] = $6d6c82fa2f331bd2$export$83b33e5fe4cce64;
module.exports["usePostOfficeExernalMessageProxy"] = $6d6c82fa2f331bd2$export$e45375ff75169f;

});

parcelRegister("922yL", function(module, exports) {
$parcel$export(module.exports, "default", () => $6936494635ea8bcb$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $6936494635ea8bcb$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("fVTNs", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $e7URT = parcelRequire("e7URT");


var $1j3sF = parcelRequire("1j3sF");


var $bYRk6 = parcelRequire("bYRk6");

const $c32683c3f1554789$export$dc30f43798194b03 = (props)=>{
    const { children: children, sourceName: sourceName, sourceType: sourceType, ...rest } = props;
    const source = sourceName && sourceType ? `${sourceName}${sourceType}` : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($1j3sF)))({
        source: source,
        ...rest
    }, (0, (/*@__PURE__*/$parcel$interopDefault($e7URT))));
};
const $c32683c3f1554789$export$34282a1f95511a11 = (props)=>{
    const data = $c32683c3f1554789$export$dc30f43798194b03(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
        data: data
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, props.children));
};
module.exports["ContextWrapper"] = $c32683c3f1554789$export$34282a1f95511a11;

});

parcelRegister("lGVHb", function(module, exports) {
function $b4b40a49047a27cf$export$db36004670a5626e(node) {
    return node?.__typename === 'GraphIntegrationSkillDirectoryItem';
}
function $b4b40a49047a27cf$export$7d1ba2a7b9e1a07(node) {
    return node?.__typename === 'ConvoAiSkill';
}
function $b4b40a49047a27cf$export$74ea09dd5afceb60(node) {
    if (!node || node.__typename !== 'GraphIntegrationSkillDirectoryItem') return null;
    const displayName = node.integrationKey?.displayName ?? '';
    const tagDisplayNames = node.tags?.map((t)=>t.displayName) ?? [];
    const trimmedDescription = node.description && node.description?.length > 150 ? `${node.description?.slice(0, 147)}...` : node.description ?? '';
    return {
        id: node.id,
        slug: node.slashCommand?.split('/')?.[1] ?? '',
        name: node.name ?? '',
        description: trimmedDescription,
        iconName: node.iconUrl?.split('name/')?.[1],
        product: displayName ? displayName.charAt(0).toUpperCase() + displayName.slice(1) : '',
        productIconUrl: node.integrationKey?.iconUrl ?? '',
        ...node.color ? {
            color: node.color
        } : {},
        ...tagDisplayNames.length > 0 ? {
            tags: [
                ...tagDisplayNames
            ]
        } : {}
    };
}
function $b4b40a49047a27cf$export$fd76a94f4a001a14(node) {
    if (!node || node.__typename !== 'ConvoAiSkill') return null;
    const primaryIntegration = node.integrations?.[0];
    let productDisplayName = '';
    let productIconUrl = '';
    // If the skill has integrations, else use the legacy integrationKeys.
    if (primaryIntegration) {
        productDisplayName = primaryIntegration.displayName ?? '';
        productIconUrl = primaryIntegration.iconUrl ?? '';
    } else {
        const product = node.integrationKeys?.[0] ?? '';
        productDisplayName = product ? product.charAt(0).toUpperCase() + product.slice(1) : '';
    }
    return {
        id: node.id,
        slug: node.slashCommand?.split('/')?.[1] ?? '',
        name: node.displayName ?? node.name ?? '',
        description: node.helpText ?? node.description ?? '',
        iconName: node.iconKey || node.iconUrl?.split('name/')?.[1],
        product: productDisplayName,
        productIconUrl: productIconUrl,
        ...node.color ? {
            color: node.color
        } : {},
        ...node.tags && node.tags.length > 0 ? {
            tags: [
                ...node.tags
            ]
        } : {}
    };
}
function $b4b40a49047a27cf$export$2cffb029ea623d71(edges) {
    if (!edges) return [];
    return edges.map((edge)=>$b4b40a49047a27cf$export$db36004670a5626e(edge?.node) ? $b4b40a49047a27cf$export$74ea09dd5afceb60(edge.node) : null).filter((skill)=>skill !== null);
}
function $b4b40a49047a27cf$export$554aac7da67453f5(edges) {
    if (!edges) return [];
    return edges.map((edge)=>$b4b40a49047a27cf$export$7d1ba2a7b9e1a07(edge?.node) ? $b4b40a49047a27cf$export$fd76a94f4a001a14(edge.node) : null).filter((skill)=>skill !== null);
}
function $b4b40a49047a27cf$export$faef8b68e529d4a7(edges) {
    if (!edges) return [];
    return edges.map((edge)=>{
        const node = edge?.node;
        if (!node || !node.__typename) return null;
        // Route to appropriate parser based on typename
        if ($b4b40a49047a27cf$export$db36004670a5626e(node)) return $b4b40a49047a27cf$export$74ea09dd5afceb60(node);
        if ($b4b40a49047a27cf$export$7d1ba2a7b9e1a07(node)) return $b4b40a49047a27cf$export$fd76a94f4a001a14(node);
        return null;
    }).filter((skill)=>skill !== null);
}
module.exports["parseSkillNode"] = $b4b40a49047a27cf$export$74ea09dd5afceb60;
module.exports["parseSkillEdges"] = $b4b40a49047a27cf$export$2cffb029ea623d71;
module.exports["parseConvoAiSkillEdges"] = $b4b40a49047a27cf$export$554aac7da67453f5;
module.exports["parseUniversalSkillEdges"] = $b4b40a49047a27cf$export$faef8b68e529d4a7;

});

parcelRegister("luv00", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5nSna = parcelRequire("5nSna");

const $8a88875ffe13fd4c$export$30b62f74ca853d7d = (0, $3u0dr.isReactCompilerActiveV2)() ? function useSSRPlaceholderReplaceIdProp() {
    const $ = (0, $frIzR.c)(2);
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    let t0;
    if ($[0] !== placeholderReplaceId) {
        t0 = {
            "data-ssr-placeholder-replace": placeholderReplaceId
        };
        $[0] = placeholderReplaceId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useSSRPlaceholderReplaceIdProp() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
};
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("9cZ1w", function(module, exports) {

var $epLE5 = parcelRequire("epLE5");


const $486bada329940e5a$export$f6e059b56d9aeb26 = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("Xa9qv"))).showCreateWithRovoModalCloseFeedbackFlagThunk);
module.exports["useLazyShowFeedbackFlag"] = $486bada329940e5a$export$f6e059b56d9aeb26;

});

parcelRegister("epLE5", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $dfceb6b0f6d6cccb$export$729b27bc0f344ffe = (loader)=>{
    return (...deps)=>(0, $42omo.useCallback)((...args)=>{
            return loader().then((thunk)=>thunk(...deps)(...args));
        }, // Linter doesn't like spread syntax
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            ...deps
        ]);
};
module.exports["createLazyCallbackHook"] = $dfceb6b0f6d6cccb$export$729b27bc0f344ffe;

});

parcelRegister("Xa9qv", function(module, exports) {

let $0b1d62968e282e20$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0b1d62968e282e20$var$load("3ezts"),
    $0b1d62968e282e20$var$load("6GYDO"),
    $0b1d62968e282e20$var$load("cyGuT"),
    $0b1d62968e282e20$var$load("hhss7"),
    $0b1d62968e282e20$var$load("k7MRD")
]).then(()=>parcelRequire('hlCkz'));

});

parcelRegister("zCcSI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $ibzAc = parcelRequire("ibzAc");


var $6mKj3 = parcelRequire("6mKj3");


var $32x2E = parcelRequire("32x2E");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $8aF6s = parcelRequire("8aF6s");


var $c96tF = parcelRequire("c96tF");


var $9cZ1w = parcelRequire("9cZ1w");

const $e34c3f63766da5b3$var$CLOSE_MODAL_DELAY = 500;
const $e34c3f63766da5b3$export$a9c99c9d804e8c41 = ({ assistanceServiceConfigHeaders: assistanceServiceConfigHeaders = {}, preventAbortRequestsOnStagingModalClose: preventAbortRequestsOnStagingModalClose = false, preventAbortRequestsOnStandaloneChatClose: preventAbortRequestsOnStandaloneChatClose = false })=>{
    const { cloudId: cloudId, orgId: orgId, userId: userId } = (0, $bQm3c.useSessionData)();
    const emojiProvider = (0, $42omo.useMemo)(()=>{
        return (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
            cloudId: cloudId,
            userId: userId
        });
    }, [
        userId,
        cloudId
    ]);
    const assistanceServiceConfig = {
        headers: assistanceServiceConfigHeaders,
        baseUrl: '/gateway/api/assist'
    };
    // Keep the config object identity stable when its semantic inputs are stable.
    const memoizedAssistanceServiceConfig = (0, $42omo.useMemo)(()=>({
            headers: assistanceServiceConfigHeaders,
            baseUrl: '/gateway/api/assist'
        }), [
        assistanceServiceConfigHeaders
    ]);
    const selectedAssistanceServiceConfig = (0, $6mKj3.expValEquals)('rovo_ttai_segment_render_stabilization', 'isEnabled', true) ? memoizedAssistanceServiceConfig : assistanceServiceConfig;
    const memoizedConfig = (0, $42omo.useMemo)(()=>({
            displaySubmitFlag: true,
            siteId: cloudId,
            product: 'confluence',
            orgId: orgId,
            assistanceServiceConfig: selectedAssistanceServiceConfig,
            emojiProvider: emojiProvider,
            userId: userId ?? undefined,
            preventAbortRequestsOnStagingModalClose: preventAbortRequestsOnStagingModalClose,
            preventAbortRequestsOnStandaloneChatClose: preventAbortRequestsOnStandaloneChatClose
        }), [
        cloudId,
        emojiProvider,
        orgId,
        preventAbortRequestsOnStagingModalClose,
        preventAbortRequestsOnStandaloneChatClose,
        selectedAssistanceServiceConfig,
        userId
    ]);
    return (0, $6mKj3.expValEquals)('rovo_ttai_segment_render_stabilization', 'isEnabled', true) ? memoizedConfig : {
        displaySubmitFlag: true,
        siteId: cloudId,
        product: 'confluence',
        orgId: orgId,
        assistanceServiceConfig: selectedAssistanceServiceConfig,
        emojiProvider: emojiProvider,
        userId: userId ?? undefined,
        preventAbortRequestsOnStagingModalClose: preventAbortRequestsOnStagingModalClose,
        preventAbortRequestsOnStandaloneChatClose: preventAbortRequestsOnStandaloneChatClose
    };
};
const $e34c3f63766da5b3$export$577864d1e6735f1b = ({ flags: flags, customGreeting: customGreeting, shouldShowGreeting: shouldShowGreeting, shouldHideFeedback: shouldHideFeedback })=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const intl = (0, $aXWIB.useIntl)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const navigateToObject = (0, $42omo.useCallback)(async ({ baseUrl: baseUrlNav, path: path })=>{
        (0, $c96tF.createNavigateToObject)(push)({
            baseUrl: baseUrlNav,
            path: path
        });
        // artifical delay before closing the modal gives the app a moment to transition to the created object while the modal is still open, this creates a smoother transition from modal to new object.
        // For non-SPA transitions, a full page reload will happen so this delay will be ignored
        await new Promise((r)=>setTimeout(r, $e34c3f63766da5b3$var$CLOSE_MODAL_DELAY));
    }, [
        push
    ]);
    const showCreateWithRovoModalCloseFeedbackFlag = (0, $9cZ1w.useLazyShowFeedbackFlag)(flags, intl, showModal, createAnalyticsEvent);
    const handleCloseSmartCreate = (0, $42omo.useCallback)(({ feedbackVariant: feedbackVariant, currentConversationId: currentConversationId, remixMetadata: remixMetadata, contentType: contentType, contentMode: contentMode })=>{
        if (shouldHideFeedback) return;
        if (feedbackVariant === undefined) return;
        showCreateWithRovoModalCloseFeedbackFlag({
            feedbackVariant: feedbackVariant,
            contentType: contentType,
            contentMode: contentMode,
            cloudId: cloudId,
            currentConversationId: currentConversationId ?? undefined,
            remixMetadata: remixMetadata
        });
    }, [
        showCreateWithRovoModalCloseFeedbackFlag,
        shouldHideFeedback,
        cloudId
    ]);
    // Keep uiConfig identity stable when handler/greeting inputs are stable.
    const memoizedUiConfig = (0, $42omo.useMemo)(()=>({
            customHandlers: {
                handleSubmitSmartCreate: navigateToObject,
                handleCloseSmartCreate: handleCloseSmartCreate
            },
            elements: {
                shouldShowGreeting: shouldShowGreeting ?? undefined
            },
            customGreeting: customGreeting ?? undefined
        }), [
        customGreeting,
        handleCloseSmartCreate,
        navigateToObject,
        shouldShowGreeting
    ]);
    return (0, $6mKj3.expValEquals)('rovo_ttai_segment_render_stabilization', 'isEnabled', true) ? memoizedUiConfig : {
        customHandlers: {
            handleSubmitSmartCreate: navigateToObject,
            handleCloseSmartCreate: handleCloseSmartCreate
        },
        elements: {
            shouldShowGreeting: shouldShowGreeting ?? undefined
        },
        customGreeting: customGreeting ?? undefined
    };
};
module.exports["useConversationAssistantConfig"] = $e34c3f63766da5b3$export$a9c99c9d804e8c41;
module.exports["useConversationAssistantUiConfig"] = $e34c3f63766da5b3$export$577864d1e6735f1b;

});

parcelRegister("c96tF", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");

const $8f856ee350559225$export$b2e60ce4b3907e57 = (baseUrl)=>{
    const host = window.location.host;
    return baseUrl.includes(host) && baseUrl.includes((0, $jlIaF.CONTEXT_PATH));
};
// database need flow query param for special case handling
const $8f856ee350559225$var$addFlowParam = (baseUrl, path)=>{
    const url = new URL(path, baseUrl);
    url.searchParams.set('flow', 'aiCreate');
    return url.pathname + url.search;
};
const $8f856ee350559225$export$38454a8d1321e65a = (push)=>({ baseUrl: baseUrl, path: path })=>{
        const isDatabase = Boolean((0, $1NBp8.DATABASE_VIEW).match(`${baseUrl}${path}`));
        let finalPath = path;
        if (isDatabase) finalPath = $8f856ee350559225$var$addFlowParam(baseUrl, path);
        if ($8f856ee350559225$export$b2e60ce4b3907e57(baseUrl)) push((0, $jlIaF.CONTEXT_PATH) + finalPath);
        else window.location.href = `${baseUrl}${finalPath}`;
    };
module.exports["createNavigateToObject"] = $8f856ee350559225$export$38454a8d1321e65a;

});

parcelRegister("e0SBo", function(module, exports) {
$parcel$export(module.exports, "default", () => $a33b6ba3d9a58f3b$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $a33b6ba3d9a58f3b$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var dateToCompare = (0, $egXhZ.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("aMqwg", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $9d4cc27d6faf7a6e$var$rovoEntitlementStore = (0, $1P1Tu.createStore)({
    initialState: {
        isRovoEnabled: false
    },
    name: 'RovoEntitlementStore',
    actions: {
        setIsRovoEnabled: (isRovoEnabled, reason)=>({ setState: setState })=>{
                setState({
                    isRovoEnabled: isRovoEnabled,
                    reason: reason
                });
            }
    }
});
const $9d4cc27d6faf7a6e$var$useStateHook = (0, $9zUhf.createStateHook)($9d4cc27d6faf7a6e$var$rovoEntitlementStore);
const $9d4cc27d6faf7a6e$export$66d5dd4be64dea43 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(2);
    const result = $9d4cc27d6faf7a6e$var$useStateHook();
    let t0;
    if ($[0] !== result) {
        t0 = {
            ...result,
            isRovoEnabled: result.isRovoEnabled
        };
        $[0] = result;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const result = $9d4cc27d6faf7a6e$var$useStateHook();
    return {
        ...result,
        isRovoEnabled: result.isRovoEnabled
    };
};
const $9d4cc27d6faf7a6e$export$8004893135276275 = (0, $9zUhf.createActionsHook)($9d4cc27d6faf7a6e$var$rovoEntitlementStore);
const $9d4cc27d6faf7a6e$export$d03a05ad8547472c = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const { isRovoEnabled: isRovoEnabled } = t0;
    const { setIsRovoEnabled: setIsRovoEnabled } = $9d4cc27d6faf7a6e$export$8004893135276275();
    setIsRovoEnabled(isRovoEnabled);
    return null;
} : ({ isRovoEnabled: isRovoEnabled })=>{
    const { setIsRovoEnabled: setIsRovoEnabled } = $9d4cc27d6faf7a6e$export$8004893135276275();
    (0, $42omo.useMemo)(()=>{
        setIsRovoEnabled(isRovoEnabled);
    }, [
        isRovoEnabled,
        setIsRovoEnabled
    ]);
    return null;
};
module.exports["useRovoEntitlement"] = $9d4cc27d6faf7a6e$export$66d5dd4be64dea43;
module.exports["useRovoEntitlementActions"] = $9d4cc27d6faf7a6e$export$8004893135276275;
module.exports["RovoEntitlementSetter"] = $9d4cc27d6faf7a6e$export$d03a05ad8547472c;

});

parcelRegister("isFEX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0cdccba3d7742a12d1dd259bf333308d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d70b2843323b118c$var$_react = $d70b2843323b118c$var$_interopRequireDefault((parcelRequire("42omo")));

var $d70b2843323b118c$var$_baseNew = $d70b2843323b118c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $d70b2843323b118c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Template".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved fore templates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d70b2843323b118c$var$TemplateIcon = (props)=>/*#__PURE__*/ $d70b2843323b118c$var$_react.default.createElement($d70b2843323b118c$var$_baseNew.default, Object.assign({
        name: "TemplateIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 6h-7v7.5H13a.5.5 0 0 0 .5-.5zm-11 7a.5.5 0 0 0 .5.5h2V6H2.5zm11-10a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v1.5h11zM15 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>`
    }, props));
$d70b2843323b118c$var$TemplateIcon.displayName = 'TemplateIcon';
var $d70b2843323b118c$var$_default = module.exports.default = $d70b2843323b118c$var$TemplateIcon;

});

parcelRegister("f7MuR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $26d702ce000cc6e9$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $26d702ce000cc6e9$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        }
};
const $26d702ce000cc6e9$export$39f521003d60a645 = (0, $1P1Tu.createStore)({
    initialState: $26d702ce000cc6e9$var$initialState,
    actions: $26d702ce000cc6e9$var$actions,
    name: 'siteUserTraitsStore'
});
const $26d702ce000cc6e9$export$55703aaacc066827 = (0, $9zUhf.createHook)($26d702ce000cc6e9$export$39f521003d60a645);
const $26d702ce000cc6e9$export$60cc1c45e628d86f = (0, $9zUhf.createActionsHook)($26d702ce000cc6e9$export$39f521003d60a645);
async function $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $26d702ce000cc6e9$var$hasFetched = false;
function $26d702ce000cc6e9$export$f1fbc6ad89f91b89() {
    $26d702ce000cc6e9$var$hasFetched = false;
}
function $26d702ce000cc6e9$var$getSiteUserTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.siteUser);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.siteUser);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $26d702ce000cc6e9$export$f02520a2cf0afa96({ skip: skip, skipBootstrap: skipBootstrap, fetchPolicy: fetchPolicy = 'cache-first' } = {}) {
    // skip=true -> full idle, no preload/store/fetch
    const preloadedData = (0, $42omo.useMemo)(()=>skip ? null : $26d702ce000cc6e9$var$getSiteUserTraitsFromSources(), [
        skip
    ]);
    const [storeState, storeActions] = $26d702ce000cc6e9$export$55703aaacc066827();
    const { accessStatus: accessStatus, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    // Track whether cache-and-network fetch dispatched this mount
    const fetchDispatchedRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (skip) return;
        if (!cloudId || !userId) return;
        if (skipBootstrap) return;
        if (!hasLicensedAccess) return;
        if (fetchPolicy === 'cache-first') {
            // Old behavior: don't fetch if we have data from any source
            if (preloadedData || storeState.data || storeState.loading || storeState.error) return;
            if ($26d702ce000cc6e9$var$hasFetched) return;
            $26d702ce000cc6e9$var$hasFetched = true;
            storeActions.start();
            $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then((data)=>storeActions.success(data), (err)=>storeActions.error(err));
        } else {
            // cache-and-network: fetch once per mount
            if (storeState.loading) {
                fetchDispatchedRef.current = true;
                return;
            }
            if (fetchDispatchedRef.current) return;
            fetchDispatchedRef.current = true;
            storeActions.start();
            $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then((data)=>storeActions.success(data), (err)=>storeActions.error(err));
        }
    }, [
        skip,
        skipBootstrap,
        fetchPolicy,
        cloudId,
        userId,
        hasLicensedAccess,
        preloadedData,
        storeState,
        storeActions
    ]);
    if (skip) return {
        data: null,
        loading: false,
        error: null
    };
    // Fetched store result wins over preloaded data
    if (storeState.data) return {
        data: storeState.data,
        loading: storeState.loading,
        error: storeState.error
    };
    if (preloadedData) return {
        data: preloadedData,
        loading: storeState.loading,
        error: null
    };
    return {
        data: null,
        loading: storeState.loading,
        error: storeState.error
    };
}
module.exports["useSiteUserTraits"] = $26d702ce000cc6e9$export$f02520a2cf0afa96;

});

parcelRegister("lHQAj", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4WmbV = parcelRequire("4WmbV");

const $5558feba06e8dbf9$export$60332b2344f7fe41 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== children) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children) < 2 ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, children);
        $[3] = children;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardSectionMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
            ...props,
            withTasteAndToneStyling: true,
            buttonGroupAlignment: "right"
        }));
        $[5] = props;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== t1 || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardLayout, null, t1, t2);
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardLayout, null, (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children) < 2 ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardSectionMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        ...props,
        withTasteAndToneStyling: true,
        buttonGroupAlignment: "right"
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5558feba06e8dbf9$var$CardLayout = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _4cvr1h6o _bfhk1bhr _kqswh2mm",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _4cvr1h6o _bfhk1bhr _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$var$CardSectionMessageContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt41ejb _1wpz1fhb",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41ejb _1wpz1fhb",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$var$CardContentsContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18rx4jg8",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18rx4jg8",
            __cmplp.className
        ])
    });
});
$5558feba06e8dbf9$var$CardContentsContainer.displayName = 'CardContentsContainer';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5558feba06e8dbf9$var$CardWithBorderAndBox = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rko12b0 _19itoecm _11q71bhr _1reo15vq _18m915vq _16qs130s",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko12b0 _19itoecm _11q71bhr _1reo15vq _18m915vq _16qs130s",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$export$8a23e74e5cf3ca41 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardWithBorderAndBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardContentsContainer, null, children));
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardWithBorderAndBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardContentsContainer, null, children));
module.exports["Card"] = $5558feba06e8dbf9$export$60332b2344f7fe41;
module.exports["CardContainer"] = $5558feba06e8dbf9$export$8a23e74e5cf3ca41;

});

parcelRegister("7tXrp", function(module, exports) {

var $d9tcB = parcelRequire("d9tcB");

const $f4962613d517e76c$var$FREE_TOUCHPOINTS = {
    pageInsights: {
        requestedEdition: 'standard',
        requestedFeature: 'pageInsights'
    },
    archiveUpsellDialog: {
        requestedEdition: 'standard',
        requestedFeature: 'archive'
    },
    generalAccessLevelSelector: {
        requestedEdition: 'standard',
        requestedFeature: 'pagePermissions'
    },
    shareAndRestrictDialogUpsell: {
        requestedEdition: 'standard',
        requestedFeature: 'pagePermissions'
    },
    quickSummaryUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'rovo'
    },
    teamCalendarUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'calendars'
    },
    'whiteboardCreationPaywall-upfrontDialog': {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboards'
    }
};
const $f4962613d517e76c$var$STANDARD_TOUCHPOINTS = {
    viewSpacePerms: {
        requestedEdition: 'premium',
        requestedFeature: 'copySpacePermissions'
    },
    contentManagerUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'contentManager'
    },
    adminCenter: {
        requestedEdition: 'premium',
        requestedFeature: 'adminCenter'
    },
    userAccessUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'inspectPermissions'
    },
    shareAndRestrictDialogInspectPermissionsUpsell: {
        requestedEdition: 'premium',
        requestedFeature: 'inspectPermissions'
    },
    restrictionsDialogInspectPermissionsUpsell: {
        requestedEdition: 'premium',
        requestedFeature: 'inspectPermissions'
    },
    companyHubUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'companyHub'
    },
    premiumCardsInsertUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumCarouselInsertUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumSpotlightInsertUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumCardsConfigUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumCarouselConfigUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumSpotlightConfigUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    whiteboardsUpsellCtaScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboardInsert'
    },
    'whiteboardCreationPaywall-upfrontDialog': {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboards'
    },
    'whiteboardCreationPaywall-unsetDialog': {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboards'
    },
    'whiteboardCreationPaywall-viewOnlyButton': {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboards'
    },
    createSpaceDrawer: {
        requestedEdition: 'premium',
        requestedFeature: 'copySpacePermissions'
    }
};
const $f4962613d517e76c$export$354adb22437506d7 = (source, edition)=>{
    switch(edition){
        case (0, $d9tcB.ConfluenceEdition).FREE:
            return $f4962613d517e76c$var$FREE_TOUCHPOINTS[source];
        case (0, $d9tcB.ConfluenceEdition).STANDARD:
            return $f4962613d517e76c$var$STANDARD_TOUCHPOINTS[source];
        default:
            return undefined;
    }
};
module.exports["getEligibleTouchpointForEdition"] = $f4962613d517e76c$export$354adb22437506d7;

});

parcelRegister("jIOyV", function(module, exports) {
// "confluence.fe.interaction.XXX"
const $4fa41f80373a2ebe$export$f49429c67898bd15 = 'more-actions-dropdown';
const $4fa41f80373a2ebe$export$daaf73616fe91ce9 = 'move-page-dialog';
const $4fa41f80373a2ebe$export$d4222bce9029f393 = 'content-analytics-dialog';
const $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c = 'content-analytics-dialog-mentions-tab';
const $4fa41f80373a2ebe$export$eb06363d6ef3b8dd = 'restrictions-dialog';
const $4fa41f80373a2ebe$export$ef2fb65c026ab7d3 = 'quick-summary-dialog';
const $4fa41f80373a2ebe$export$8122cf0ca2968a7b = 'open-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$ea9696a28a6fbc61 = 'initialize-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$e561726b92a6162d = 'comments_summary_component';
const $4fa41f80373a2ebe$export$e348981755bdab67 = 'create-space-drawer';
const $4fa41f80373a2ebe$export$af1eb8557193d022 = 'ai-presentation-modal';
const $4fa41f80373a2ebe$export$7f72b8ffbbbfef58 = 'ai-content-catchup';
const $4fa41f80373a2ebe$export$576b15c3bba51667 = 'ai-audio-briefing';
module.exports["MORE_ACTIONS_DROPDOWN_INTERACTION"] = $4fa41f80373a2ebe$export$f49429c67898bd15;
module.exports["MOVE_PAGE_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$daaf73616fe91ce9;
module.exports["CONTENT_ANALYTICS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$d4222bce9029f393;
module.exports["CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION"] = $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c;
module.exports["RESTRICTIONS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$eb06363d6ef3b8dd;
module.exports["QUICK_SUMMARY_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$ef2fb65c026ab7d3;
module.exports["OPEN_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$8122cf0ca2968a7b;
module.exports["INITIALIZE_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$ea9696a28a6fbc61;
module.exports["COMMENTS_SUMMARY_COMPONENT_INTERACTION"] = $4fa41f80373a2ebe$export$e561726b92a6162d;
module.exports["CREATE_SPACE_DRAWER_INTERACTION"] = $4fa41f80373a2ebe$export$e348981755bdab67;
module.exports["AI_CONTENT_CATCHUP_INTERACTION"] = $4fa41f80373a2ebe$export$7f72b8ffbbbfef58;
module.exports["AI_AUDIO_BRIEFING_INTERACTION"] = $4fa41f80373a2ebe$export$576b15c3bba51667;

});

parcelRegister("2YmgJ", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $a63d9f06b3e123f3$var$store = (0, $1P1Tu.createStore)({
    initialState: {
        actionFilter: undefined,
        actions: [],
        jiraIssueViewActions: undefined,
        input: '',
        activeAction: undefined,
        buttonClickedTimestamp: undefined
    },
    actions: {
        setConversationActions: (actions)=>({ setState: setState })=>{
                setState({
                    actions: actions
                });
            },
        /*
     * Jira Issue View does not use the provider pattern yet, so we need to skip the provider action fetching.
     * When Jira Issue View is migrated to set actions using provider pattern, we can remove this setter.
     */ setJiraIssueViewActions: (actions)=>({ setState: setState })=>{
                setState({
                    jiraIssueViewActions: actions
                });
            },
        setInput: (input)=>({ setState: setState })=>{
                setState({
                    input: input
                });
            },
        setActionFilter: (actionFilter)=>({ setState: setState })=>{
                setState({
                    actionFilter: actionFilter
                });
            },
        /*
     * Do not use this setter directly. Use setActiveAction from useActiveAction hook in conversation-assistant instead.
     */ setActiveAction_UNSAFE: (activeAction)=>({ setState: setState })=>{
                setState({
                    activeAction: activeAction
                });
            },
        setActiveActionFollowUpContext: (customFollowUpContext)=>({ getState: getState, setState: setState })=>{
                const activeAction = getState().activeAction;
                if (!activeAction || !('customFollowUpContext' in activeAction)) return;
                setState({
                    activeAction: {
                        ...activeAction,
                        customFollowUpContext: customFollowUpContext
                    }
                });
            },
        setButtonClickedTimestamp: (buttonClickedTimestamp)=>({ setState: setState })=>{
                setState({
                    buttonClickedTimestamp: buttonClickedTimestamp
                });
            },
        getConversationActions: ()=>({ getState: getState })=>{
                return getState().actions;
            },
        getActionFilter: ()=>({ getState: getState })=>{
                return getState().actionFilter;
            },
        getInput: ()=>({ getState: getState })=>{
                return getState().input;
            },
        getActiveAction: ()=>({ getState: getState })=>{
                return getState().activeAction;
            },
        getButtonClickedTimestamp: ()=>({ getState: getState })=>{
                return getState().buttonClickedTimestamp;
            },
        setConvoStarterActionPrompt: (convoStarterActionPrompt)=>({ setState: setState })=>{
                setState({
                    convoStarterActionPrompt: convoStarterActionPrompt
                });
            }
    }
});
const $a63d9f06b3e123f3$export$83a8985e8d377ba1 = (0, $9zUhf.createHook)($a63d9f06b3e123f3$var$store);
const $a63d9f06b3e123f3$export$74d7aed167e24a67 = (0, $9zUhf.createActionsHook)($a63d9f06b3e123f3$var$store);
const $a63d9f06b3e123f3$export$d6ed3fb83640b335 = (0, $9zUhf.createStateHook)($a63d9f06b3e123f3$var$store);
const $a63d9f06b3e123f3$export$4be353558b8b8a37 = (0, $9zUhf.createStateHook)($a63d9f06b3e123f3$var$store, {
    selector: (state)=>state.convoStarterActionPrompt
});
module.exports["useConversationActionsStore"] = $a63d9f06b3e123f3$export$83a8985e8d377ba1;
module.exports["useConversationActionsStoreActions"] = $a63d9f06b3e123f3$export$74d7aed167e24a67;
module.exports["useConversationActionsStoreState"] = $a63d9f06b3e123f3$export$d6ed3fb83640b335;

});

parcelRegister("7pE6f", function(module, exports) {
/**
 * This file was cloned from https://bitbucket.org/atlassian/pf-adf-service/src/master/src/lib/converters/adf-to-markdownPlus.ts and slightly modified to work in the browser.
 */ 
var $gktFz = parcelRequire("gktFz");


var $hVXQj = parcelRequire("hVXQj");


var $iyDxB = parcelRequire("iyDxB");


var $h9yJL = parcelRequire("h9yJL");


var $6eZqW = parcelRequire("6eZqW");

const $5a51f9da98a84e11$var$defaultSerializer = new (0, $h9yJL.JSONTransformer)();
function $5a51f9da98a84e11$export$bd172d9b9473ac80(adf, featureToggles, idMap) {
    // Default to markdownPlus being enabled unless explicitly disabled
    if (featureToggles === undefined) featureToggles = {};
    if (featureToggles?.markdownPlus === undefined) featureToggles.markdownPlus = true;
    if (featureToggles?.markdownPlusAvoidDuplicatedIdCounter === undefined) featureToggles.markdownPlusAvoidDuplicatedIdCounter = true;
    let serializer = $5a51f9da98a84e11$var$defaultSerializer;
    if (featureToggles.markdownPlusUseNextLayoutSection) serializer = new (0, $h9yJL.JSONTransformer)((0, $gktFz.createSchema)({
        ...(0, $iyDxB.defaultSchemaConfig),
        customNodeSpecs: {
            layoutSection: (0, $hVXQj.layoutSectionWithSingleColumn)
        }
    }));
    // Convert ADF to ProseMirrorNode
    const proseMirrorNode = serializer.parse(adf);
    // Generate the mentionMap required for correctly returning @mention strings in Markdown+
    const mentionMap = $5a51f9da98a84e11$var$getMentionMap(serializer.encode(proseMirrorNode));
    // Convert ProseMirrorNode to markdown-plus
    const { markdown: markdown, idMap: newIdMap } = (0, $6eZqW.convertProsemirrorNodeToMarkdown)({
        node: proseMirrorNode,
        featureToggles: featureToggles,
        mentionMap: mentionMap,
        idMap: idMap
    });
    return {
        markdown: markdown,
        idMap: newIdMap
    };
}
function $5a51f9da98a84e11$var$getMentionMap(jsonNode) {
    const mentionMap = {};
    function findMentions(node) {
        if (node.type === 'mention') {
            const userValues = $5a51f9da98a84e11$var$getUserMentionValues(node);
            if (userValues) // Stripping '@' from the mention as Markdown+ automatically adds it back for each map value
            mentionMap[userValues.id] = userValues.text.replace('@', '');
        }
        node.content?.forEach((childNode)=>{
            if (childNode) findMentions(childNode);
        });
    }
    findMentions(jsonNode);
    return mentionMap;
}
function $5a51f9da98a84e11$var$getUserMentionValues(node) {
    if (node.attrs && $5a51f9da98a84e11$var$hasTextAndIdFields(node.attrs)) return {
        text: node.attrs.text,
        id: node.attrs.id
    };
    return null;
}
function $5a51f9da98a84e11$var$hasTextAndIdFields(attrs) {
    return 'text' in attrs && 'id' in attrs && typeof attrs.text === 'string' && typeof attrs.id === 'string';
}
module.exports["adfToMarkdownPlus"] = $5a51f9da98a84e11$export$bd172d9b9473ac80;

});

parcelRegister("4sbrV", function(module, exports) {
/**
 * This file was cloned from https://bitbucket.org/atlassian/pf-adf-service/src/master/src/lib/converters/markdownPlus-to-adf.ts and slightly modified to work in the browser.
 */ 
var $iyDxB = parcelRequire("iyDxB");


var $h9yJL = parcelRequire("h9yJL");


var $hAuc5 = parcelRequire("hAuc5");

const $c4325a25ee151966$var$serializer = new (0, $h9yJL.JSONTransformer)();
function $c4325a25ee151966$export$dfca419434f7e5a8({ markdown: markdown, idMap: idMap = {}, editorSchema: editorSchema, featureToggles: featureToggles = {
    markdownPlus: true
} }) {
    // Default to markdownPlus being enabled unless explicitly disabled
    if (featureToggles === undefined) featureToggles = {};
    if (featureToggles?.markdownPlus === undefined) featureToggles.markdownPlus = true;
    // Convert markdown-plus to ProseMirrorNode
    const proseMirrorNode = (0, $hAuc5.backendConvertMarkdownToProsemirrorNode)({
        markdown: markdown,
        schema: editorSchema || (0, $iyDxB.defaultSchema),
        idMap: idMap,
        featureToggles: featureToggles
    });
    // Convert ProseMirrorNode to ADF
    return $c4325a25ee151966$var$serializer.encode(proseMirrorNode);
}
module.exports["markdownPlusToAdf"] = $c4325a25ee151966$export$dfca419434f7e5a8;

});

parcelRegister("6TWiP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f828166ff0e4b26e4ba3197fe41c41b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $50651ad665c1db79$var$_react = $50651ad665c1db79$var$_interopRequireDefault((parcelRequire("42omo")));

var $50651ad665c1db79$var$_baseNew = $50651ad665c1db79$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $50651ad665c1db79$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Atom".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $50651ad665c1db79$var$AtomIcon = (props)=>/*#__PURE__*/ $50651ad665c1db79$var$_react.default.createElement($50651ad665c1db79$var$_baseNew.default, Object.assign({
        name: "AtomIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M9.87 1.42c1.566-.567 3.258-.667 4.318.393 1.059 1.059.959 2.75.392 4.317A11 11 0 0 1 13.683 8c.376.635.678 1.265.897 1.87.567 1.566.667 3.258-.393 4.318-1.059 1.059-2.75.959-4.317.392A11 11 0 0 1 8 13.683a11 11 0 0 1-1.87.897c-1.566.567-3.258.667-4.317-.393-1.06-1.059-.96-2.75-.393-4.317.219-.605.52-1.235.896-1.87a11 11 0 0 1-.896-1.87c-.567-1.566-.667-3.258.393-4.317C2.872.753 4.563.853 6.13 1.42c.605.219 1.235.52 1.87.896a11 11 0 0 1 1.87-.896M3.26 9.397a9 9 0 0 0-.43.983c-.521 1.44-.362 2.342.043 2.747s1.306.564 2.747.043a9 9 0 0 0 .983-.43 17 17 0 0 1-1.785-1.558A17 17 0 0 1 3.26 9.397m9.48 0a17.4 17.4 0 0 1-3.343 3.342q.507.258.983.431c1.44.521 2.342.362 2.747-.043s.564-1.306.043-2.747a9 9 0 0 0-.43-.983M8 4.099a15.5 15.5 0 0 0-2.121 1.78A15.5 15.5 0 0 0 4.099 8a15.4 15.4 0 0 0 1.78 2.121A15.5 15.5 0 0 0 8 11.901a15.5 15.5 0 0 0 2.121-1.78A15.5 15.5 0 0 0 11.901 8a15.5 15.5 0 0 0-1.78-2.121A15.5 15.5 0 0 0 8 4.099M5.62 2.83c-1.44-.521-2.342-.362-2.747.043S2.31 4.18 2.83 5.62q.173.475.43.983c.46-.607.981-1.207 1.558-1.785A17 17 0 0 1 6.603 3.26a9 9 0 0 0-.983-.43m7.507.043c-.405-.405-1.306-.564-2.747-.043a9 9 0 0 0-.983.43c.607.46 1.207.981 1.785 1.558a17 17 0 0 1 1.557 1.785 9 9 0 0 0 .431-.983c.521-1.44.362-2.342-.043-2.747"/><path fill="currentcolor" d="M9 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$50651ad665c1db79$var$AtomIcon.displayName = 'AtomIcon';
var $50651ad665c1db79$var$_default = module.exports.default = $50651ad665c1db79$var$AtomIcon;

});

parcelRegister("fNJG8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c02a973e1b80a41efb48b80326ffc315>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b80edd69ce46ac6c$var$_react = $b80edd69ce46ac6c$var$_interopRequireDefault((parcelRequire("42omo")));

var $b80edd69ce46ac6c$var$_baseNew = $b80edd69ce46ac6c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $b80edd69ce46ac6c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CloudArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b80edd69ce46ac6c$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $b80edd69ce46ac6c$var$_react.default.createElement($b80edd69ce46ac6c$var$_baseNew.default, Object.assign({
        name: "CloudArrowUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3a4.25 4.25 0 0 0-4.236 3.9.75.75 0 0 1-.565.668A2.251 2.251 0 0 0 3.75 12v1.5a3.75 3.75 0 0 1-1.418-7.222 5.751 5.751 0 0 1 11.239-.458A4 4 0 0 1 12 13.5V12a2.5 2.5 0 0 0 .712-4.897.75.75 0 0 1-.526-.59A4.25 4.25 0 0 0 8 3m0 4a.75.75 0 0 1 .53.22l3 3-1.06 1.06-1.72-1.72V16h-1.5V9.56l-1.72 1.72-1.06-1.06 3-3A.75.75 0 0 1 8 7" clip-rule="evenodd"/>`
    }, props));
$b80edd69ce46ac6c$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
var $b80edd69ce46ac6c$var$_default = module.exports.default = $b80edd69ce46ac6c$var$CloudArrowUpIcon;

});

parcelRegister("jO3S6", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $i4C2H = parcelRequire("i4C2H");


const $5eff64246cff89b2$var$LazyRovoLoadingGif = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("23ga2"))); /**
             * @deprecated please use LazyAnimatedRovoIcon from @atlassian/rovo-platform-ui-components/primitives/rovo-animated-icon/LazyAnimatedRovoIcon instead
             */ 
const $5eff64246cff89b2$export$7ea4e54699cd5224 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { alt: t1, testId: t2, width: t3, height: t4 } = t0;
    const alt = t1 === undefined ? "" : t1;
    const testId = t2 === undefined ? "" : t2;
    const width = t3 === undefined ? "" : t3;
    const height = t4 === undefined ? "" : t4;
    let t5;
    if ($[0] !== alt || $[1] !== height || $[2] !== testId || $[3] !== width) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i4C2H.default), {
            interactionName: "rovo-conversation-assistant-animated-icon",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5eff64246cff89b2$var$LazyRovoLoadingGif, {
            alt: alt,
            testId: testId,
            width: width,
            height: height
        }));
        $[0] = alt;
        $[1] = height;
        $[2] = testId;
        $[3] = width;
        $[4] = t5;
    } else t5 = $[4];
    return t5;
} : ({ alt: alt = '', testId: testId = '', width: width = '', height: height = '' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i4C2H.default), {
        interactionName: "rovo-conversation-assistant-animated-icon",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5eff64246cff89b2$var$LazyRovoLoadingGif, {
        alt: alt,
        testId: testId,
        width: width,
        height: height
    }));
});
module.exports["LazyAnimatedRovoIcon"] = $5eff64246cff89b2$export$7ea4e54699cd5224;

});

parcelRegister("23ga2", function(module, exports) {

let $17e865d2382724b6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $17e865d2382724b6$var$load("frhR0").then(()=>parcelRequire('5O8EX'));

});

parcelRegister("cAdj8", function(module, exports) {

var $69Jl3 = parcelRequire("69Jl3");


var $42omo = parcelRequire("42omo");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $1uFM6 = parcelRequire("1uFM6");


var $flE5X = parcelRequire("flE5X");


var $jMyy4 = parcelRequire("jMyy4");

const $a1394411ec7881e4$var$usePageInfoPageInfoQuery = (0, $69Jl3.default);
const $a1394411ec7881e4$export$e1b9843c9a40eb2 = {
    id: '',
    type: '',
    status: '',
    space: {
        id: '',
        operations: []
    },
    operations: [],
    version: {
        number: -1
    }
};
const $a1394411ec7881e4$export$7b2dac1793a2824 = ({ fetchPolicy: fetchPolicy = 'cache-and-network', onCompleted: onCompleted, onError: onError } = {})=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)($a1394411ec7881e4$var$usePageInfoPageInfoQuery, {
        variables: {
            pageId: contentId
        },
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted,
        __callerPackage__: "@confluence/page-info"
    });
    return (0, $42omo.useMemo)(()=>{
        // Handle error case first
        if (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error) || error instanceof (0, $flE5X.NoNetworkError)) (0, $7Sm4c.markErrorAsHandled)(error);
            onError?.(error);
            return {
                pageInfo: null,
                loading: false,
                error: error,
                refetch: null
            };
        }
        // If we have data, use it even during loading
        if (data) {
            const pageInfoNode = data.content?.nodes?.[0] ?? null;
            if (pageInfoNode) return {
                pageInfo: pageInfoNode,
                loading: loading,
                error: undefined,
                refetch: refetch
            };
            return {
                pageInfo: {
                    ...$a1394411ec7881e4$export$e1b9843c9a40eb2
                },
                loading: loading,
                error: undefined,
                refetch: refetch
            };
        }
        // Only return null pageInfo if we have no data at all
        return {
            pageInfo: null,
            loading: loading,
            error: undefined,
            refetch: null
        };
    }, [
        data,
        loading,
        error,
        onError,
        refetch
    ]);
};
module.exports["usePageInfo"] = $a1394411ec7881e4$export$7b2dac1793a2824;

});

parcelRegister("69Jl3", function(module, exports) {
/**
 * @generated SignedSource<<a52aa17c9371e87ad68639adf48d413b>>
 * @relayHash ece963db192ceabc724d67f753bee503
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2811ac8ea0cd2136d716a0779dac023c092684c56d72b0b668fe85db77dee6d4
const $c7d0a8215908754e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "pageId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "current",
                        "archived",
                        "draft"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        },
                        v2 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "number"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePageInfoPageInfoQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePageInfoPageInfoQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "ece963db192ceabc724d67f753bee503",
            "id": "2811ac8ea0cd2136d716a0779dac023c092684c56d72b0b668fe85db77dee6d4",
            "metadata": {},
            "name": "usePageInfoPageInfoQuery",
            "operationKind": "query",
            "text": "query usePageInfoPageInfoQuery($pageId:ID){content(id:$pageId,status:[\"current\",\"archived\",\"draft\"]){nodes{id,type,status,space{id,operations{operation,targetType}},operations{operation,targetType},version{number}}}}"
        }
    };
}();
$c7d0a8215908754e$var$node.hash = "a5580c0bc26236652ac23ad7c3f4bf51";
var $c7d0a8215908754e$export$2e2bcd8739ae039 = $c7d0a8215908754e$var$node;
module.exports["default"] = $c7d0a8215908754e$export$2e2bcd8739ae039;

});

parcelRegister("dOOm2", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $fqANv = parcelRequire("fqANv");

var $5k6WH = parcelRequire("5k6WH");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f64c374ed616824e$var$GradientPropertyContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq _kqswh2mm _c71l1kw7",
            __cmplp.className
        ])
    });
});
const $f64c374ed616824e$var$outerContainerStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    position: 'relative',
    background: `conic-gradient(
    from var(--gradient-angle, 45deg),
    #0065FF 10%,
    #0469FF 30%,
    #BF63F3 50%,
    #FFA900 70%,
    #0065FF 90%
  )`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    ...(0, $fqANv.reduceMotionAsPerUserPreference),
    maxHeight: 'inherit'
});
const $f64c374ed616824e$var$animationStyles = (0, $ecnYn.xcss)({
    animation: 'rotationAnimation linear 2s infinite'
});
const $f64c374ed616824e$var$baseGlowStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    filter: 'blur(25px)',
    opacity: '0.5',
    height: '100%',
    width: '100%'
});
const $f64c374ed616824e$var$defaultBorderRadiusStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.large'
});
const $f64c374ed616824e$var$modalBorderRadiusStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.small'
});
const $f64c374ed616824e$var$innerContainerStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    maxHeight: 'inherit',
    display: 'flex',
    flexDirection: 'column',
    backgroundClip: 'content-box'
});
const $f64c374ed616824e$export$6ed1e39f4dbe0bbf = ({ loading: loading = false, children: children, useModalStyles: useModalStyles, hideGlow: hideGlow, customInnerContainerStyles: customInnerContainerStyles, customGlowStyles: customGlowStyles, ...props })=>{
    const isReducedMotion = (0, $5k6WH.useIsReducedMotion)();
    const shouldRotate = loading && !isReducedMotion;
    const containerStyles = shouldRotate ? [
        $f64c374ed616824e$var$outerContainerStyles,
        $f64c374ed616824e$var$animationStyles
    ] : [
        $f64c374ed616824e$var$outerContainerStyles
    ];
    const glowStyles = customGlowStyles ? [
        $f64c374ed616824e$var$baseGlowStyles,
        customGlowStyles
    ] : [
        $f64c374ed616824e$var$baseGlowStyles
    ];
    const borderRadiusStyles = useModalStyles ? $f64c374ed616824e$var$modalBorderRadiusStyles : $f64c374ed616824e$var$defaultBorderRadiusStyles;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f64c374ed616824e$var$GradientPropertyContainer, {
        "data-testid": "ai-border-container",
        ...props
    }, shouldRotate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            ...containerStyles,
            borderRadiusStyles,
            ...hideGlow ? [] : glowStyles
        ],
        testId: "loading-glow"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            ...containerStyles,
            borderRadiusStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        padding: "space.025",
        xcss: [
            $f64c374ed616824e$var$innerContainerStyles,
            borderRadiusStyles,
            customInnerContainerStyles
        ]
    }, children)));
};
module.exports["AIBorder"] = $f64c374ed616824e$export$6ed1e39f4dbe0bbf;

});

parcelRegister("fqANv", function(module, exports) {
/**
 * Use for any CSS based motion (animation or transition).
 * Always put at the end of your declaration for correct use of the cascade.
 * Reduced motion preference is generally set through OS preferences/settings.
 *
 * @deprecated This is not fully compatible with Compiled CSS and will be removed in the future.
 * You should hardcode the `prefers-reduced-motion` media query in your file instead.
 */ const $7ebe4f6aaaab63a6$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
module.exports["reduceMotionAsPerUserPreference"] = $7ebe4f6aaaab63a6$export$f0f789643ba5a83c;

});

parcelRegister("kfIha", function(module, exports) {
const $3551cf4db632cbd5$var$isClipboardApiSupported = ()=>Boolean(navigator.clipboard && typeof navigator.clipboard.writeText === 'function');
const $3551cf4db632cbd5$export$b2199c37e85de4a7 = ()=>{
    const copyToClipboard = async (value)=>{
        if (value && $3551cf4db632cbd5$var$isClipboardApiSupported()) await navigator.clipboard.writeText(value);
    };
    return {
        copyToClipboard: copyToClipboard
    };
};
module.exports["useCopyToClipboard"] = $3551cf4db632cbd5$export$b2199c37e85de4a7;

});

parcelRegister("dchHi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $bQm3c = parcelRequire("bQm3c");

const $e12d220a6c6e853e$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
const $e12d220a6c6e853e$export$5b0d1a23cf38988 = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $e12d220a6c6e853e$export$eecedbc46bd36460 = ({ children: children, entrypointId: entrypointId, locale: locale, feedbackContextId: feedbackContextId = $e12d220a6c6e853e$var$FEEDBACK_CONTEXT_CF, feedbackContext: feedbackContext = {}, userId: userId, displayName: displayName })=>{
    const { displayName: sessionDisplayName, userId: sessionUserId } = (0, $bQm3c.useSessionData)();
    const { locale: intlLocale } = (0, $aXWIB.useIntl)();
    const feedbackContextString = Object.entries(feedbackContext).map(([key, value])=>`${key}: ${JSON.stringify(value)}`).join(' ');
    const contextValue = (0, $42omo.useMemo)(()=>({
            entrypointId: entrypointId,
            feedbackContextId: feedbackContextId,
            feedbackContext: feedbackContextString,
            locale: locale || intlLocale,
            userId: userId || sessionUserId || undefined,
            displayName: displayName || sessionDisplayName || undefined
        }), [
        entrypointId,
        feedbackContextId,
        feedbackContextString,
        locale,
        intlLocale,
        userId,
        sessionUserId,
        displayName,
        sessionDisplayName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e12d220a6c6e853e$export$5b0d1a23cf38988.Provider, {
        value: contextValue
    }, children);
};
const $e12d220a6c6e853e$export$e8f7cf9dc2b23528 = ()=>{
    const context = (0, $42omo.useContext)($e12d220a6c6e853e$export$5b0d1a23cf38988);
    if (context === undefined) throw new Error('useFeedbackCollectorProperties must be used within a FeedbackCollectorPropertiesProvider');
    return context;
};
module.exports["FeedbackCollectorPropertiesProvider"] = $e12d220a6c6e853e$export$eecedbc46bd36460;
module.exports["useFeedbackCollectorProperties"] = $e12d220a6c6e853e$export$e8f7cf9dc2b23528;

});

parcelRegister("JCGnt", function(module, exports) {

var $6vgLy = parcelRequire("6vgLy");


var $f7MuR = parcelRequire("f7MuR");

const $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
const $affa2edf03b5b535$export$750d18e9348a361a = ({ activeDaysThreshold: activeDaysThreshold = 28, activeUserCutoffDate: activeUserCutoffDate }, skip = false)=>{
    const { data: data, loading: loading, error: error } = (0, $f7MuR.useSiteUserTraits)({
        skipBootstrap: skip
    });
    const confluenceFirstActive = data?.attributes?.find(({ name: name })=>name === $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const firstActiveDate = confluenceFirstActive ? new Date(confluenceFirstActive) : null;
    const { isNewlyCreatedUser: isNewlyCreatedUser } = (0, $6vgLy.useShouldExcludeUser)({
        checkDate: firstActiveDate,
        daysThreshold: activeDaysThreshold,
        cutoffDate: activeUserCutoffDate
    });
    if (loading) return {
        isNewUser: null,
        loading: true
    };
    if (error) return {
        isNewUser: null,
        error: error
    };
    return {
        isNewUser: isNewlyCreatedUser,
        loading: false,
        error: null
    };
};
module.exports["useIsNewUser"] = $affa2edf03b5b535$export$750d18e9348a361a;

});

parcelRegister("6vgLy", function(module, exports) {

var $922yL = parcelRequire("922yL");

var $e0SBo = parcelRequire("e0SBo");

var $cFEpk = parcelRequire("cFEpk");

const $859f2d1feb92d345$export$30b189c21f25ee23 = ({ checkDate: checkDate, daysThreshold: daysThreshold = 14, cutoffDate: cutoffDate })=>{
    // If there is no check date, we cannot determine if user is new
    if (!checkDate) return {
        shouldExclude: true,
        isNewlyCreatedUser: null,
        isNewUserAfterCutoffDate: false
    };
    const isNewlyCreatedUser = (0, $e0SBo.default)((0, $922yL.default)(checkDate, daysThreshold), new Date());
    // Check if user is a new user (date is AFTER the cutoff date)
    // These users don't need changeboarding since it's all new to them
    const isNewUserAfterCutoffDate = cutoffDate && (0, $cFEpk.default)(cutoffDate) ? (0, $e0SBo.default)(checkDate, cutoffDate) : false;
    const shouldExclude = isNewlyCreatedUser || isNewUserAfterCutoffDate;
    return {
        shouldExclude: shouldExclude,
        isNewlyCreatedUser: isNewlyCreatedUser,
        isNewUserAfterCutoffDate: isNewUserAfterCutoffDate
    };
};
module.exports["useShouldExcludeUser"] = $859f2d1feb92d345$export$30b189c21f25ee23;

});

parcelRegister("ai7NK", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $30dd91193859fc54$export$4f97fa3245bb0e31 = {
    isSidePanelOpen: false
};
const $30dd91193859fc54$export$e324594224ef24da = {
    showSidePanel: ()=>({ setState: setState })=>{
            setState({
                isSidePanelOpen: true
            });
        },
    hideSidePanel: ()=>({ setState: setState })=>{
            setState({
                isSidePanelOpen: false
            });
        }
};
const $30dd91193859fc54$var$Store = (0, $1P1Tu.createStore)({
    initialState: $30dd91193859fc54$export$4f97fa3245bb0e31,
    actions: $30dd91193859fc54$export$e324594224ef24da,
    name: 'SidePanelState'
});
const $30dd91193859fc54$export$d4bcf572fecd48f5 = (0, $9zUhf.createActionsHook)($30dd91193859fc54$var$Store);
const $30dd91193859fc54$export$f3f6191f6fee6235 = (0, $9zUhf.createStateHook)($30dd91193859fc54$var$Store, {
    selector: (state)=>state.isSidePanelOpen
});
module.exports["useSidePanelStateActions"] = $30dd91193859fc54$export$d4bcf572fecd48f5;
module.exports["useIsSidePanelOpen"] = $30dd91193859fc54$export$f3f6191f6fee6235;

});

parcelRegister("4GDP8", function(module, exports) {
function $d27310b4a47ce627$var$keepTrying(fn, times, interval) {
    if (!fn() && times) setTimeout(()=>$d27310b4a47ce627$var$keepTrying(fn, times - 1, interval), interval);
}
function $d27310b4a47ce627$var$waitForDom(itemId) {
    return new Promise((resolve)=>{
        function lookForItem() {
            const targetItem = document.querySelector(itemId);
            if (targetItem) {
                clearInterval(checkInterval);
                resolve(true);
            }
        }
        // Start an interval to check for the item every 10ms
        const checkInterval = setInterval(lookForItem, 10);
        // Fail silently if the item isn't found after 5000ms
        setTimeout(()=>{
            clearInterval(checkInterval);
            resolve(false);
        }, 5000);
    });
}
function $d27310b4a47ce627$var$isForgeModule(itemId) {
    return itemId.startsWith('ari:cloud:ecosystem::extension');
}
function $d27310b4a47ce627$var$escapeForgeModuleKey(itemId) {
    return itemId.replace(/\//g, '\\/').replace(/:/g, '\\:');
}
function $d27310b4a47ce627$var$getItemSelector(itemId) {
    if (!itemId || !itemId.length) return;
    let itemSelector = itemId[0] === '#' ? itemId : `#${itemId}`;
    if ($d27310b4a47ce627$var$isForgeModule(itemId)) itemSelector = $d27310b4a47ce627$var$escapeForgeModuleKey(itemSelector);
    return itemSelector;
}
async function $d27310b4a47ce627$export$6bd4cdcdf3940391({ parentmenuId: parentmenuId, submenuId: submenuId, forgeItemId: forgeItemId }) {
    // Make sure the forge item has a valid id
    const forgeItemSelector = $d27310b4a47ce627$var$getItemSelector(forgeItemId);
    if (!forgeItemSelector) return;
    $d27310b4a47ce627$var$openMenu(parentmenuId);
    const foundSubmenu = await $d27310b4a47ce627$var$waitForDom(submenuId);
    if (!foundSubmenu) return;
    $d27310b4a47ce627$var$openMenu(submenuId);
    const foundForgeItem = await $d27310b4a47ce627$var$waitForDom(forgeItemSelector);
    if (!foundForgeItem) return;
    const forgeItem = document.querySelector(forgeItemSelector);
    forgeItem?.click();
}
function $d27310b4a47ce627$var$openMenu(menuId) {
    const triggerButton = document.querySelector(menuId);
    if (!triggerButton) return;
    const isOpen = triggerButton.getAttribute('aria-expanded') === 'true';
    //only care about closed case, otherwise let legacy event listener handle
    if (!isOpen) triggerButton.click();
}
function $d27310b4a47ce627$export$73ebde48694f32cd(itemId) {
    const itemSelector = $d27310b4a47ce627$var$getItemSelector(itemId);
    if (!itemSelector) return;
    $d27310b4a47ce627$var$keepTrying(()=>{
        const item = document.querySelector(itemSelector);
        if (item) {
            item.click();
            return true;
        }
    }, 100, 5);
}
function $d27310b4a47ce627$export$96aa6f6c7286ecb4(itemId) {
    const itemSelector = $d27310b4a47ce627$var$getItemSelector(itemId);
    if (!itemSelector) return;
    const event = new MouseEvent('mouseup', {
        bubbles: true,
        cancelable: true
    });
    document.querySelector(itemSelector)?.dispatchEvent(event);
}
function $d27310b4a47ce627$export$1d6f959e29b7f60d() {
    $d27310b4a47ce627$var$openMenu('#tools-menu-trigger');
}
function $d27310b4a47ce627$export$3d4ff948da3c7dd3() {
    $d27310b4a47ce627$var$openMenu('#context-menu-other-apps');
}
function $d27310b4a47ce627$export$94323a98da3bb62c() {
    $d27310b4a47ce627$var$openMenu('#more-actions-trigger');
}
module.exports["openForgeAppFromSubmenu"] = $d27310b4a47ce627$export$6bd4cdcdf3940391;
module.exports["simulateItemClick"] = $d27310b4a47ce627$export$73ebde48694f32cd;
module.exports["simulateItemMouseOver"] = $d27310b4a47ce627$export$96aa6f6c7286ecb4;
module.exports["openMenuClick"] = $d27310b4a47ce627$export$1d6f959e29b7f60d;
module.exports["openContextMenuClick"] = $d27310b4a47ce627$export$3d4ff948da3c7dd3;
module.exports["openMoreActionsMenuClick"] = $d27310b4a47ce627$export$94323a98da3bb62c;

});

parcelRegister("bAyaS", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $8eabddf4fe78ba91$var$initialState = {
    showCreateSpaceDrawer: false,
    shouldRenderDrawer: false,
    createSpaceButtonRef: {
        current: null
    },
    createSpaceButtonLocation: undefined
};
const $8eabddf4fe78ba91$export$e324594224ef24da = {
    openDrawer: (value, createSpaceButtonLocation)=>({ setState: setState })=>{
            setState({
                showCreateSpaceDrawer: true,
                shouldRenderDrawer: true,
                createSpaceButtonRef: value,
                createSpaceButtonLocation: createSpaceButtonLocation
            });
        },
    closeDrawer: ()=>({ setState: setState })=>{
            setState({
                showCreateSpaceDrawer: false,
                createSpaceButtonLocation: undefined
            });
        }
};
const $8eabddf4fe78ba91$export$390f32400eaf98c9 = (0, $1P1Tu.createStore)({
    initialState: $8eabddf4fe78ba91$var$initialState,
    actions: $8eabddf4fe78ba91$export$e324594224ef24da,
    name: 'createSpaceStore'
});
const $8eabddf4fe78ba91$export$5642c413017336a4 = (0, $9zUhf.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9);
const $8eabddf4fe78ba91$var$getShouldRenderDrawer = (state)=>{
    return state.shouldRenderDrawer;
};
const $8eabddf4fe78ba91$export$34596812152477bc = (0, $9zUhf.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9, {
    selector: $8eabddf4fe78ba91$var$getShouldRenderDrawer
});
const $8eabddf4fe78ba91$var$getIsCreateSpaceDrawerShowing = (state)=>{
    return state.showCreateSpaceDrawer;
};
const $8eabddf4fe78ba91$export$5ff6e7335b182a8e = (0, $9zUhf.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9, {
    selector: $8eabddf4fe78ba91$var$getIsCreateSpaceDrawerShowing
});
const $8eabddf4fe78ba91$export$ad3d638eaaafd693 = (0, $9zUhf.createActionsHook)($8eabddf4fe78ba91$export$390f32400eaf98c9);
module.exports["useCreateSpaceStore"] = $8eabddf4fe78ba91$export$5642c413017336a4;
module.exports["useShouldRenderDrawer"] = $8eabddf4fe78ba91$export$34596812152477bc;
module.exports["useCreateSpaceStoreActions"] = $8eabddf4fe78ba91$export$ad3d638eaaafd693;

});

parcelRegister("i1vUz", function(module, exports) {

var $4qmCZ = parcelRequire("4qmCZ");


var $8SLNj = parcelRequire("8SLNj");


var $8G3G6 = parcelRequire("8G3G6");


var $8uM2K = parcelRequire("8uM2K");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $h2uld = parcelRequire("h2uld");

const $649e6d4fa880ffb0$var$useDynamicSplitButtonCatchupLastViewedTimeQuery = (0, $8G3G6.default);
const $649e6d4fa880ffb0$var$useDynamicSplitButtonContentHistoryQuery = (0, $8SLNj.default);
const $649e6d4fa880ffb0$export$ca7c63318c849d7a = (contentId, contentType, isRefreshRovoButton = false)=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, userId: userId } = (0, $bQm3c.useSessionData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { readTime: readTime, loading: readTimeLoading } = (0, $h2uld.useReadTime)(contentId, !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT);
    const { data: data, loading: catchupLastViewedLoading, error: queryError } = (0, $jMyy4.useQueryInterop)($649e6d4fa880ffb0$var$useDynamicSplitButtonCatchupLastViewedTimeQuery, {
        variables: {
            contentId: contentId,
            contentType: contentType
        },
        skip: !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT,
        __callerPackage__: "@confluence/ai-floating-context-menu"
    });
    const { data: lastModifiedDateData, loading: lastModifiedLoading } = (0, $jMyy4.useQueryInterop)((0, $4qmCZ.default), {
        variables: {
            contentId: contentId
        },
        skip: !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT,
        __callerPackage__: "@confluence/ai-floating-context-menu"
    });
    const { data: contentHistoryData, loading: contentHistoryLoading } = (0, $jMyy4.useQueryInterop)($649e6d4fa880ffb0$var$useDynamicSplitButtonContentHistoryQuery, {
        variables: {
            contentId: contentId
        },
        skip: !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT || !isRovoButtonEnabled,
        fetchPolicy: 'network-only',
        __callerPackage__: "@confluence/ai-floating-context-menu"
    });
    const lastModifiedDate = lastModifiedDateData?.content?.nodes?.[0]?.metadata?.lastModifiedDate ?? '';
    const lastViewedTime = data?.catchupGetLastViewedTime?.lastViewedTimeISO ?? '';
    // Guard against cases where lastViewedTime would otherwise cause a NaN parse result
    const cleanedLastViewedTime = lastViewedTime.replace(/\[.*?\]$/, '');
    const parsedLastViewedTime = Date.parse(cleanedLastViewedTime);
    const parsedLastModifiedDate = Date.parse(lastModifiedDate);
    const lastEditedCollaborators = contentHistoryData?.contentHistory?.nodes?.[0]?.collaborators?.userAccountIds ?? [];
    const isCurrentUserARecentCollaborator = lastEditedCollaborators.some((collaborator)=>collaborator === userId);
    const isFirstTimeVisit = Number.isNaN(parsedLastViewedTime);
    const lastViewedDate = isFirstTimeVisit ? undefined : new Date(parsedLastViewedTime);
    const queryLoading = catchupLastViewedLoading || lastModifiedLoading || contentHistoryLoading || readTimeLoading;
    let showCatchupAsDefault = false;
    let showSummarizeAsDefault = true;
    if (!parsedLastViewedTime && !isFirstTimeVisit || !parsedLastModifiedDate || queryError) return {
        showCatchupAsDefault: showCatchupAsDefault,
        queryLoading: queryLoading,
        queryError: queryError
    };
    if (isRovoButtonEnabled && pageMode !== (0, $cD1qu.PageMode).EDIT && !queryLoading && isFirstTimeVisit && readTime && readTime >= 5 && !isCurrentUserARecentCollaborator) {
        if (isRefreshRovoButton) return {
            showCatchupAsDefault: showCatchupAsDefault,
            showSummarizeAsDefault: showSummarizeAsDefault,
            queryLoading: queryLoading
        };
    }
    showCatchupAsDefault = pageMode !== (0, $cD1qu.PageMode).EDIT && !queryLoading && parsedLastModifiedDate > parsedLastViewedTime && !isCurrentUserARecentCollaborator;
    showSummarizeAsDefault = false;
    return {
        showCatchupAsDefault: showCatchupAsDefault,
        showSummarizeAsDefault: showSummarizeAsDefault,
        queryLoading: queryLoading,
        lastViewedDate: lastViewedDate
    };
};
module.exports["useDynamicSplitButton"] = $649e6d4fa880ffb0$export$ca7c63318c849d7a;

});

parcelRegister("4qmCZ", function(module, exports) {
/**
 * @generated SignedSource<<b18880c95a88e91ee675a5ab3e7a2f6a>>
 * @relayHash 53828d84c0acb319d0f0762fbd51cfb9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3782297928019afae38deeb994658b9d2bfb75b3dd67df3051fac91d5ebf0e37
const $3f3bb2f2b7df90db$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "lastModifiedDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useDynamicSplitButtonLastModifiedDateQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useDynamicSplitButtonLastModifiedDateQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "53828d84c0acb319d0f0762fbd51cfb9",
            "id": "3782297928019afae38deeb994658b9d2bfb75b3dd67df3051fac91d5ebf0e37",
            "metadata": {},
            "name": "useDynamicSplitButtonLastModifiedDateQuery",
            "operationKind": "query",
            "text": "query useDynamicSplitButtonLastModifiedDateQuery($contentId:ID!){content(id:$contentId){nodes{id,metadata{lastModifiedDate}}}}"
        }
    };
}();
$3f3bb2f2b7df90db$var$node.hash = "cb78a829ad38a06c36dc9615c22411b7";
var $3f3bb2f2b7df90db$export$2e2bcd8739ae039 = $3f3bb2f2b7df90db$var$node;
module.exports["default"] = $3f3bb2f2b7df90db$export$2e2bcd8739ae039;

});

parcelRegister("8SLNj", function(module, exports) {
/**
 * @generated SignedSource<<6135257c8df94a440f547d327ee53e8c>>
 * @relayHash c82cedffd514ace9062cc5a7ea29b433
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7dd5a60846b03a6eacef04466d72dec90722d2cae751b0c9b97f555a408d7190
const $a7452eae54a23656$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                }
            ],
            "concreteType": "PaginatedContentHistoryList",
            "kind": "LinkedField",
            "name": "contentHistory",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ContentHistory",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "ContributorUsers",
                            "kind": "LinkedField",
                            "name": "collaborators",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "userAccountIds"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useDynamicSplitButtonContentHistoryQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useDynamicSplitButtonContentHistoryQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c82cedffd514ace9062cc5a7ea29b433",
            "id": "7dd5a60846b03a6eacef04466d72dec90722d2cae751b0c9b97f555a408d7190",
            "metadata": {},
            "name": "useDynamicSplitButtonContentHistoryQuery",
            "operationKind": "query",
            "text": "query useDynamicSplitButtonContentHistoryQuery($contentId:ID!){contentHistory(contentId:$contentId,first:1){nodes{collaborators{userAccountIds}}}}"
        }
    };
}();
$a7452eae54a23656$var$node.hash = "428e55c833e4f9ecc04af6435214d702";
var $a7452eae54a23656$export$2e2bcd8739ae039 = $a7452eae54a23656$var$node;
module.exports["default"] = $a7452eae54a23656$export$2e2bcd8739ae039;

});

parcelRegister("auLW1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $b253f08be2669ace$export$c463287b61deee24 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "wRZLE",
    name: "PageCatchupComponent",
    loader: async ()=>(await (parcelRequire("5iSlq"))).PageCatchupComponentWithErrorBoundary
});
module.exports["PageCatchupComponent"] = $b253f08be2669ace$export$c463287b61deee24;

});

parcelRegister("5iSlq", function(module, exports) {

let $3dc8c9e183b62587$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3dc8c9e183b62587$var$load("kNNS3"),
    $3dc8c9e183b62587$var$load("3ezts"),
    $3dc8c9e183b62587$var$load("cmqxT"),
    $3dc8c9e183b62587$var$load("7EorR"),
    $3dc8c9e183b62587$var$load("hhss7"),
    $3dc8c9e183b62587$var$load("eN6nL")
]).then(()=>parcelRequire('4RbVT'));

});

parcelRegister("afBrg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::28e818db41afcf6fce742cecb9d4361e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $776858abadb4b212$var$_react = $776858abadb4b212$var$_interopRequireDefault((parcelRequire("42omo")));

var $776858abadb4b212$var$_baseNew = $776858abadb4b212$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $776858abadb4b212$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeAudioBriefing".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Audio Briefings, a new feature launching within Confluence to help people develop an expanded awareness on a topic by generating AI-powered podcasts about their work.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $776858abadb4b212$var$AiGenerativeAudioBriefingIcon = (props)=>/*#__PURE__*/ $776858abadb4b212$var$_react.default.createElement($776858abadb4b212$var$_baseNew.default, Object.assign({
        name: "AiGenerativeAudioBriefingIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0c.97 0 1.88.2 2.72.55l-.24.09c-.52.19-.93.56-1.19 1.02A5.5 5.5 0 0 0 2.5 7v.71A2.5 2.5 0 0 1 6 10v3.08A1.92 1.92 0 0 1 4.08 15 3.08 3.08 0 0 1 1 12V7a7 7 0 0 1 7-7M3.5 9a1 1 0 0 0-1 1v1.92c0 .87.71 1.58 1.58 1.58.23 0 .42-.19.42-.42V10a1 1 0 0 0-1-1m11.46-2.78Q15 6.6 15 7v5a3.08 3.08 0 0 1-3.08 3A1.92 1.92 0 0 1 10 13.08V10a2.5 2.5 0 0 1 3.5-2.29v-.73a2.25 2.25 0 0 0 1.46-.77M12.5 9a1 1 0 0 0-1 1v3.08c0 .23.19.42.42.42.87 0 1.58-.71 1.58-1.58V10a1 1 0 0 0-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M13.365.009a.75.75 0 0 1 .541.378l.05.106.334.92a.5.5 0 0 0 .298.297l.919.335a.75.75 0 0 1 0 1.41l-.92.335a.5.5 0 0 0-.297.298l-.335.919a.75.75 0 0 1-1.41 0l-.335-.92a.5.5 0 0 0-.298-.297l-.919-.335a.75.75 0 0 1-.484-.589L10.5 2.75l.009-.116a.75.75 0 0 1 .484-.59l.92-.334a.5.5 0 0 0 .297-.298l.335-.919A.75.75 0 0 1 13.249 0z"/>`
    }, props));
$776858abadb4b212$var$AiGenerativeAudioBriefingIcon.displayName = 'AiGenerativeAudioBriefingIcon';
var $776858abadb4b212$var$_default = module.exports.default = $776858abadb4b212$var$AiGenerativeAudioBriefingIcon;

});

parcelRegister("1I9Gw", function(module, exports) {
const $f0a04d35c062874d$export$1598149f6f3f7d46 = (spaceKey)=>{
    return spaceKey?.[0] === '~';
};
module.exports["isPersonalSpace"] = $f0a04d35c062874d$export$1598149f6f3f7d46;

});

parcelRegister("NomII", function(module, exports) {
/* CustomPopupContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $eyWa4 = parcelRequire("eyWa4");


var $bmowW = parcelRequire("bmowW");

const $7ecedb5cea5467d4$var$PopupWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1mok _16qs130s _1pbykb7n _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ])
    });
});
const $7ecedb5cea5467d4$export$2db9b01e44994880 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, ...props }, ref)=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7ecedb5cea5467d4$var$PopupWrapper, {
        ...props,
        ref: ref,
        role: "dialog",
        "aria-label": intl.formatMessage((0, $bmowW.i18n).quickSummaryLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.150"
    }, children));
});
module.exports["CustomPopupContainer"] = $7ecedb5cea5467d4$export$2db9b01e44994880;

});

parcelRegister("bmowW", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");


var $jhwJP = parcelRequire("jhwJP");

const $c2de17ff654b3217$var$i18nBase = (0, $aXWIB.defineMessages)({
    quickSummaryLabel: {
        id: "quick-summary.label.text",
        defaultMessage: "Quick summary"
    },
    quickSummaryToolTipText: {
        id: "quick-summary.tooltip.text",
        defaultMessage: "Summarize"
    },
    quickSummaryFeatureSpotlightText: {
        id: "quick-summary.feature-spotlight-one.text",
        defaultMessage: "This might be a longer read. Save time and read a quick summary from Atlassian Intelligence."
    },
    quickSummarySpotlightSummarizeText: {
        id: "quick-summary.spotlight.summarize.button.text",
        defaultMessage: "Summarize"
    },
    quickSummarySpotlightCloseButtonText: {
        id: "quick-summary.spotlight.close.button.text",
        defaultMessage: "Dismiss"
    },
    quickSummaryOptInDialogHeaderText: {
        id: "quick-summary.opt-in.dialog.header.text",
        defaultMessage: "Work smarter, not harder"
    },
    quickSummaryOptInDialogBodyText: {
        id: "quick-summary.opt-in.dialog.body.text",
        defaultMessage: "Save time by reading an Al-generated summary instead of an entire page or blog with <a>Atlassian Intelligence</a>. <br></br><br></br> Interested in trying Atlassian Intelligence? Your admin can activate AI features from Atlassian Administration."
    },
    quickSummaryAdminOptInDialogBodyText: {
        id: "quick-summary.admin.opt-in.dialog.body.text",
        defaultMessage: "Save your team time by reading an Al-generated summary instead of an entire page with <a>Atlassian Intelligence</a>. <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration."
    }
});
const $c2de17ff654b3217$var$i18nLiveDocs = (0, $aXWIB.defineMessages)({
    quickSummaryOptInDialogBodyText: {
        id: "quick-summary.opt-in.dialog.body.text.livedocs",
        defaultMessage: "Save time by reading an Al-generated summary instead of an entire page, live doc, or blog with <a>Atlassian Intelligence</a>. <br></br><br></br> Interested in trying Atlassian Intelligence? Your admin can activate AI features from Atlassian Administration."
    },
    quickSummaryAdminOptInDialogBodyText: {
        id: "quick-summary.admin.opt-in.dialog.body.text.livedocs",
        defaultMessage: "Save your team time by reading an Al-generated summary instead of an entire page or live doc with <a>Atlassian Intelligence</a>. <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration."
    }
});
const $c2de17ff654b3217$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($c2de17ff654b3217$var$i18nBase, $c2de17ff654b3217$var$i18nLiveDocs);
module.exports["i18n"] = $c2de17ff654b3217$export$a7357cdd1f0b0168;

});

parcelRegister("c8mrj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aUTn5 = parcelRequire("aUTn5");


var $hq2Sz = parcelRequire("hq2Sz");


var $1mDVg = parcelRequire("1mDVg");


var $1Q0l6 = parcelRequire("1Q0l6");


var $UNr39 = parcelRequire("UNr39");


var $jln20 = parcelRequire("jln20");


var $cAdj8 = parcelRequire("cAdj8");

const $c8e282bfad3727e4$export$ddc739fc0aea988a = ({ contentId: contentId, content: content, useRovoWidth: useRovoWidth = false })=>{
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const setIsCreatedWithAi = (0, $hq2Sz.useSetIsCreatedWithAi)();
    const setIsCreatedFromTable = (0, $hq2Sz.useSetIsCreatedFromTable)();
    const setIsRovoPanelWidth = (0, $hq2Sz.useSetIsRovoPanelWidth)();
    const setInsertStorageFragmentRequestPayload = (0, $hq2Sz.useSetInsertStorageFragmentRequestPayload)();
    const contentLastModifiedTimestamp = (0, $hq2Sz.useGetContentLastModifiedTimestamp)();
    // eslint-disable-next-line confluence-sweet-state/sweet-state-prefer-actions-hook
    const [, issueCreateSidePanelActions] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const { pageInfo: pageInfo } = (0, $cAdj8.usePageInfo)({
        fetchPolicy: 'cache-first'
    });
    const hasEditPermission = (0, $42omo.useMemo)(()=>pageInfo?.operations?.some((op)=>op?.operation === 'update' && op?.targetType === pageInfo.type) || false, [
        pageInfo
    ]);
    return (0, $42omo.useCallback)(()=>{
        setIsCreatedWithAi(true);
        setIsCreatedFromTable(false);
        setIsRovoPanelWidth(useRovoWidth);
        if (content.current) {
            const range = (0, $1Q0l6.getValidRange)((0, $1Q0l6.getPageContentRange)());
            const payload = (0, $1Q0l6.constructInsertStorageFragmentRequestPayload)(contentId, (0, $aUTn5.convertSelectionToLegacyFormat), range, content.current, contentLastModifiedTimestamp);
            setInsertStorageFragmentRequestPayload(payload);
        }
        issueCreateSidePanelActions.setHasEditPermission(hasEditPermission);
        rightSidebarContext.open((0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_ID), useRovoWidth ? (0, $UNr39.ROVO_BULK_CREATE_SIDE_PANEL_WIDTH) : (0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_WIDTH));
    }, [
        setIsCreatedWithAi,
        setIsCreatedFromTable,
        setIsRovoPanelWidth,
        useRovoWidth,
        contentId,
        content,
        contentLastModifiedTimestamp,
        setInsertStorageFragmentRequestPayload,
        issueCreateSidePanelActions,
        hasEditPermission,
        rightSidebarContext
    ]);
};
module.exports["useBulkIssueCreate"] = $c8e282bfad3727e4$export$ddc739fc0aea988a;

});

parcelRegister("eN3MW", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $bee98af9586f2941$export$e6e415a985158eb3 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "EZkxH",
    name: "QuickSummaryStreamingComponent",
    loader: async ()=>(await (parcelRequire("ljxR5"))).QuickSummaryStreamingEntryPoint
});
module.exports["QuickSummaryStreamingComponent"] = $bee98af9586f2941$export$e6e415a985158eb3;

});

parcelRegister("ljxR5", function(module, exports) {

let $f845a249394eebf9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f845a249394eebf9$var$load("kNNS3"),
    $f845a249394eebf9$var$load("hcY7w"),
    $f845a249394eebf9$var$load("6wr18"),
    $f845a249394eebf9$var$load("i3R6S"),
    $f845a249394eebf9$var$load("hhss7"),
    $f845a249394eebf9$var$load("kUbT8"),
    $f845a249394eebf9$var$load("ffEVr"),
    $f845a249394eebf9$var$load("jrchu")
]).then(()=>parcelRequire('9zqwo'));

});

parcelRegister("brrvF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1ytiN = parcelRequire("1ytiN");


var $42MJM = parcelRequire("42MJM");


var $fykBu = parcelRequire("fykBu");


var $7bACx = parcelRequire("7bACx");

const $a68160926e693700$var$i18n = (0, $aXWIB.defineMessages)({
    headerText: {
        id: "quick-summary.upsell.header.text",
        defaultMessage: "Improve productivity with Rovo"
    },
    headerTextAdmin: {
        id: "quick-summary.upsell.header.text.admin",
        defaultMessage: "Improve team productivity with Rovo"
    },
    learnMoreLinkTextUser: {
        id: "quick-summary.upsell.learn-more.link.text.user",
        defaultMessage: "Learn more about Rovo"
    },
    bodyTextAdmin: {
        id: "quick-summary.upsell.body.text.admin",
        defaultMessage: "Save time with page summaries, create and organize ideas efficiently, and get smarter, relevant search results you can act on. Upgrade to Premium"
    },
    bodyTextUser: {
        id: "quick-summary.upsell.body.text.user",
        defaultMessage: "Save time with page summaries, create and organize ideas efficiently, and get smarter, relevant search results you can act on. Try Rovo today"
    }
});
const $a68160926e693700$export$37172947b8f9cb48 = 'https://www.atlassian.com/software/rovo/guides/end-user-guide/introduction';
const $a68160926e693700$export$9f5718677d288e24 = 'https://www.atlassian.com/software/rovo/guides/admin-guide/introduction';
const $a68160926e693700$export$f552fbd4bef744fa = ()=>{
    const intl = (0, $aXWIB.useIntl)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const headerText = isSiteAdmin ? intl.formatMessage($a68160926e693700$var$i18n.headerTextAdmin) : intl.formatMessage($a68160926e693700$var$i18n.headerText);
    const bodyText = isSiteAdmin ? intl.formatMessage($a68160926e693700$var$i18n.bodyTextAdmin) : intl.formatMessage($a68160926e693700$var$i18n.bodyTextUser);
    const learnMoreLink = isSiteAdmin ? $a68160926e693700$export$9f5718677d288e24 : $a68160926e693700$export$37172947b8f9cb48;
    const learnMoreText = intl.formatMessage($a68160926e693700$var$i18n.learnMoreLinkTextUser);
    const learnMoreLinkProps = (0, $42omo.useMemo)(()=>({
            href: learnMoreLink,
            message: learnMoreText
        }), [
        learnMoreLink,
        learnMoreText
    ]);
    const imageProps = (0, $42omo.useMemo)(()=>({
            src: {
                default: (0, (/*@__PURE__*/$parcel$interopDefault($fykBu))),
                dark: (0, (/*@__PURE__*/$parcel$interopDefault($7bACx)))
            },
            alt: ''
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42MJM.AIUpsell), {
        title: headerText,
        body: bodyText,
        feature: "quickSummary",
        learnMoreLink: learnMoreLinkProps,
        image: imageProps
    });
};
module.exports["QuickSummaryUpsell"] = $a68160926e693700$export$f552fbd4bef744fa;

});

parcelRegister("fykBu", function(module, exports) {
module.exports = new URL("quickSummaryUpsellBannerLight.edcc3647.svg", import.meta.url).toString();

});

parcelRegister("7bACx", function(module, exports) {
module.exports = new URL("quickSummaryUpsellBannerDark.e27429f6.svg", import.meta.url).toString();

});

parcelRegister("9oezN", function(module, exports) {

const $6b7b6fc399a60c96$export$47e445a2288f991 = async ({ resetAfter: resetAfter = 3000 } = {})=>{
    let confetti = null;
    try {
        confetti = (await (parcelRequire("6u9JG"))).default;
    } catch (error) {
        return;
    }
    if (!confetti) return;
    // mirrors the confetti animation in Atlas
    const baseProps = {
        particleCount: 120,
        spread: 55,
        ticks: 225,
        zIndex: 2000,
        scalar: 1.5,
        startVelocity: 100,
        colors: [
            '#6554C0',
            '#0065FF',
            '#00B8D9',
            '#FF5630',
            '#FFAB00',
            '#36B37E'
        ]
    };
    // right corner
    confetti({
        ...baseProps,
        origin: {
            x: 1,
            y: 1
        },
        angle: 120
    });
    // left corner
    confetti({
        ...baseProps,
        origin: {
            x: 0,
            y: 1
        },
        angle: 60
    });
    if (resetAfter) setTimeout(()=>{
        confetti?.reset();
    }, resetAfter);
};
module.exports["popOnboardingConfetti"] = $6b7b6fc399a60c96$export$47e445a2288f991;

});

parcelRegister("6u9JG", function(module, exports) {

let $4b8d18bab8f60514$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4b8d18bab8f60514$var$load("aglhs").then(()=>parcelRequire('g3Ror'));

});

parcelRegister("AL4QS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aeea3452b156c1a88293b0f0d28d725d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $06e7e17859e1d884$var$_react = $06e7e17859e1d884$var$_interopRequireDefault((parcelRequire("42omo")));

var $06e7e17859e1d884$var$_baseNew = $06e7e17859e1d884$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $06e7e17859e1d884$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GenerativeIndicator".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for indicating generative and suggested content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $06e7e17859e1d884$var$GenerativeIndicatorIcon = (props)=>/*#__PURE__*/ $06e7e17859e1d884$var$_react.default.createElement($06e7e17859e1d884$var$_baseNew.default, Object.assign({
        name: "GenerativeIndicatorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.117 1.009a.75.75 0 0 1 .588.484l1.55 4.251 4.252 1.55A.75.75 0 0 1 15 8v.002a.75.75 0 0 1-.493.704l-4.252 1.55-1.55 4.252a.75.75 0 0 1-.704.493h-.002a.75.75 0 0 1-.704-.493l-1.55-4.252-4.252-1.55A.75.75 0 0 1 1 8.001v-.002a.75.75 0 0 1 .493-.704l4.251-1.55 1.55-4.252.049-.106A.75.75 0 0 1 7.999 1h.002z"/>`
    }, props));
$06e7e17859e1d884$var$GenerativeIndicatorIcon.displayName = 'GenerativeIndicatorIcon';
var $06e7e17859e1d884$var$_default = module.exports.default = $06e7e17859e1d884$var$GenerativeIndicatorIcon;

});


//# sourceMappingURL=ObjectSidebarControl.1d3d125f.js.map
